/** UI strings of the community market (merged into messages.ts). */
export const marketEs = {
  "nav.market": "Mercado",
  "mkt.set.err.hand": "Elegí al menos una zona donde entregás en mano.",
  "mkt.set.err.pickup": "Escribí la dirección del punto de retiro.",
  "mkt.set.err.arrange": "Para \"donde arreglemos\" marcá al menos un día con su horario.",
  "mkt.set.err.schedule": "Revisá los horarios: el \"hasta\" tiene que ser después del \"desde\".",
  "mkt.set.err.window": "Revisá el horario",
  "mkt.set.fromDay": "{day} desde",
  "mkt.set.toDay": "{day} hasta",
  "mkt.set.dayOff": "No",
  "mkt.set.copyHours": "Usar el horario del {day} en todos los días marcados",
  "mkt.status.confirmed": "Confirmado",
  "mkt.payHint.cash": "Pagás en efectivo cuando te entregan las cartas (solo en persona).",
  "mkt.set.schedule": "Días y horarios para entregar",
  "mkt.set.scheduleHint": "Marcá los días que podés encontrarte y el horario de cada uno. El comprador elige uno de esos días al comprar (en mano, retiro o donde arreglemos). Es obligatorio para \"donde arreglemos\".",
  "mkt.set.scheduleDays": "Días disponibles",
  "mkt.set.from": "Desde",
  "mkt.set.to": "Hasta",
  "mkt.set.cash": "Acepto efectivo contra entrega",
  "mkt.set.cashHint": "Solo para entregas en persona (en mano, retiro o a convenir). El pedido queda confirmado sin pago previo.",
  "mkt.set.minOrder": "Compra mínima (opcional, en pesos)",
  "mkt.set.minOrderNone": "Sin mínimo",
  "mkt.set.minOrderHint": "Las cartas de cada pedido tienen que sumar al menos este monto (sin contar el envío). Las ofertas que aceptás no lo necesitan. Vacío: sin mínimo.",
  "mkt.set.minOrderInvalid": "Poné un monto en pesos, sin centavos, o dejalo vacío.",
  "mkt.minOrder": "Compra mínima",
  "mkt.belowMinOrder": "Esta tienda vende desde {min} en cartas: te faltan {missing}.",
  "mkt.schedule": "Días y horarios",
  "mkt.meetingDay": "¿Qué día se encuentran?",
  "mkt.meetingWindow": "Entre las {from} y las {to} h. El lugar exacto lo arreglan por el chat.",
  "mkt.meetingLine": "{day}, entre las {from} y las {to} h",
  "mkt.cashInPerson": "El efectivo es solo para entregas en persona.",
  "mkt.newSellerSafePay": "Es un vendedor nuevo: las compras de más de {max} solo se pagan con Mercado Pago (tiene protección al comprador) o en efectivo al recibir las cartas en mano.",
  "mkt.newSeller": "Vendedor nuevo",
  "mkt.limitedSeller": "Solo efectivo en mano",
  "mkt.set.ownerPays": "Los datos de cobro (Mercado Pago, CBU o alias, billetera cripto) los carga el dueño de la tienda.",
  "sp.acting": "Estás editando @{handle} como admin. Los cambios quedan registrados.",
  "sp.actingExit": "Salir",
  "sp.actingLost": "No podés editar esta tienda desde el admin ahora (la soltaste, o tu sesión necesita el código de nuevo).",
  "mkt.activate.title": "Tu tienda está lista",
  "mkt.activate.body": "En pokefans.fun armamos tu tienda con tus publicaciones. Todavía nadie la ve: revisala y, cuando quieras, aceptá las reglas para publicarla.",
  "mkt.activate.keep": "Podemos seguir ayudándote a cargar cosas. Si preferís que no, escribinos y dejamos de hacerlo.",
  "mkt.activate.go": "Publicar mi tienda",
  "mkt.activate.error": "No se pudo publicar. Revisá los datos y probá de nuevo.",
  "mkt.set.limited": "Mientras tu tienda tenga límites, los compradores solo ven el efectivo y la entrega en mano. Lo demás que configures queda guardado para cuando se levanten.",
  "mkt.limitedBuyer": "Esta tienda solo vende en efectivo y con entrega en mano. Encontrate en un lugar público y con gente (un shopping, una estación, un café), revisá las cartas antes de pagar y no pagues nada por adelantado.",
  "mkt.limitedYou": "Tu tienda arrancó con límites: los compradores solo pueden pagarte en efectivo y recibir las cartas en mano. Se levantan solos con tus primeras {sales} ventas sin reclamos y {days} días como vendedor.",
  "mkt.limitedSetup": "Tu tienda arrancó con límites: solo se vende en efectivo y con entrega en mano. Activá los dos en Ajustes para que se vean tus publicaciones.",
  "mkt.newSellerYou": "Sos vendedor nuevo: en ventas de más de {max} los compradores solo pueden pagarte con Mercado Pago o en efectivo en mano. Esto dura tus primeros {days} días y hasta tus primeras {sales} ventas.",
  "mkt.newSellerConnectMp": "Conectá Mercado Pago para no perder ventas grandes.",
  "mkt.cashNote": "Pagás en efectivo cuando te entreguen las cartas. Revisalas antes de pagar.",
  "mkt.cashToPay": "A pagar en efectivo al recibir: {total}",
  "mkt.errMeeting": "Elegí uno de los días disponibles del vendedor.",
  "mkt.markHanded": "Entregado y cobrado",
  "mkt.markReceivedCash": "Recibí las cartas y pagué",
  "mkt.st.confirmedBuyer": "Pedido confirmado. Te mandamos los datos del vendedor por email: coordinen el encuentro y pagás al recibir.",
  "mkt.st.confirmedSeller": "Pedido confirmado: se cobra en efectivo al entregar. Te mandamos los datos del comprador por email.",
  "mkt.title": "Mercado de la comunidad",
  "mkt.titleSeller": "Cartas de @{seller}",
  "mkt.intro": "Cartas de otros fans. Le pagás directo al vendedor y coordinan la entrega por el chat del pedido. pokefans.fun no cobra comisión.",
  "mkt.results": "{count} publicaciones",
  "mkt.resultsCards": "{count} cartas",
  "mkt.f.category": "Categoría",
  "mkt.resultsCards_one": "1 carta",
  "mkt.fromPrice": "Desde {price}",
  "mkt.soldByMany": "La venden {count} vendedores",
  "mkt.allCards": "← Todas las cartas",
  "mkt.results_one": "1 publicación",
  "mkt.filters": "Filtros",
  "mkt.sort": "Ordenar",
  "mkt.view.label": "Vista",
  "mkt.view.cards": "Tarjetas",
  "mkt.view.list": "Lista",
  "mkt.view.listLabel": "Publicaciones",
  "mkt.sort.newest": "Más nuevas",
  "mkt.sort.price_asc": "Menor precio",
  "mkt.sort.price_desc": "Mayor precio",
  "mkt.sort.rating": "Mejor vendedor",
  "mkt.sellCta": "Quiero vender",
  "mkt.empty": "No hay publicaciones con esos filtros.",
  "mkt.emptyWant": "Avisame cuando aparezca",
  "mkt.f.search": "Buscar",
  "mkt.f.searchHint": "Carta, set, número o vendedor",
  "mkt.f.seller": "Vendedor",
  "mkt.f.condition": "Estado",
  "mkt.f.language": "Idioma",
  "mkt.f.finish": "Acabado",
  "mkt.f.graded": "Gradeada",
  "mkt.f.gradedYes": "Solo gradeadas",
  "mkt.f.gradedNo": "Sin gradear",
  "mkt.f.any": "Cualquiera",
  "mkt.f.min": "Desde $",
  "mkt.f.max": "Hasta $",
  "mkt.f.zone": "Entrega en mano en",
  "mkt.f.payment": "Medio de pago",
  "mkt.f.rating": "Calificación del vendedor",
  "mkt.f.ratingAtLeast": "{value}★ o más",
  "mkt.f.sales": "Ventas del vendedor",
  "mkt.f.salesAtLeast": "{count}+ ventas",
  "mkt.f.salesAtLeast_one": "Al menos 1 venta",
  "mkt.noReviews": "Sin reseñas",
  "mkt.starsLabel": "{value} de 5 estrellas, {count} reseñas",
  "mkt.starsShort": "{count} estrellas",
  "mkt.starsShort_one": "1 estrella",
  "mkt.salesCount": "{count} ventas",
  "mkt.salesCount_one": "1 venta",
  "mkt.available": "{count} disponibles",
  "mkt.available_one": "1 disponible",
  "mkt.report": "Denunciar",
  "mkt.reportTitle": "Denunciar",
  "mkt.reportReason": "¿Qué pasa?",
  "mkt.reportDetails": "Contanos más (opcional)",
  "mkt.reportSend": "Enviar denuncia",
  "mkt.reportSent": "Gracias. La vamos a revisar.",
  "mkt.reportOrder": "Denunciar este pedido",
  "mkt.copy": "Copiar",
  "mkt.copied": "¡Copiado!",
  "mkt.status.pending_payment": "Esperando el pago",
  "mkt.status.paid": "Pagado",
  "mkt.status.shipped": "Enviado",
  "mkt.status.completed": "Completado",
  "mkt.status.cancelled": "Cancelado",
  "mkt.status.disputed": "En revisión",
  "mkt.status.live": "Publicada",
  "mkt.status.soldout": "Sin stock",
  "mkt.status.draft": "Pausada",
  "mkt.status.offer_pending": "Esperando respuesta",
  "mkt.status.offer_countered": "Contraoferta",
  "mkt.status.offer_accepted": "Aceptada",
  "mkt.status.offer_rejected": "Rechazada",
  "mkt.status.offer_cancelled": "Retirada",
  "mkt.status.offer_expired": "Vencida",
  "mkt.status.offer_used": "Comprada",

  "mkt.breadcrumbs": "Ubicación",
  "mkt.listingNotFound": "Esta publicación ya no está disponible.",
  "mkt.photoN": "foto {n}",
  "mkt.catalogImageNote": "Imagen del catálogo. El vendedor no subió fotos de esta carta.",
  "mkt.catalogImageMore": "Imagen del catálogo. El vendedor subió {count} fotos de esta carta: mirá su estado en las miniaturas.",
  "mkt.catalogImageMore_one": "Imagen del catálogo. El vendedor subió 1 foto de esta carta: mirá su estado en la miniatura.",
  "mkt.catalogImage": "imagen del catálogo",
  "mkt.sellerPhoto": "foto del vendedor {n}",
  "mkt.sellerPhotoNote": "Foto del vendedor: es la carta que vas a recibir.",
  "mkt.photos.open": "Ver las {count} fotos del vendedor",
  "mkt.photos.open_one": "Ver la foto del vendedor",
  "mkt.photos.title": "Fotos del vendedor: {name}",
  "mkt.photos.listing": "Ver la publicación",
  "mkt.presaleNote": "Preventa: sale el {date}. Coordiná con el vendedor cuándo te lo entrega.",
  "mkt.presaleNoteNoDate": "Preventa: todavía no salió. Coordiná con el vendedor cuándo te lo entrega.",
  "mkt.reference": "Precio de referencia",
  "mkt.refStore": "En la tienda (por transferencia)",
  "mkt.refStoreOut": "La tienda no la tiene en stock ahora.",
  "mkt.refStoreLink": "Ver en la tienda",
  "mkt.refNoStore": "La tienda no la tiene a la venta.",
  "mkt.refMarket": "{count} publicaciones más desde {price}",
  "mkt.refMarket_one": "1 publicación más desde {price}",
  "mkt.refMarketNone": "No hay otras publicaciones de esta carta.",
  "mkt.refMarketNoneSealed": "No hay otras publicaciones de este producto.",
  "mkt.refCheaperStore": "💡 En la tienda está más barata (precio NM, en el estado que tengamos).",
  "mkt.editInShop": "Editar en mi tienda",
  "mkt.onVacation": "La tienda está de vacaciones hasta el {date}.",
  "mkt.notAvailable": "No disponible por ahora.",
  "mkt.quantity": "Cantidad",
  "mkt.quantityOf": "Cantidad de {name}",
  "mkt.buyNow": "Comprar",
  "mkt.addToOrder": "Sumar al pedido con {seller}",
  "mkt.addedToOrder": "✓ Sumada al pedido",
  "mcart.title": "Tu carrito",
  "mcart.perSeller": "Tenés cartas de {count} vendedores: son {count} pedidos separados, y a cada uno le pagás aparte, directo y solo su monto.",
  "mcart.orderOf": "Pedido {n} de {count}",
  "mcart.cardsOf": "Cartas de @{handle}",
  "mcart.exactLater": "El monto exacto a pagar (con la entrega) te lo da cada pedido, junto con a quién pagarle.",
  "mcart.buyFrom": "Comprar a @{handle}",
  "mcart.empty": "Todavía no sumaste cartas.",
  "mcart.browse": "Ir al mercado",
  "mkt.makeOffer": "Hacer una oferta",
  "mkt.save": "Guardar",
  "mkt.saved": "Guardado",
  "mkt.specsLocked": "Tiene ofertas abiertas o una reserva: estos datos no se pueden cambiar hasta que se cierren.",
  "mkt.soldBy": "Vende",
  "mkt.seeShop": "Ver tienda",
  "mkt.payments": "Cobra con",
  "mkt.delivery": "Entrega",
  "mkt.noProtection": "Este vendedor no cobra por Mercado Pago: transferencias y cripto no tienen protección al comprador. Revisá su reputación antes.",
  "mkt.sellerNotes": "Notas del vendedor",
  "mkt.offerTitle": "Hacer una oferta",
  "mkt.offerIntro": "Precio publicado: {price}. El vendedor puede aceptar, rechazar o contraofertar. Si acepta, tenés 48 horas para comprar a ese precio.",
  "mkt.offerPrice": "Tu oferta por carta ($)",
  "mkt.offerSend": "Enviar oferta",
  "mkt.offerSent": "¡Oferta enviada! Te avisamos por email cuando responda. Seguila en Mi mercado › Ofertas.",
  "mkt.offerOpen": "Ya tenés una oferta abierta por esta publicación.",

  "mkt.sellerNotFound": "No encontramos esa tienda.",
  "mkt.memberSince": "en pokefans.fun desde {date}",
  "mkt.avatarLevel": "nivel {level}",
  "mkt.followers": "{count} seguidores",
  "mkt.followers_one": "1 seguidor",
  "mkt.follow": "Seguir",
  "mkt.following": "Siguiendo",
  "mkt.share": "Compartir",
  "mkt.reputation": "Reputación",
  "mkt.metricResponse": "Responde en",
  "mkt.metricCancel": "Pedidos que canceló",
  "mkt.metricOnTime": "Envió a tiempo",
  "mkt.metricsNote": "Últimos 90 días. A tiempo = dentro de los 3 días de pagado.",
  "mkt.minutes": "~{count} minutos",
  "mkt.minutes_one": "~1 minuto",
  "mkt.hours": "~{count} horas",
  "mkt.hours_one": "~1 hora",
  "mkt.days": "~{count} días",
  "mkt.days_one": "~1 día",
  "mkt.howSells": "Cómo vende",
  "mkt.free": "gratis",
  "mkt.quoted": "a cotizar",
  "mkt.pickupAfterPay": "Dirección después de pagar",
  "mkt.arrangeChat": "Donde arreglen, en sus días y horarios",
  "mkt.offers": "Ofertas",
  "mkt.offersYes": "Acepta ofertas",
  "mkt.offersNo": "No acepta ofertas",
  "mkt.sellerCards": "Sus publicaciones",
  "mkt.sellerNoCards": "No tiene nada publicado ahora.",
  "mkt.reviews": "Reseñas ({count})",
  "mkt.noReviewsYet": "Todavía no tiene reseñas.",
  "mkt.sellerReply": "Respuesta del vendedor:",
  "mkt.moreReviews": "Ver más reseñas",

  "mkt.cartEmpty": "No hay cartas de este vendedor en tu pedido.",
  "mkt.backToShop": "Volver a su tienda",
  "mkt.checkoutTitle": "Tu pedido a @{handle}",
  "mkt.totalTo": "Total a pagarle a @{handle}",
  "mkt.otherCarts": "Este pedido es solo de @{handle}. Tus cartas de otros vendedores siguen en el carrito: cada una es otro pedido, con su propio pago.",
  "mkt.otherCart": "@{handle}: {count} cartas por {total}",
  "mkt.otherCart_one": "@{handle}: 1 carta por {total}",
  "mkt.cards": "Cartas",
  "mkt.offerPriceTag": "precio ofertado",
  "mkt.remove": "Quitar",
  "mkt.addMoreFromSeller": "＋ Sumar más cartas de este vendedor",
  "mkt.yourZone": "¿En qué zona estás?",
  "mkt.choose": "Elegí…",
  "mkt.payment": "Pago",
  "mkt.payHint.mercadopago": "🛡️ Compra protegida: pagás por Mercado Pago, con su protección al comprador.",
  "mkt.payHint.transfer": "Le transferís al vendedor y él confirma que le llegó. Sin protección: pagá solo con los datos del pedido.",
  "mkt.payHint.crypto": "USDT a la billetera del vendedor, al dólar del día. Sin protección: pagá solo con los datos del pedido.",
  "mkt.verified": "Verificado",
  "mkt.manualWarning": "Transferencias y cripto van directo al vendedor, sin intermediarios: si algo sale mal no hay a quién reclamarle el dinero. Pagá solo con los datos de este pedido.",
  "mkt.yourDetails": "Tus datos",
  "mkt.name": "Nombre y apellido",
  "mkt.phone": "Teléfono",
  "mkt.phoneHint": "Lo ve el vendedor recién cuando el pedido esté pagado.",
  "mkt.address": "Dirección de entrega",
  "mkt.city": "Ciudad",
  "mkt.notes": "Algo para el vendedor (opcional)",
  "mkt.subtotal": "Cartas",
  "mkt.deliveryLine": "Entrega",
  "mkt.toAgree": "a convenir",
  "mkt.total": "Total",
  "mkt.acceptTermsBuyer": "Leí y acepto los",
  "mkt.marketTerms": "términos del mercado",
  "mkt.payWithMp": "Pagar con Mercado Pago",
  "mkt.placeOrder": "Hacer el pedido",
  "mkt.noMoneyNote": "pokefans.fun no cobra ni retiene el dinero: le pagás directamente al vendedor.",
  "mkt.errStock": "Alguna carta ya no está disponible en esa cantidad. Revisá el pedido.",
  "mkt.errPriceChanged": "Cambió el precio de {names} desde que lo agregaste. Ya ves el precio de hoy: revisá el total y confirmá de nuevo.",
  "mkt.errPriceChangedCoupon": "El cupón se quitó: aplicalo de nuevo para ver su descuento con el precio nuevo.",
  "mkt.errVacation": "El vendedor está de vacaciones.",
  "mkt.errOffer": "La oferta venció o ya se usó.",

  "mkt.orderNotFound": "No encontramos ese pedido.",
  "mkt.orderTitle": "Pedido {number}",
  "mkt.youSell": "Vendés",
  "mkt.youBuy": "Comprás",
  "mkt.howToPay": "Cómo pagar",
  "mkt.payDirect": "Pagale exactamente {total} a @{handle} ({name}), por el pedido {number}:",
  "mkt.exactAmount": "Monto exacto",
  "mkt.payPlusShipping": "Pagale {total} por las cartas, más el envío que te cotice por el chat, a @{handle} ({name}), por el pedido {number}:",
  "mkt.amountNoShipping": "Cartas (sin el envío)",
  "mkt.payOnlyThis": "Este pago es solo para @{handle}. Te quedan cartas de {others} en el carrito: cada pedido tiene su propio monto y sus propios datos de pago.",
  "mkt.seeCart": "Ver carrito",
  "mkt.holder": "Titular",
  "mkt.checkHolder": "Antes de confirmar, fijate que el titular que te muestra tu banco sea {holder}. Si no coincide, no transfieras y avisanos con «Denunciar este pedido».",
  "mkt.bank": "Banco",
  "mkt.reservedUntil": "Las cartas quedan reservadas hasta el {date}. Avisá apenas pagues.",
  "mkt.markPaid": "Ya pagué",
  "mkt.txLabel": "Hash de la transacción (TXID)",
  "mkt.txHint": "Lo ves en tu billetera después de enviar. Con el hash, el vendedor encuentra tu pago en la blockchain.",
  "mkt.txSave": "Guardar hash",
  "mkt.txReplace": "Cambiar hash",
  "mkt.txShown": "Transacción:",
  "mkt.txExplorer": "Ver en el explorador",
  "mkt.txCheckSeller": "Antes de confirmar, abrí la transacción y revisá que vaya a tu billetera, el monto, que el token sea el USDT oficial y que esté confirmada.",
  "mkt.txMissingSeller": "El comprador avisó que pagó pero no cargó el hash de la transacción: pedíselo por el chat.",
  "mkt.txUsed": "Ese hash ya se usó para pagar otro pedido.",
  "mkt.txInvalid": "Ese hash no es válido para esta red. Copialo completo desde tu billetera.",
  "mkt.usdtExact": "Tiene que llegar este monto exacto, con todos los decimales: los últimos son de tu pedido y le muestran al vendedor que la transferencia es tuya. Si tu exchange descuenta comisión, sumala.",
  "mkt.usdtExactAuto": "Tiene que llegar este monto exacto, con todos los decimales: los últimos son de tu pedido. Si tu exchange descuenta comisión, sumala. Con el hash, cuando la red confirma la transferencia, el pedido se confirma solo.",
  "mkt.txCheckSellerAmount": "Antes de confirmar, abrí la transacción y revisá que vaya a tu billetera, que sean exactamente {usdt} USDT (el USDT oficial) y que esté confirmada.",
  "mkt.txCheck.ok": "Verificada en la red.",
  "mkt.txCheck.pending": "Esperando que la red confirme la transacción. El pedido se confirma solo cuando llegue.",
  "mkt.txCheck.not_found": "No aparece confirmada en la red TRON: el vendedor tiene que revisarla.",
  "mkt.txCheck.wrong_token": "Esta transacción no es de USDT oficial: el vendedor tiene que revisarla.",
  "mkt.txCheck.wrong_to": "Esta transacción no fue a la billetera de este pedido: el vendedor tiene que revisarla.",
  "mkt.txCheck.wrong_amount": "El monto no es el exacto de este pedido: el vendedor tiene que revisarlo y confirmarlo.",
  "mkt.txCheck.too_old": "Esta transacción es de antes del pedido: el vendedor tiene que revisarla.",
  "mkt.txCheck.used": "Esta transacción ya pagó otro pedido.",
  "mkt.confirmPayment": "Me llegó el pago",
  "mkt.confirmPaymentMarked": "Confirmar que me llegó el pago",
  "mkt.markShipped": "Marcar como enviado / entregado",
  "mkt.markReceived": "Recibí todo bien",
  "mkt.askHelp": "Pedir ayuda a pokefans.fun",
  "mkt.cancelOrder": "Cancelar el pedido",
  "mkt.reasonRequired": "Contanos qué pasó.",
  "mkt.discount": "Descuento",
  "mkt.buyer": "Comprador",
  "mkt.seller": "Vendedor",
  "mkt.contactAfterPay": "Los datos de contacto aparecen (y se envían por email) cuando el pedido esté pagado o confirmado.",
  "mkt.tracking": "Seguimiento: {code}",
  "mkt.st.unpaidBuyer": "Pagale al vendedor con los datos de abajo y tocá \"Ya pagué\".",
  "mkt.st.unpaidMp": "Falta pagar con Mercado Pago.",
  "mkt.st.unpaidSeller": "Esperando que el comprador pague.",
  "mkt.st.markedBuyer": "Avisaste que pagaste. El vendedor tiene que confirmar que le llegó.",
  "mkt.st.markedSeller": "El comprador dice que ya pagó: revisá tu cuenta y confirmá.",
  "mkt.st.paidBuyer": "Pago confirmado. Coordinen la entrega por el chat.",
  "mkt.st.paidSeller": "Pedido pagado. Coordiná la entrega y marcalo como enviado / entregado.",
  "mkt.st.shippedBuyer": "El vendedor lo envió / entregó. Confirmá cuando lo tengas; si no, se completa solo el {date}.",
  "mkt.st.shippedSeller": "Enviado. Se completa cuando el comprador confirme o solo el {date}.",
  "mkt.st.completed": "¡Pedido completado! Dejá tu reseña.",
  "mkt.st.disputed": "pokefans.fun está revisando este pedido. Sigan por el chat.",
  "mkt.st.cancelled": "Pedido cancelado. {reason}",
  "mkt.chat": "Chat del pedido",
  "mkt.chatSafety": "Por seguridad, hablen y paguen solo por acá. Nunca compartas contraseñas ni códigos.",
  "mkt.chatLabel": "Mensaje",
  "mkt.chatPlaceholder": "Escribí un mensaje…",
  "mkt.send": "Enviar",
  "mkt.reviewTitle": "Reseña",
  "mkt.theSeller": "al vendedor",
  "mkt.theBuyer": "al comprador",
  "mkt.rate": "Calificá {who}",
  "mkt.reviewText": "Comentario",
  "mkt.reviewPlaceholder": "¿Cómo te fue? (opcional)",
  "mkt.reviewSend": "Enviar reseña",
  "mkt.yourReview": "Tu reseña:",
  "mkt.theirReview": "Te calificó:",
  "mkt.replyLabel": "Respuesta",
  "mkt.replyPlaceholder": "Respondé a esta reseña (una sola vez)",
  "mkt.replySend": "Responder",
  "mkt.cancelTitle": "Cancelar el pedido",
  "mkt.cancelReason": "Motivo",
  "mkt.cancelIntro": "Las cartas vuelven a estar disponibles. Si ya se pagó, el vendedor tiene que devolver el dinero completo.",
  "mkt.disputeTitle": "Pedir ayuda",
  "mkt.disputeReason": "¿Qué pasó?",
  "mkt.disputeIntro": "Usalo si no lo pudieron resolver por el chat. pokefans.fun revisa el pedido y el chat, y media con el vendedor.",
  "mkt.shipTitle": "Enviado / entregado",
  "mkt.trackingLabel": "Número de seguimiento (opcional)",
  "mkt.shipIntro": "Marcalo cuando lo despaches o lo entregues en mano.",

  "mkt.myShop": "Mi tienda",
  "mkt.myShopHint": "Vendé tus cartas en el mercado",
  "mkt.myMarket": "Mi mercado",
  "mkt.myMarketHint": "Compras, ofertas, favoritos y \"Busco\"",
  "mkt.pendingTitle": "Tu solicitud está en revisión",
  "mkt.pendingText": "Te avisamos por email apenas la revisemos.",
  "mkt.pausedTitle": "Tu tienda está pausada",
  "mkt.bannedTitle": "Tu tienda fue dada de baja",
  "mkt.reason": "Motivo: {reason}",
  "mkt.mpConnected": "¡Listo! Tu cuenta de Mercado Pago quedó conectada.",
  "mkt.mpError": "No se pudo conectar Mercado Pago. Probá de nuevo.",
  "mkt.setupPayments": "Configurá al menos un medio de cobro en Ajustes para que te puedan comprar.",
  "mkt.cantSellYet": "Este vendedor todavía no configuró {what}. Cuando lo haga vas a poder comprarle.",
  "mkt.cantSellDelivery": "cómo entrega",
  "mkt.cantSellPayment": "cómo cobra",
  "mkt.and": " ni ",
  "mkt.andBoth": " y ",
  "mkt.setupToSell": "Tus publicaciones no se ven en el mercado hasta que configures {what}.",
  "mkt.setupWhatPayment": "cómo cobrás",
  "mkt.setupWhatDelivery": "cómo entregás",
  "mkt.goToSettings": "Ir a Ajustes",
  "mkt.tab.publicaciones": "Publicaciones",
  "mkt.tab.ventas": "Ventas",
  "mkt.tab.ofertas": "Ofertas",
  "mkt.tab.ajustes": "Ajustes",
  "mkt.tab.integraciones": "Integraciones",
  "push.title": "Notificaciones en este dispositivo",
  "push.intro": "Te avisamos al instante de compras, ventas, mensajes del chat y ofertas, aunque no tengas el sitio abierto.",
  "push.enable": "Activar notificaciones",
  "push.on": "Activadas en este dispositivo.",
  "push.disable": "Desactivar",
  "push.denied": "Las notificaciones están bloqueadas para pokefans.fun en este navegador. Habilitalas desde la configuración del sitio (el candado al lado de la dirección).",
  "push.iosInstall": "En iPhone funcionan con la app instalada: tocá Compartir › \"Agregar a inicio\", abrí pokefans.fun desde el ícono y activalas desde acá.",
  "inbox.label": "{count} pendientes en el mercado",
  "inbox.label_one": "1 pendiente en el mercado",
  "search.sellers": "Vendedores",
  "search.sellerListings": "{count} publicaciones",
  "search.sellerListings_one": "1 publicación",
  "mkt.tab.estadisticas": "Estadísticas",
  "mkt.tab.est_cartas": "Cartas",
  "mkt.tab.est_precios": "Precios",
  "mkt.tab.demanda": "Lo que buscan",
  "mkt.tab.cupones": "Cupones",
  "mkt.tab.clientes": "Clientes",
  "mkt.tab.emails": "Emails",
  "eml.teaser": "Emails a tus clientes y seguidores, con tus cartas y un cupón, enviados por pokefans en tu nombre: disponible en {plan}.",
  "eml.intro": "Escribile a un grupo de tus clientes o seguidores: pokefans elige a las personas (solo las que aceptaron recibir novedades y no te dieron de baja) y manda el email en tu nombre. Vos ves cuántos lo recibieron, cuántos entraron y cuántos compraron.",
  "eml.paused": "Por ahora pokefans no está mandando emails de las tiendas: tu email queda en cola y sale apenas se habiliten.",
  "eml.blocked": "Tus emails a clientes están apagados: {reason}. Escribinos si creés que es un error.",
  "eml.left": "Te quedan {left} de {max} emails este mes.",
  "eml.rules": "Cada persona recibe como mucho un email tuyo por semana y cuatro de todas las tiendas. Sin links a otros sitios ni datos de contacto: lo demás, por el chat de los pedidos.",
  "eml.new": "Nuevo email",
  "eml.segment": "Para",
  "eml.subject": "Asunto",
  "eml.body": "Texto",
  "eml.bodyHint": "Texto simple. Empieza con «Hola, <nombre>:» y termina con tus cartas y tu cupón.",
  "eml.listings": "Cartas para mostrar (hasta 6)",
  "eml.coupon": "Cupón (opcional)",
  "eml.noCoupon": "Sin cupón",
  "eml.send": "Mandar",
  "eml.firstNote": "El primero lo revisa pokefans antes de salir; los siguientes salen solos.",
  "eml.empty": "Todavía no mandaste emails.",
  "eml.status.queued": "En cola",
  "eml.status.sending": "Saliendo",
  "eml.status.sent": "Enviado",
  "eml.status.rejected": "No salió",
  "eml.awaiting": "esperando revisión de pokefans",
  "eml.results": "{sent} enviados · {clicks} entraron · {orders} pedidos",
  "eml.rejected": "Motivo: {reason}",
  "eml.resultsFew": "Enviado a menos de 5 personas: en este grupo no mostramos los números.",
  "auto.title": "Automáticos",
  "auto.intro": "Emails que salen solos, con texto de pokefans, a tus clientes (y seguidores, en las novedades). Cuentan para los mismos límites por persona y no gastan los 4 del mes.",
  "auto.thanks": "Gracias + cupón",
  "auto.thanksHint": "7 días después de cada compra completada, una vez por comprador, con un cupón personal para la próxima.",
  "auto.winback": "Volvé",
  "auto.winbackHint": "A quien no te compra hace 60 días (una vez cada 180), con tus últimas cartas y, si querés, un cupón.",
  "auto.news": "Novedades",
  "auto.newsHint": "Una vez por semana, si publicaste 5 cartas o más, con hasta 6 de ellas.",
  "auto.on": "Prendido",
  "auto.save": "Guardar",
  "auto.saved": "Guardado.",
  "auto.days": "Vence a los (días)",
  "auto.results": "{sent} enviados · {clicks} entraron · {orders} pedidos",
  "eml.err.links": "Sacá los links a otros sitios y los emails o datos de contacto del texto.",
  "eml.err.emails_quota": "Ya usaste los emails de este mes.",
  "eml.err.emails_blocked": "Tus emails a clientes están apagados.",
  "eml.err.validation": "Revisá el asunto (3 a 80 caracteres) y el texto (hasta 2000).",
  "mkt.plan.rowEmails": "Emails a tus clientes y seguidores (por mes)",
  "shopmail.title": "Emails de tiendas",
  "shopmail.optoutText": "No vas a recibir más emails de esta tienda por pokefans. El resto de tus avisos sigue igual.",
  "shopmail.optoutButton": "No recibir más de esta tienda",
  "shopmail.optoutDone": "Listo: no vas a recibir más emails de esta tienda.",
  "shopmail.spamText": "¿Este email de una tienda te pareció spam? Avisanos: dejás de recibir los de esa tienda y pokefans revisa sus envíos.",
  "shopmail.spamButton": "Denunciar como spam",
  "shopmail.spamDone": "Gracias: no vas a recibir más emails de esa tienda y lo vamos a revisar.",
  "cus.teaser": "Tus clientes, grupos (recurrentes, VIP, inactivos), qué más compran y quiénes buscan lo que tenés, con cupones para cada grupo: disponible en {plan}.",
  "cus.customers": "Clientes",
  "cus.repeat": "Recurrentes",
  "cus.repeatNote": "{pct}% de tus clientes",
  "cus.avgTicket": "Ticket promedio",
  "cus.repeatRevenue": "De tu plata",
  "cus.repeatRevenueNote": "viene de gente que ya te había comprado",
  "cus.followers": "Seguidores",
  "cus.segment": "Grupo",
  "cus.sort": "Ordenar",
  "cus.sort.last": "Última compra",
  "cus.sort.spent": "Más gastado",
  "cus.sort.orders": "Más pedidos",
  "cus.seg.all": "Todos tus clientes",
  "cus.seg.new": "Compraron una vez",
  "cus.seg.repeat": "Recurrentes (2 compras o más)",
  "cus.seg.vip": "VIP (los que más gastan)",
  "cus.seg.recent": "Compraron en los últimos 30 días",
  "cus.seg.inactive": "Sin comprar hace más de 60 días",
  "cus.seg.followers": "Te siguen",
  "cus.seg.wants_my_stock": "Buscan o guardaron cartas que tenés",
  "cus.seg.boughtSet": "Compraron de {set}",
  "cus.chip.new": "nuevo",
  "cus.chip.repeat": "recurrente",
  "cus.chip.vip": "VIP",
  "cus.chip.recent": "reciente",
  "cus.chip.inactive": "inactivo",
  "cus.colName": "Cliente",
  "cus.colOrders": "Pedidos",
  "cus.colSpent": "Gastado",
  "cus.colFirst": "Primera",
  "cus.colLast": "Última",
  "cus.lastOrder": "Último pedido",
  "cus.giveCoupon": "Darle un cupón",
  "cus.couponFor": "Cupón para {name}",
  "cus.couponDays": "Vence en (días)",
  "cus.couponMade": "Listo: {name} lo ve en Mis cupones y al comprarte. Código {code}.",
  "cus.empty": "Todavía nadie de este grupo te compró.",
  "cus.privacy": "Ves solo lo que te compraron a vos. Para grupos y emails, pokefans elige a las personas y vos ves cuántas son.",
  "cus.interests": "Tus clientes también compran",
  "cus.interestsHint": "Lo que compraron tus clientes en otras tiendas y en pokefans en los últimos 180 días. Solo cantidades de personas, y solo cuando son 5 o más.",
  "cus.interestsEmpty": "Todavía no hay datos suficientes (hacen falta 5 compradores distintos por fila).",
  "cus.sets": "Sets",
  "cus.categories": "Categorías",
  "cus.pokemon": "Pokémon",
  "cus.buyers": "{count} clientes",
  "cus.opportunities": "Oportunidades",
  "cus.opportunitiesHint": "{count} clientes o seguidores tuyos buscan o guardaron cartas que tenés publicadas. No mostramos quiénes: podés darles un cupón con el grupo «Buscan o guardaron cartas que tenés».",
  "cus.opportunitiesEmpty": "Por ahora nadie de tus clientes o seguidores busca lo que tenés publicado.",
  "cus.people": "{count} personas",
  "cus.groupSize": "{count} personas en este grupo ahora",
  "cus.groupSizeFew": "Menos de 5 personas en este grupo ahora",
  "cus.peopleFew": "menos de 5 personas",
  "cus.opportunitiesHintFew": "Menos de 5 clientes o seguidores tuyos buscan o guardaron cartas que tenés publicadas. No mostramos quiénes: podés darles un cupón con el grupo «Buscan o guardaron cartas que tenés».",
  "mkt.plan.rowCustomers": "Clientes: grupos, qué más compran, oportunidades y cupones por grupo o cliente",
  "mkt.plan.rowApi": "API e integraciones: tu planilla o tu sistema sincronizan stock, precios y pedidos",
  "mkt.tab.cuponesBuyer": "Mis cupones",
  "myc.intro": "Cupones que te dieron las tiendas: se usan en el checkout de esa tienda.",
  "myc.empty": "Por ahora no tenés cupones.",
  "myc.personal": "solo para vos",
  "myc.until": "hasta el {date}",
  "myc.atCheckout": "Tenés un cupón de esta tienda: {code} ({off}).",
  "cpn.intro": "Un cupón es un descuento que hacés sobre tus precios: se aplica en el checkout de tu tienda, nunca sobre el envío ni junto con una oferta aceptada. El comprador te sigue pagando directo.",
  "cpn.limit": "Tu plan permite {count} cupones activos a la vez.",
  "cpn.limit_one": "Tu plan permite 1 cupón activo a la vez, para toda la tienda.",
  "cpn.new": "Nuevo cupón",
  "cpn.code": "Código",
  "cpn.codeHint": "De 4 a 16 letras o números, sin espacios (por ejemplo BIENVENIDO).",
  "cpn.kind": "Tipo",
  "cpn.percent": "Porcentaje",
  "cpn.amount": "Monto fijo",
  "cpn.value": "Descuento",
  "cpn.minSubtotal": "Compra mínima (opcional)",
  "cpn.maxDiscount": "Tope del descuento (opcional)",
  "cpn.scope": "Para qué",
  "cpn.scope.shop": "Toda la tienda",
  "cpn.scope.products": "Algunas cartas",
  "cpn.scope.set": "Un set",
  "cpn.scope.segment": "Un grupo de clientes",
  "cpn.scope.user": "Un cliente",
  "cpn.products": "Cartas",
  "cpn.set": "Set",
  "cpn.usesMax": "Usos en total (opcional)",
  "cpn.perUser": "Usos por comprador",
  "cpn.endsAt": "Vence (opcional)",
  "cpn.create": "Crear cupón",
  "cpn.empty": "Todavía no creaste cupones.",
  "cpn.uses": "{count} usos",
  "cpn.uses_one": "1 uso",
  "cpn.usesOf": "{count} de {max} usos",
  "cpn.discounted": "{amount} descontados",
  "cpn.status.active": "Activo",
  "cpn.status.paused": "Pausado",
  "cpn.status.ended": "Terminado",
  "cpn.pausedPlan": "pausado: tu plan ya no lo incluye",
  "cpn.pausedAdmin": "pausado por pokefans.fun",
  "cpn.until": "hasta el {date}",
  "cpn.from": "desde el {date}",
  "cpn.min": "compra mínima {amount}",
  "cpn.cap": "tope {amount}",
  "cpn.pause": "Pausar",
  "cpn.resume": "Reactivar",
  "cpn.end": "Terminar",
  "cpn.endConfirm": "¿Terminar el cupón {code}? No se puede volver a usar.",
  "cpn.err.coupon_limit": "Tu plan no permite más cupones activos: pausá o terminá otro primero.",
  "cpn.err.coupon_code_taken": "Ya tenés un cupón con ese código.",
  "cpn.err.plan_required": "Tu plan no incluye ese tipo de cupón.",
  "cpn.err.validation": "Revisá los datos del cupón.",
  "cpn.public": "🏷️ Cupón {code}: {off}",
  "cpn.off.percent": "{value}% de descuento",
  "cpn.off.amount": "{value} de descuento",
  "cpn.publicMin": " en compras desde {amount}",
  "mkt.coupon": "Cupón",
  "mkt.couponHave": "¿Tenés un cupón?",
  "mkt.couponApply": "Aplicar",
  "mkt.couponRemove": "Quitar cupón",
  "mkt.couponUse": "Usar",
  "mkt.couponLine": "Cupón {code}",
  "mkt.couponWithOffer": "Los cupones no se suman a una oferta aceptada.",
  "mkt.couponErr.coupon_not_found": "Ese cupón no existe en esta tienda.",
  "mkt.couponErr.coupon_other_shop": "Ese cupón es de otra tienda.",
  "mkt.couponErr.coupon_inactive": "Ese cupón no está activo.",
  "mkt.couponErr.coupon_not_started": "Ese cupón todavía no empezó.",
  "mkt.couponErr.coupon_expired": "Ese cupón ya venció.",
  "mkt.couponErr.coupon_used_up": "Ese cupón ya se usó todas las veces que permitía.",
  "mkt.couponErr.coupon_already_used": "Ya usaste ese cupón.",
  "mkt.couponErr.coupon_min": "Ese cupón es para compras desde {min}.",
  "mkt.couponErr.coupon_no_lines": "Ese cupón no aplica a estas cartas.",
  "mkt.couponErr.coupon_with_offer": "Los cupones no se suman a una oferta aceptada.",
  "mkt.couponErr.coupon_not_for_you": "Ese cupón es para otra persona.",
  "mkt.couponErr.other": "No pudimos revisar el cupón. Probá de nuevo.",
  "mkt.bulkPart": "Descuento por cantidad",
  "perf.sources": "De dónde vienen tus visitas",
  "perf.sourcesHint": "Cuentan desde que empezamos a registrarlo. Tu link corto y tu QR cuentan como «Tu QR o link corto».",
  "perf.sourcesEmpty": "Todavía no hay visitas con origen registrado en este período.",
  "perf.src.search": "Búsqueda del mercado",
  "perf.src.product": "Página de la carta",
  "perf.src.shop": "Tu tienda",
  "perf.src.featured": "Destacados",
  "perf.src.email": "Tus emails",
  "perf.src.qr": "Tu QR o link corto",
  "perf.src.external": "Otros sitios (Instagram, WhatsApp…)",
  "perf.src.other": "Otras páginas",
  "perf.rotationText": "Tus cartas tardan {days} días en venderse (mediana de {count} ventas).",
  "perf.rotationNone": "Todavía no hay ventas completadas para calcularlo.",
  "perf.noViews": "Sin visitas en 30 días",
  "perf.noViewsHint": "Publicadas hace un mes o más y nadie las miró en los últimos 30 días: bajales el precio o pausalas.",
  "perf.savedNotSold": "Guardadas pero sin vender",
  "perf.savedNotSoldHint": "La gente las guarda como favoritas pero no las compra: probá destacarlas o bajarles un poco el precio.",
  "perf.favorites": "{count} favoritas",
  "perf.lowerPrice": "Bajar precio",
  "perf.pause": "Pausar",
  "perf.paused": "Pausada",
  "perf.feature": "Destacar",
  "perf.featured": "Destacada",
  "perf.none": "Ninguna.",
  "rep.title": "Emails para vos",
  "rep.teaser": "Un resumen de tu semana cada lunes, avisos de tus precios contra el mercado y un resumen mensual para tu contador: disponible en {plan}.",
  "rep.weekly": "Resumen de mi semana (los lunes)",
  "rep.prices": "Avisos de precio (los lunes, si alguna publicación quedó cara)",
  "rep.saved": "Guardado.",
  "rep.accounting": "Resumen para el contador",
  "rep.accountingHint": "Pedidos completados de los últimos 12 meses, por mes y medio de pago (sin los envíos cotizados por el chat). Es solo lo que cobraste: pokefans.fun no emite comprobantes.",
  "rep.accountingDownload": "Descargar para Excel",
  "serverPage.open": "Abrir la página",
  "wh.title": "Webhooks",
  "wh.count": "{count} de {max} webhooks",
  "wh.hint": "Recibí en tu servidor una notificación firmada (HTTP POST) cada vez que ocurre un evento en tu tienda: pedidos, pagos, mensajes o cambios en publicaciones.",
  "wh.url": "URL (https)",
  "wh.description": "Descripción (opcional)",
  "wh.events": "Eventos",
  "wh.all": "Todos los eventos",
  "wh.pick": "Elegir eventos",
  "wh.listingHint": "Para no perder cambios de una publicación, elegí todos los eventos de publicaciones: un cambio de precio y stock simultáneo llega como «Cambio de stock», con la publicación completa.",
  "wh.create": "Crear webhook",
  "wh.created": "Copiá el secreto de firma y guardalo en un lugar seguro: lo necesitás para verificar cada notificación y no se vuelve a mostrar.",
  "wh.rotated": "Copiá el secreto nuevo ahora. Durante 24 horas cada notificación lleva las dos firmas, la anterior y la nueva.",
  "wh.active": "Activo",
  "wh.failing": "Fallando desde {date}",
  "wh.off": "Desactivado",
  "wh.offFailing": "Se desactivó tras 3 días de fallas. Corregí el endpoint y reactivalo: se envían las notificaciones pendientes.",
  "wh.allEvents": "Todos",
  "wh.someEvents": "{count} eventos",
  "wh.test": "Probar",
  "wh.testOk": "Respondió {code} en {ms} ms",
  "wh.testFail": "No respondió bien: {error}",
  "wh.rotate": "Rotar secreto",
  "wh.deliveries": "Envíos",
  "wh.noDeliveries": "Todavía no hay envíos.",
  "wh.retry": "Reintentar",
  "wh.retried": "En cola",
  "wh.turnOff": "Desactivar",
  "wh.turnOn": "Activar",
  "wh.delete": "Borrar",
  "wh.deleteConfirm": "¿Borrar el webhook a {url}? Deja de recibir notificaciones.",
  "wh.limit": "Llegaste a los {max} webhooks de tu plan.",
  "wh.badUrl": "Tiene que ser una URL https pública (no una dirección interna).",
  "wh.status.ok": "entregado",
  "wh.status.pending": "reintentando",
  "wh.status.dead": "falló",
  "wh.status.skipped": "omitido",
  "wh.ev.order.created": "Pedido nuevo",
  "wh.ev.order.payment_claimed": "El comprador avisó que pagó",
  "wh.ev.order.confirmed": "Pedido en efectivo confirmado",
  "wh.ev.order.paid": "Pedido pagado",
  "wh.ev.order.shipped": "Pedido enviado",
  "wh.ev.order.handed": "Entregado en mano",
  "wh.ev.order.completed": "Pedido completado",
  "wh.ev.order.cancelled": "Pedido cancelado",
  "wh.ev.order.disputed": "Pedido con reclamo",
  "wh.ev.order.updated": "Otros cambios en un pedido",
  "wh.ev.order.message.created": "Mensaje en un pedido",
  "wh.ev.offer.created": "Oferta nueva",
  "wh.ev.offer.accepted": "Oferta aceptada",
  "wh.ev.offer.expired": "Oferta vencida",
  "wh.ev.listing.created": "Publicación nueva",
  "wh.ev.listing.updated": "Publicación cambiada",
  "wh.ev.listing.stock_changed": "Cambio de stock",
  "wh.ev.listing.sold_out": "Publicación agotada",
  "wh.ev.listing.removed": "Publicación borrada",
  "wh.ev.review.created": "Reseña nueva",
  "wh.ev.want.matched": "Alguien busca una carta que publicaste",
  "api.log": "Registro de actividad",
  "api.logEmpty": "Todavía no hubo solicitudes con tus claves.",
  "api.logHint": "Últimos 30 días: todas las escrituras y los errores, y una muestra de las lecturas exitosas.",
  "api.title": "Integraciones (API)",
  "wh.testLabel": "Prueba",
  "wh.failingPill": "Con fallas",
  "wh.rotatedTitle": "Secreto rotado",
  "wh.createdTitle": "Webhook creado",
  "wh.colResponse": "Respuesta",
  "wh.colResult": "Resultado",
  "wh.colEvent": "Evento",
  "wh.colStatus": "Estado",
  "wh.colUrl": "Destino",
  "wh.empty": "No hay webhooks configurados.",
  "wh.new": "Nuevo webhook",
  "api.lapsed": "Las integraciones están incluidas en el plan {plan}.",
  "api.teaserShort": "Conectá tu sistema o tu planilla y mantené al día el stock y los precios de tus publicaciones automáticamente. Incluido en {plan}.",
  "api.teaser": "Conectá tu sistema o tu planilla y mantené al día el stock y los precios de tus {count} publicaciones automáticamente. Incluido en {plan}.",
  "api.logHide": "Ocultar",
  "api.logShow": "Ver registro",
  "api.scopeShort.webhooks:manage": "Webhooks",
  "api.scopeShort.orders:write": "Pedidos: escritura",
  "api.scopeShort.orders:read": "Pedidos: lectura",
  "api.scopeShort.listings:write": "Publicaciones: escritura",
  "api.scopeShort.listings:read": "Publicaciones: lectura",
  "api.createdTitle": "Clave creada",
  "api.colKeyName": "Clave",
  "api.colMs": "Duración",
  "api.colStatus": "Estado",
  "api.colRequest": "Solicitud",
  "api.colDate": "Fecha",
  "api.colActions": "Acciones",
  "api.colLastUsed": "Último uso",
  "api.colScopes": "Permisos",
  "api.colKey": "Clave",
  "api.colName": "Nombre",
  "api.empty": "Todavía no creaste ninguna clave.",
  "api.cancel": "Cancelar",
  "api.new": "Nueva clave",
  "api.keysHint": "Recomendamos una clave por sistema: así podés revocar una sin afectar a las demás.",
  "api.keysTitle": "Claves de API",
  "api.baseUrl": "URL base",
  "api.count": "{count} de {max} claves",
  "api.hint": "Conectá tu sistema de gestión, tu planilla o tus propios scripts con la tienda a través de la API REST: publicaciones, stock, precios y pedidos.",
  "api.docs": "Documentación de la API",
  "api.teaserCta": "Ver {plan}",
  "api.name": "Nombre (para reconocerla)",
  "api.namePlaceholder": "Planilla, Tiendanube, mi script…",
  "api.scopes": "Qué puede hacer",
  "api.scope.listings:read": "Ver publicaciones",
  "api.scope.listings:write": "Crear y cambiar publicaciones, stock y precios",
  "api.scope.orders:read": "Ver pedidos",
  "api.scope.orders:write": "Actuar sobre pedidos (confirmar pago, enviado, entregado, cancelar)",
  "api.scope.webhooks:manage": "Configurar avisos automáticos (webhooks)",
  "api.create": "Crear clave",
  "api.created": "Copiala y guardala en un lugar seguro: es la única vez que la vas a ver. Si la perdés, revocala y creá otra.",
  "api.copy": "Copiar",
  "api.copied": "Copiada",
  "api.neverUsed": "Nunca",
  "api.revoke": "Revocar",
  "api.revokeConfirm": "¿Revocar la clave «{name}»? Lo que la use deja de funcionar ya mismo.",
  "api.limit": "Llegaste a las {max} claves de tu plan: revocá una para crear otra.",
  "qr.title": "Respuestas rápidas",
  "qr.hint": "Textos que usás seguido en el chat de los pedidos (cómo pagar, cuándo despachás, cómo cuidás las cartas). En el chat, un toque los pega en el mensaje: después lo revisás y lo mandás.",
  "qr.count": "{count} de {max}",
  "qr.teaser": "Respuestas rápidas para el chat de los pedidos: disponible en {plan}.",
  "qr.titleLabel": "Nombre",
  "qr.bodyLabel": "Texto",
  "qr.add": "Guardar respuesta",
  "qr.remove": "Borrar",
  "qr.limit": "Tu plan no permite más respuestas rápidas: borrá alguna primero.",
  "qr.inChat": "Respuestas rápidas:",
  "link.title": "Tu link corto y QR",
  "link.hint": "Tu link para la bio de Instagram o WhatsApp. El QR, para tu mesa en un evento o tus paquetes: las visitas que llegan por el QR las ves en Rendimiento.",
  "link.copy": "Copiar link",
  "link.download": "Descargar QR",
  "ins.funnel": "Embudo por publicación",
  "ins.funnelHint": "De la visita a la venta, en el período. Conversión: pedidos cada 100 visitas, contando solo desde que registramos visitas.",
  "ins.funnelEmpty": "Todavía no tenés publicaciones.",
  "ins.colOffers": "Ofertas",
  "ins.colOrders": "Pedidos",
  "ins.colUnits": "Unidades",
  "ins.colConversion": "Conversión",
  "ins.prices": "Tu precio contra el mercado",
  "ins.pricesEmpty": "No tenés publicaciones activas sin gradear.",
  "ins.alone": "Sos el único que la vende",
  "ins.cheapest": "Sos el más barato",
  "ins.above": "{pct}% arriba de la mediana",
  "ins.below": "{pct}% abajo de la mediana",
  "ins.atMedian": "En la mediana",
  "ins.priceRow": "Vos: {mine} · mediana {median} · mínimo {min} · {count} ofertas más",
  "ins.priceRow_one": "Vos: {mine} · la otra oferta: {min}",
  "ins.response": "Respondés en el chat en",
  "ins.dispatch": "Despachás un envío en",
  "ins.samples": "mediana de {count} pedidos",
  "ins.samples_one": "1 pedido",
  "ins.timesNote": "Estos tiempos los ves solo vos.",
  "todo.title": "Para hacer hoy",
  "todo.none": "Nada pendiente: estás al día.",
  "todo.confirmPayment": "Confirmar que te llegó el pago",
  "todo.unpaid": "Sin pagar hace más de un día",
  "todo.deliver": "Para enviar o entregar",
  "todo.unanswered": "Mensajes sin responder",
  "todo.reviews": "Reseñas para contestar",
  "todo.more": "y {count} más en Ventas",
  "show.demand.title": "Lo que buscan",
  "show.demand.number": "{count} personas guardaron en «Busco» cartas que vos tenés.",
  "show.demand.number_one": "1 persona guardó en «Busco» una carta que vos tenés.",
  "show.demand.hint": "No las publicaron en Se busca, así que solo te enterás con {plan}: te avisamos en el momento en que alguien la agrega.",
  "show.demand.verb": "Ver cuáles",
  "show.customers.title": "Ya vendiste. Lo difícil está hecho.",
  "show.customers.number": "{count} clientes te compraron más de una vez.",
  "show.customers.number_one": "1 cliente te compró más de una vez.",
  "show.customers.hint": "Con {plan} ves quiénes son, los agrupás y les mandás un cupón para que vuelvan.",
  "show.customers.verb": "Ver quiénes te compraron",
  "show.emails.title": "Emails a tus clientes",
  "show.emails.number": "{count} clientes y seguidores recibirían tu novedad.",
  "show.emails.number_one": "1 cliente o seguidor recibiría tu novedad.",
  "show.emails.hint": "Con {plan} les escribís {emails} veces por mes desde pokefans.",
  "show.emails.verb": "Escribirles",
  "show.price.title": "Tu precio contra el mercado",
  "show.price.number": "{count} de tus publicaciones están arriba de la mediana del mercado.",
  "show.price.number_one": "1 de tus publicaciones está arriba de la mediana del mercado.",
  "show.price.hint": "Con {plan} ves cuáles y por cuánto, y cuánto tardás en responder y en despachar.",
  "show.price.verb": "Ver cuáles",
  "show.feature.title": "Destacados",
  "show.feature.number": "Una publicación tuya tiene {count} favoritos y ninguna venta.",
  "show.feature.number_one": "Una publicación tuya tiene 1 favorito y ninguna venta.",
  "show.feature.hint": "Con {plan} la destacás 7 días arriba de los resultados del mercado.",
  "show.feature.verb": "Destacarla",
  "show.first_sale.title": "Vendiste. ¿Querés que te vuelvan a comprar?",
  "show.first_sale.number": "{count} personas ya te compraron.",
  "show.first_sale.number_one": "Alguien ya te compró: lo difícil está hecho.",
  "show.first_sale.hint": "A quien ya te compró le cuesta menos volver. Con {plan} ves quiénes son y les mandás un cupón y tus novedades.",
  "show.first_sale.verb": "Ver quiénes te compraron",
  "show.coupons.title": "Cupones para tu tienda",
  "show.coupons.number": "Un cupón de bienvenida trae de vuelta a quien miró y no compró.",
  "show.coupons.sample": "10% en tu tienda",
  "show.coupons.hint": "Con {plan} creás tu cupón y lo compartís: quien lo usa paga menos en tu tienda.",
  "show.coupons.verb": "Crear mi cupón",
  "show.shop.tagline": "Tu frase, tu color y tu logo",
  "show.shop.number": "Así se vería tu tienda con banner, logo y color propios.",
  "show.shop.links": "Tus {count} redes quedan arriba de todo.",
  "show.shop.links_one": "Tu red queda arriba de todo.",
  "show.shop.verb": "Personalizar mi tienda",
  "offer.featureFirst": "{count} personas la tienen en favoritos: destacala antes de bajar el precio.",
  "offer.featured": "¡Listo! Queda destacada 7 días.",
  "limit.listingTitle": "Esta carta no entra",
  "limit.listingText": "Tenés {live} publicaciones activas, el máximo del plan {plan}.",
  "limit.listingNext": "Con {plan} publicás esta y {more} más.",
  "limit.listingNextNoLimit": "Con {plan} publicás sin límite.",
  "limit.featured": "Y destacás {count} por mes.",
  "limit.priceTitle": "Esta carta vale más de lo que tu plan permite",
  "limit.priceText": "El plan {plan} permite publicaciones de hasta {max}.",
  "limit.priceNext": "Con {plan} publicás hasta {max}.",
  "limit.priceNextNoLimit": "Con {plan} publicás a cualquier precio.",
  "limit.saved": "Quedó guardada, pausada: no se pierde nada.",
  "limit.upgrade": "Pasar a {plan}",
  "limit.pauseOther": "Pausar otra publicación",
  "limit.lowerPrice": "Bajar el precio",
  "nl.quota": "{live} de {max} publicaciones activas",
  "nl.quotaLow": "Te quedan {count} publicaciones. Las cartas que no publicás no se venden.",
  "nl.quotaLow_one": "Te queda 1 publicación. Las cartas que no publicás no se venden.",
  "todo.offers": "Ofertas por responder",
  "mkt.tab.inicio": "Inicio",
  "mkt.tab.mas": "Más",
  "mkt.tab.pedidos": "Pedidos",
  "mkt.tab.plan": "Plan",
  "mkt.tab.tienda": "Tienda",
  "sp.toSite": "Volver a pokefans.fun",
  "sig.views": "{count} visitas en 30 días",
  "sig.views_one": "1 visita en 30 días",
  "sig.above": "{pct}% arriba del mercado",
  "sig.noViews": "Sin visitas en 30 días",
  "sig.wanting": "{count} la buscan",
  "sig.wanting_one": "1 la busca",
  "sig.seeWanted": "Ver quién la busca",
  "lst.more": "Más acciones",
  "sp.search": "Buscar en mi tienda",
  "sp.searchHint": "Pedido, comprador o carta ( / )",
  "sp.searchNone": "Nada con eso en tu tienda.",
  "sp.bell": "Avisos",
  "sp.bellCount": "{count} cosas para hacer",
  "sp.bellCount_one": "1 cosa para hacer",
  "sp.bellAll": "Ver todo en Inicio",
  "home.week": "Últimos 7 días",
  "home.orders": "{count} ventas",
  "home.orders_one": "1 venta",
  "home.views": "{count} visitas",
  "home.views_one": "1 visita",
  "home.shop": "Tu tienda",
  "home.liveOf": "{live} de {max} publicaciones activas",
  "home.live": "{count} publicaciones activas",
  "home.live_one": "1 publicación activa",
  "home.noViews": "{count} sin visitas en 30 días",
  "home.noViews_one": "1 sin visitas en 30 días",
  "home.publish": "Publicar carta",
  "home.import": "Importar planilla",
  "home.seeShop": "Ver mi tienda",
  "home.plan": "Plan {plan}",
  "home.planListings": "{live}/{max} publicaciones",
  "home.planFeatured": "{count} destacados disponibles",
  "home.planFeatured_one": "1 destacado disponible",
  "home.seePlans": "Ver planes",
  "home.planEnding": "Tu plan {plan} termina el {date}.",
  "home.start": "Para tu primera venta",
  "home.startMp": "Conectá Mercado Pago",
  "home.startListings": "Publicá {max} cartas ({live} de {max})",
  "home.startVerify": "Pedí la verificación",
  "home.startShare": "Compartí el link de tu tienda",
  "home.pendingReview": "Estamos revisando tu pedido para vender.",
  "home.pendingPrepare": "Prepará tus publicaciones",
  "home.pendingSettings": "Configurá cobro y entrega",
  "acct.shopNone": "¿Tenés cartas para vender?",
  "acct.shopOpen": "Abrí tu tienda",
  "acct.shopPending": "en revisión",
  "acct.shopTodo": "{count} cosas para hacer hoy",
  "acct.shopTodo_one": "1 cosa para hacer hoy",
  "acct.shopAllDone": "todo al día",
  "acct.shopGo": "Ir a mi tienda",
  "todo.meeting": "Entregas acordadas para hoy o mañana",
  "todo.connectMp": "Conectá Mercado Pago para cobrar con tarjeta",
  "todo.soldout": "Publicaciones sin stock",
  "todo.couponEnding": "Cupones que vencen en 48 horas",
  "todo.verify": "Pedí el sello de Verificado",
  "todo.allDone": "Todo al día ✓",
  "todo.all": "Ver todas ({count})",
  "todo.fewer": "Ver menos",
  "todo.dismiss": "Ocultar: {task}",
  "todo.dismissHint": "Ocultar esta tarea (vuelve si llega algo nuevo)",
  "todo.dismissFailed": "No se pudo. Probá de nuevo.",
  "todo.hidden": "{count} tareas ocultas.",
  "todo.hidden_one": "1 tarea oculta.",
  "todo.restore": "Volver a mostrar",
  "todo.seeSales": "Ver en Ventas",
  "qa.title": "Acciones rápidas",
  "qa.reserve": "Reservar para un cliente",
  "qa.coupon": "Crear cupón",
  "qa.copy": "Copiar link de la tienda",
  "qa.copied": "¡Link copiado!",
  "qa.locked": "{action}: disponible en {plan}",
  "home.followers": "{count} seguidores nuevos",
  "home.followers_one": "1 seguidor nuevo",
  "home.weeksChart": "Ventas de las últimas 8 semanas",
  "home.soldOut": "{count} sin stock",
  "home.soldOut_one": "1 sin stock",
  "home.opportunities": "Oportunidades",
  "home.recentOrders": "Últimas ventas",
  "home.recentMessages": "Últimos mensajes",
  "home.next.confirm": "Confirmar pago",
  "home.next.deliver": "Entregar",
  "home.next.view": "Ver",
  "home.next.reply": "Responder",
  "home.reviewTitle": "Para que te aprobemos",
  "home.reviewPhoto": "Mandá la foto de verificación",
  "home.reviewPayment": "Elegí cómo te pagan",
  "home.reviewDelivery": "Elegí cómo entregás",
  "home.reviewListings": "Prepará tus primeras publicaciones",
  "home.reviewListingsCap": "Prepará tus primeras publicaciones (al aprobarte se publican hasta {n} con tu plan)",
  "guide.progress": "{done} de {total}",
  "guide.progressLabel": "Avance de la guía de inicio",
  "guide.optional": "opcional",
  "guide.recommended": "recomendado",
  "guide.ownerDoes": "Esto lo hace el dueño de la tienda.",
  "guide.toSettings": "Ir a Ajustes",
  "guide.publish": "Publicar una carta",
  "guide.photoWhy": "Una foto de una carta tuya con tu @usuario y la fecha escritos a mano: así sabemos que la tienda es tuya. Solo la ve el equipo de pokefans.",
  "guide.photoCta": "Subir la foto",
  "guide.paymentWhy": "Sin un medio de cobro nadie te puede comprar: transferencia, Mercado Pago, cripto o efectivo en mano.",
  "guide.deliveryWhy": "El comprador elige entre lo que ofrezcas: envío, en mano, retiro o a convenir.",
  "guide.firstListingWhy": "Las cargás ahora y salen a la venta apenas aprobemos la tienda.",
  "guide.bio": "Contá quién sos",
  "guide.bioWhy": "Unas líneas sobre vos o tu tienda (desde {n} letras) le dan confianza a quien te compra por primera vez.",
  "guide.bioCta": "Escribir la presentación",
  "guide.listingsWhy": "Las tiendas con pocas cartas casi no reciben visitas.",
  "guide.mpWhy": "Con Mercado Pago tus compradores pagan con Compra protegida: les da más confianza para comprarle a una tienda nueva.",
  "guide.mpCta": "Conectar Mercado Pago",
  "guide.verifyWhy": "El sello 🪪 Verificado les muestra a los compradores que revisamos tu tienda.",
  "guide.verifyCta": "Pedir la verificación",
  "guide.dismiss": "Cerrar la guía",
  "guide.dismissFailed": "No pudimos cerrar la guía. Probá de nuevo.",
  "csv.title": "Exportar pedidos",
  "csv.hint": "Un archivo para Excel con tus pedidos de esas fechas (hasta un año), con el comprador, el medio de pago y los montos.",
  "csv.from": "Desde",
  "csv.to": "Hasta",
  "csv.download": "Descargar para Excel",
  "csv.teaser": "Exportar tus pedidos a Excel: disponible en {plan}.",
  "mkt.plan.rowInsights": "Embudo por publicación, precio contra el mercado y exportar pedidos",
  "mkt.plan.rowCoupons": "Cupones de descuento activos (EX: para toda la tienda; VMAX: también por cartas, set, grupo de clientes o cliente)",
  "st.period": "Período",
  "st.period30": "30 días",
  "st.period90": "90 días",
  "st.periodAll": "Desde el principio",
  "st.sales": "Ventas completadas",
  "st.revenue": "{amount} en cartas",
  "st.avgTicket": "Ticket promedio",
  "st.views": "Visitas a tus publicaciones",
  "st.viewsSince": "desde el {date}",
  "st.viewsNone": "todavía ninguna",
  "st.offers": "Ofertas recibidas",
  "st.offersAccepted": "{count} aceptadas",
  "st.offersAccepted_one": "1 aceptada",
  "st.salesNote": "Las ventas se cuentan el día que se completan y los montos son lo que vendiste en cartas, sin envío. Las visitas son a la página de cada publicación (no cuentan las tuyas).",
  "st.tabSummary": "Resumen",
  "st.pricesToday": "Precios de hoy, contra las publicaciones activas de otras tiendas para la misma carta, estado, idioma y terminación (sin gradeadas).",
  "st.cancelledNote": "{count} cancelados",
  "st.cancelledNote_one": "1 cancelado",
  "st.avgTicketNote": "por venta completada",
  "st.nowLabel": "Ahora:",
  "st.nowOrders": "{count} pedidos en curso",
  "st.nowOrders_one": "1 pedido en curso",
  "st.nowFavorites": "{count} guardadas como favoritas",
  "st.nowFavorites_one": "1 guardada como favorita",
  "st.nowFollowers": "{count} seguidores",
  "st.nowFollowers_one": "1 seguidor",
  "st.repTimes": "Tu reputación y tus tiempos",
  "st.repHint": "Lo que ven los compradores, de los últimos 90 días.",
  "ins.recent": "Tus tiempos de los últimos 30 días",
  "st.howWeCount": "¿Cómo contamos?",
  "perf.needsPush": "Necesitan un empujón",
  "st.lockedFunnel": "Con {plan} ves de cada publicación cuántas visitas terminan en venta.",
  "st.lockedFunnelVerb": "Ver mi embudo",
  "st.lockedPush": "Con {plan} ves cuáles no mira nadie y cuáles guardan pero no compran, con el botón para pausarlas o destacarlas.",
  "st.lockedPushVerb": "Ver cuáles",
  "st.lockedPrices": "Con {plan} ves cada publicación contra la mediana del mercado.",
  "st.lockedPricesVerb": "Ver mis precios",
  "st.chartWeeks": "Ventas por semana",
  "st.chartMonths": "Ventas por mes",
  "st.chartEmpty": "Todavía no hay ventas completadas en este período.",
  "st.bar": "{when}: {count} ventas, {amount}",
  "st.bar_one": "{when}: 1 venta, {amount}",
  "st.response": "Respondés en",
  "st.cancelPct": "Cancelaciones tuyas",
  "st.onTimePct": "Envíos a tiempo",
  "st.top": "Tus publicaciones más vistas",
  "st.topNone": "Todavía no tenés publicaciones.",
  "st.colViews": "Visitas",
  "st.colFavorites": "Favoritas",
  "st.colSold": "Vendidas",
  "st.pricing": "Mejorá tu precio",
  "st.pricingNone": "Ninguna: en lo que publicaste, nadie tiene la misma carta más barata.",
  "st.pricingRow": " · Vos: {mine} · {count} más baratas, desde {min}.",
  "st.pricingRow_one": " · Vos: {mine} · 1 más barata, a {min}.",
  "st.pricingStore": "La tienda la tiene a {store}.",
  "st.demand": "Quién busca tus cartas",
  "st.demandHint": "Gente que marcó \"La busco\" en cartas que tenés publicadas. No mostramos quiénes son.",
  "st.demandNone": "Por ahora nadie marcó \"La busco\" en tus cartas.",
  "st.demandRow": " · {count} la buscan · vos: {price}.",
  "st.demandRow_one": " · 1 persona la busca · vos: {price}.",
  "st.demandBelow": "{count} pagarían menos que tu precio (el más alto, {max}).",
  "st.demandBelow_one": "1 pagaría menos que tu precio ({max}).",
  "mkt.tab.compras": "Compras",
  "mkt.tab.favoritos": "Favoritos",
  "mkt.tab.busco": "Busco",
  "mkt.tab.seguidos": "Seguidos",
  "mkt.applyTitle": "Vendé tus cartas",
  "mkt.applyIntro": "Abrí tu tienda en el mercado de la comunidad. Revisamos cada solicitud a mano.",
  "mkt.applyPoint1": "Cobrás directo: tu Mercado Pago, transferencia o cripto. Sin comisiones.",
  "mkt.applyPoint2": "Elegís cómo entregar: en mano en CABA y GBA, envío, punto de retiro o a convenir.",
  "mkt.applyPoint3": "Cartas sueltas y productos sellados originales tuyos (sobres, ETB, cajas, mazos y colecciones). Nada de proxies, falsificaciones ni sellados reabiertos.",
  "mkt.rejected": "No aprobamos tu solicitud anterior. {reason}",
  "mkt.handle": "Nombre de usuario de tu tienda",
  "mkt.handleHint": "3 a 20 letras minúsculas, números o _. Queda en pokefans.fun/vendedores/…",
  "mkt.handleError": "Usá de 3 a 20 letras minúsculas, números o _.",
  "mkt.handleTaken": "Ese nombre ya está tomado.",
  "mkt.shopName": "Nombre visible",
  "mkt.contactPhone": "Teléfono de contacto",
  "mkt.contactPhoneHint": "No es público: lo ve el comprador recién cuando te paga.",
  "mkt.socialUrl": "Link de una red social o tienda (opcional)",
  "mkt.socialUrlHint": "Compartí algún link de red social que nos deje corroborar que sos vendedor o coleccionista (Instagram, Facebook, TikTok, Mercado Libre, Cardmarket…). Si no tenés, igual podemos aprobarte, con límites: solo efectivo y entrega en mano hasta tus primeras ventas.",
  "mkt.socialUrlError": "Poné un link válido, por ejemplo instagram.com/tu_usuario.",
  "mkt.kind": "¿Quién vende?",
  "mkt.kindPerson": "Una persona",
  "mkt.kindPersonHint": "Vendés a tu nombre (también si sos monotributista). Te pedimos una foto de verificación y tu fecha de nacimiento.",
  "mkt.kindCompany": "Una empresa",
  "mkt.kindCompanyHint": "Una sociedad con razón social y CUIT (empieza con 30, 33 o 34). Los compradores ven la razón social y el CUIT en tu tienda.",
  "mkt.legalName": "Razón social",
  "mkt.legalNameError": "Poné la razón social, como figura en ARCA.",
  "mkt.cuit": "CUIT de la empresa",
  "mkt.cuitError": "Revisá el CUIT: tiene que ser de una empresa (30, 33 o 34) y de 11 números.",
  "mkt.companyReview": "Revisamos la razón social y el CUIT de tu empresa: no hace falta foto de verificación.",
  "mkt.companyLine": "Empresa: {name} · CUIT {cuit}",
  "mkt.birthDate": "Fecha de nacimiento",
  "mkt.birthDateHint": "Para vender tenés que ser mayor de 18 años. No es pública: solo la ve el equipo de pokefans.fun.",
  "mkt.birthDateError": "Ingresá una fecha de nacimiento válida.",
  "mkt.birthDateMinor": "Para vender en el mercado tenés que tener 18 años o más.",
  "mkt.province": "Provincia",
  "mkt.bio": "Sobre vos (público)",
  "mkt.applyNote": "¿Algo para nosotros?",
  "mkt.applyNoteHint": "Qué vas a vender, si ya vendés en otro lado (Instagram, grupos, eventos)…",
  "mkt.acceptSellerTerms": "Acepto los",
  "mkt.applyError": "Revisá los datos marcados.",
  "mkt.verifyTitle": "Verificación",
  "mkt.verifyPhoto": "Foto de verificación",
  "mkt.verifyPhotoHint": "Sacale una foto a tu carta más valiosa al lado de un papel escrito a mano con tu @usuario de la tienda y la fecha de hoy. Solo la vemos nosotros, para aprobarte.",
  "mkt.verifyPhotoError": "No pudimos subir la foto: probá con otra JPG, PNG o WebP.",
  "mkt.verifyPhotoMissingShort": "Falta la foto de verificación.",
  "mkt.verifyPhotoSent": "✅ Recibimos tu foto de verificación.",
  "mkt.verifyPhotoMissing": "Falta tu foto de verificación: sin ella no podemos aprobarte.",
  "mkt.verifyPhotoUpload": "Subir foto de verificación",
  "mkt.verifyPhotoChange": "Cambiar la foto de verificación",
  "mkt.verifySocialMissing": "Si tenés una red social donde se vea que vendés o coleccionás, sumá el link (sin uno, podemos aprobarte con límites):",
  "mkt.verifySave": "Guardar link",
  "mkt.blockedApply": "No podemos aceptar esta solicitud. Si creés que es un error, escribinos.",
  "mkt.blockedBank": "No podemos aceptar esa cuenta bancaria. Si creés que es un error, escribinos.",
  "mkt.applySend": "Enviar solicitud",
  "mkt.newListing": "Publicar una carta o un sellado",
  "mkt.noListings": "Todavía no publicaste nada.",
  "mkt.findCard": "Buscá la carta o el producto en el catálogo",
  "mkt.findCardHint": "Nombre, set o número (ej: charizard 151, pikachu 25)",
  "mkt.noCardFound": "No la encontramos. Probá con otro nombre o el número.",
  "mkt.searchCards": "Buscar",
  "mkt.pickKind": "Tipo",
  "mkt.pickKindAll": "Todo (cartas y sellados)",
  "mkt.pickSet": "Set",
  "mkt.pickSetAll": "Todos los sets",
  "mkt.seeAllCards": "Ver todas las cartas de \"{q}\"",
  "mkt.cardResults": "{count} resultados para \"{q}\". Tocá la que es.",
  "mkt.cardResults_one": "1 resultado para \"{q}\". Tocá la que es.",
  "mkt.cardResultsFuzzy": "No encontramos \"{q}\" tal cual; te mostramos {count} parecidas.",
  "mkt.cardResultsFuzzy_one": "No encontramos \"{q}\" tal cual; te mostramos 1 parecida.",
  "mkt.closeResults": "Cerrar resultados",
  "mkt.moreCards": "Ver más",
  "mkt.changeCard": "Cambiar carta",
  "mkt.grader": "Gradeo",
  "mkt.notGraded": "Sin gradear",
  "mkt.grade": "Nota",
  "mkt.priceArs": "Precio por unidad ($)",
  "mkt.listingNotes": "Detalles (opcional)",
  "mkt.sealedNote": "Producto sellado: tiene que ser original y estar cerrado de fábrica (nada de sobres resellados ni pesados).",
  "nl.progress": "Pasos para publicar",
  "nl.id.button": "Identificar con una foto",
  "nl.id.reading": "Leyendo la carta…",
  "nl.id.pick": "¿Es alguna de estas?",
  "nl.id.none": "No encontramos esa carta en el catálogo: buscala por nombre o número.",
  "nl.id.ocr_failed": "No pudimos leer la carta. Probá con mejor luz, más cerca y sin reflejos.",
  "nl.id.unsupported_language": "Por ahora solo reconocemos cartas en español o inglés.",
  "nl.id.unsupported_image": "No se pudo abrir la foto. Probá con otra.",
  "nl.id.image_too_large": "La foto es muy grande.",
  "nl.id.rate_limited": "Demasiadas fotos seguidas: probá en un minuto.",
  "nl.id.error": "No se pudo leer la foto. Probá de nuevo o buscala por nombre.",
  "nl.step1": "¿Qué carta?",
  "nl.step2": "¿Cómo está?",
  "nl.step3": "¿Cuánto?",
  "nl.graded": "Está gradeada",
  "nl.more": "Más opciones (acabado, detalles)",
  "nl.next": "Siguiente",
  "nl.back": "Atrás",
  "nl.less": "Una menos",
  "nl.more1": "Una más",
  "nl.repeat": "Igual que la anterior: {what}",
  "nl.sealedShort": "Sellado",
  "nl.repeatHint": "Mismo precio y cantidad que la anterior: fijate que le quede bien a esta carta.",
  "nl.publish": "Publicar",
  "nl.save": "Guardar (se publica cuando te aprobemos)",
  "nl.publishing": "Publicando…",
  "nl.openSaved": "Quedó guardada, pausada: abrila",
  "nl.savedPaused": "Quedó guardada, pausada, pero no se pudo terminar. Probá de nuevo.",
  "nl.doneLive": "Publicada",
  "nl.donePending": "Guardada: se publica cuando te aprobemos",
  "nl.another": "Publicar otra",
  "nl.addPhotos": "Agregar fotos",
  "nl.see": "Ver publicación",
  "nl.close": "Cerrar",
  "nl.refNone": "Todavía nadie la vende en pokefans.",
  "nl.refSale": "Última venta en pokefans: {price}",
  "nl.refMedian": "Mediana en pokefans {price}",
  "nl.refMin": "mínimo {price}",
  "nl.refSellers": "{count} vendedores",
  "nl.refSellers_one": "1 vendedor",
  "nl.photosOptional": "Fotos tuyas del estado de la carta (opcional)",
  "nl.errPrice": "Poné el precio.",
  "nl.errGrade": "Poné la nota del gradeo.",
  "mkt.listingError": "No se pudo crear. Revisá los datos.",
  "mkt.listingLimit": "Llegaste al límite de publicaciones activas de tu plan ({max}). Pausá alguna o pasate a un plan con más.",
  "mkt.priceLimit": "Tu plan permite publicaciones de hasta {max}. Para publicar más caro, pasate a un plan superior.",
  "mkt.plan.title": "Tu plan",
  "mkt.shop.title": "Tienda personalizada",
  "mkt.shop.teaser": "Banner, logo, frase y color propios, un texto largo «Sobre la tienda», links a tus redes y hasta {pins} cartas fijadas arriba de todo en tu página. Disponible en {plan}.",
  "mkt.shop.banner": "Banner",
  "mkt.shop.bannerUpload": "Subir banner",
  "mkt.shop.bannerChange": "Cambiar banner",
  "mkt.shop.bannerRemove": "Quitar",
  "mkt.shop.bannerHint": "Se recorta a 1600 × 400 (JPG, PNG o WebP).",
  "mkt.shop.bannerLink": "El banner lleva a",
  "mkt.shop.bannerLinkNone": "Ningún lado (solo imagen)",
  "mkt.shop.bannerLinkSection": "Tu sección «{name}»",
  "mkt.shop.bannerLinkListing": "Una de tus publicaciones…",
  "mkt.shop.bannerLinkTo": "Lleva a: {name}.",
  "mkt.shop.bannerLinkHidden": "Ahora no está a la venta: el banner no lleva a ningún lado hasta que vuelva.",
  "mkt.shop.bannerLinkChange": "Cambiar",
  "mkt.shop.bannerLinkPick": "Elegir para el banner: {name}",
  "mkt.shop.bannerLinkPickShort": "Elegir",
  "mkt.shop.bannerLinkHint": "Se guarda con «Guardar tienda». Si la sección queda vacía o la publicación deja de estar a la venta, el banner sigue, sin link.",
  "mkt.shop.bannerGo": "Ver {name}",
  "mkt.shop.bannerLinkError": "Revisá a dónde lleva el banner: esa sección o publicación ya no está.",
  "mkt.shop.about": "Sobre la tienda",
  "mkt.shop.aboutHint": "Texto simple, hasta {max} caracteres. Se ve en tu página pública.",
  "mkt.shop.aboutTitle": "Sobre la tienda",
  "mkt.shop.links": "Tus redes",
  "mkt.shop.linkN": "Link {n}",
  "mkt.shop.linksHint": "Instagram, TikTok, YouTube, Facebook, X, Twitch, Kick o Threads. No se aceptan WhatsApp ni links de pago.",
  "mkt.shop.linksError": "Revisá los links: solo perfiles de Instagram, TikTok, YouTube, Facebook, X, Twitch, Kick o Threads.",
  "mkt.shop.save": "Guardar tienda",
  "mkt.shop.saved": "Guardado.",
  "mkt.shop.logo": "Logo",
  "mkt.shop.logoUpload": "Subir logo",
  "mkt.shop.logoChange": "Cambiar logo",
  "mkt.shop.logoHint": "Cuadrado, se recorta a 512 × 512. Reemplaza tu foto en la página de la tienda.",
  "mkt.shop.tagline": "Frase debajo del nombre",
  "mkt.shop.taglinePlaceholder": "Sellados y singles de Escarlata y Púrpura",
  "mkt.shop.taglineHint": "Una línea, hasta {max} caracteres.",
  "mkt.shop.accent": "Color de tu tienda",
  "mkt.shop.accentNone": "Sin color",
  "mkt.shop.accentHint": "Se usa en el botón «Seguir» y en los títulos de tu página. Solo en tu tienda.",
  "mkt.shop.accent.rojo": "Rojo",
  "mkt.shop.accent.naranja": "Naranja",
  "mkt.shop.accent.dorado": "Dorado",
  "mkt.shop.accent.verde": "Verde",
  "mkt.shop.accent.turquesa": "Turquesa",
  "mkt.shop.accent.celeste": "Celeste",
  "mkt.shop.accent.azul": "Azul",
  "mkt.shop.accent.indigo": "Índigo",
  "mkt.shop.accent.violeta": "Violeta",
  "mkt.shop.accent.rosa": "Rosa",
  "mkt.shop.accent.marron": "Marrón",
  "mkt.shop.accent.grafito": "Grafito",
  "mkt.shop.pinsVacation": "Estás de vacaciones hasta el {date}: tu tienda no muestra nada hasta entonces. Tus destacadas están bien y vuelven solas.",
  "mkt.shop.announcementLabel": "Anuncio de la tienda",
  "mkt.shop.announcementSet": "en cartas de {set}",
  "mkt.shop.announcementProducts": "en cartas elegidas",
  "mkt.shop.announcementCopy": "Copiar código",
  "mkt.shop.announcementUntil": "Hasta el {date}",
  "mkt.shop.announcement": "Anuncio arriba de tu tienda",
  "mkt.shop.announcementText": "Texto del anuncio",
  "mkt.shop.announcementPlaceholder": "10% en todo el finde · Llegó Delta Reign",
  "mkt.shop.announcementHint": "Una línea, hasta {max} caracteres. Vacío: sin anuncio.",
  "mkt.shop.announcementCoupon": "Cupón (opcional)",
  "mkt.shop.announcementNoCoupon": "Sin cupón",
  "mkt.shop.announcementNoCoupons": "Para anunciar un cupón, creá uno para toda la tienda, unas cartas o un set en Clientes › Cupones.",
  "mkt.shop.announcementLast": "Último día (opcional)",
  "mkt.shop.announcementCouponOff": "Con este cupón el anuncio no se ve ahora (pausado, vencido, sin usos o todavía no empieza).",
  "mkt.shop.announcementRule": "Se oculta solo cuando pasa el último día o el cupón deja de funcionar (pausado, vencido o sin usos).",
  "mkt.shop.announcementError": "Revisá el anuncio: entre 3 y 120 caracteres, un cupón tuyo público y una fecha de hoy en adelante.",
  "mkt.shop.sectionMore": "Ver las {count}",
  "mkt.shop.search": "Buscar en {name}",
  "mkt.shop.allCards": "Todas sus cartas",
  "mkt.shop.closeFilters": "Cerrar filtros",
  "sec.title": "Secciones de tu tienda",
  "sec.hint": "Hasta {max}. Van debajo de las destacadas. Elegí qué muestra cada una; una sección sin cartas ahora no se ve.",
  "sec.n": "Sección {n}",
  "sec.up": "Subir la sección {n}",
  "sec.down": "Bajar la sección {n}",
  "sec.remove": "Quitar la sección {n}",
  "sec.type": "Qué muestra",
  "sec.type.sealed": "Sellados",
  "sec.type.newest": "Novedades",
  "sec.type.under": "Hasta un precio",
  "sec.type.graded": "Gradeadas",
  "sec.type.set": "Un set",
  "sec.type.coupon": "Con cupón",
  "sec.type.manual": "Elegidas a mano",
  "sec.title.under": "Hasta {price}",
  "sec.what.sealed": "Tus sobres, cajas y demás sellados.",
  "sec.what.newest": "Lo que publicaste en los últimos {days} días, lo más nuevo primero.",
  "sec.what.under": "Tus publicaciones hasta ese precio, de la más cara a la más barata.",
  "sec.what.graded": "Tus cartas gradeadas (PSA, Beckett, CGC, SGC…).",
  "sec.what.set": "Tus cartas de ese set.",
  "sec.what.coupon": "Las cartas que alcanza un cupón tuyo activo de cartas elegidas o de un set.",
  "sec.what.manual": "Hasta {max} publicaciones que elegís vos, en ese orden.",
  "sec.name": "Título",
  "sec.maxPrice": "Precio máximo ($)",
  "sec.set": "Set",
  "sec.add": "Agregar {name} a la sección",
  "sec.addShort": "Agregar",
  "sec.notLive": "{name} (pausada o sin stock: no se ve ahora)",
  "sec.count": "{count} publicaciones ahora.",
  "sec.count_one": "1 publicación ahora.",
  "sec.empty": "Ninguna ahora: esta sección no se va a ver hasta que tenga cartas.",
  "sec.addSection": "Agregar sección",
  "sec.error": "Revisá las secciones: un título de 2 a 40 letras, un precio, un set o al menos una publicación elegida.",
  "rsv.button": "Reservar para un cliente",
  "rsv.title": "Reservar para un cliente",
  "rsv.what": "Apartás «{name}» a un precio para una persona: te damos un link para mandarle por Instagram o WhatsApp, y la carta sale del mercado por {hours} horas. Quien abra el link primero la paga con la compra protegida de siempre.",
  "rsv.quantity": "Cantidad",
  "rsv.price": "Precio por unidad ($)",
  "rsv.priceHint": "Hasta el precio publicado ({price}).",
  "rsv.note": "Nota para el comprador (opcional)",
  "rsv.notePlaceholder": "La que hablamos por Instagram 🙌",
  "rsv.create": "Reservar y crear link",
  "rsv.cancelForm": "Cancelar",
  "rsv.done": "Listo: la carta queda apartada {hours} horas. Mandale este link a tu cliente:",
  "rsv.doneHint": "Si nadie la paga a tiempo, vuelve sola a tu stock. La podés cancelar desde Publicaciones.",
  "rsv.close": "Listo",
  "rsv.copy": "Copiar link",
  "rsv.waText": "Te reservé la carta en pokefans.fun, la pagás desde acá: {url}",
  "rsv.errPrice": "La reserva va al precio publicado ({price}) o menos.",
  "rsv.errStock": "Solo quedan {count} para reservar.",
  "rsv.errLimit": "Tu plan permite {max} reservas activas a la vez. Cancelá una o esperá a que termine.",
  "rsv.listTitle": "Reservas para clientes",
  "rsv.st.open": "Esperando que la tomen · vence el {date}",
  "rsv.st.claimed": "La tomó {name}, falta que pague · vence el {date}",
  "rsv.st.used": "La compró {name} (pedido {order})",
  "rsv.st.expired": "Venció: volvió a tu stock",
  "rsv.st.cancelled": "Cancelada: volvió a tu stock",
  "rsv.cancel": "Cancelar reserva",
  "rsv.confirmCancel": "¿Cancelar la reserva? La carta vuelve a tu stock y el link deja de andar.",
  "rsv.viewOrder": "Ver pedido",
  "rsv.stockHint": "Además hay {count} apartadas para un cliente: no las sumes acá, vuelven solas si no las paga.",
  "rsv.stockHint_one": "Además hay 1 apartada para un cliente: no la sumes acá, vuelve sola si no la paga.",
  "rsv.rowPill": "{count} reservadas",
  "rsv.rowPill_one": "1 reservada",
  "rsv.pillSeller": "Reserva tuya",
  "rsv.pillBuyer": "Te la reservaron",
  "rsv.pageTitle": "Una carta reservada para vos",
  "rsv.pageWhat": "{seller} te apartó esta carta. La reserva vence el {date}.",
  "rsv.pagePrice": "{count} × {price}",
  "rsv.pageListed": "(publicada a {price})",
  "rsv.buy": "Comprarla",
  "rsv.signInToBuy": "Ingresar para comprarla",
  "rsv.pageHint": "Pagás con la compra protegida del mercado, como cualquier otra compra.",
  "rsv.unavailable": "Esta reserva no está disponible: ya la tomó otra persona, venció o la cancelaron.",
  "rsv.toMarket": "Ir al mercado",
  "mkt.shop.pins": "Destacadas en tu tienda",
  "mkt.shop.pinsHint": "Fijá hasta {max} publicaciones arriba de todo en tu página, en este orden. Es gratis con tu plan: no usa los «Destacar 7 días» del mes ni cambia el orden del mercado.",
  "mkt.shop.pinsTitle": "Destacadas",
  "mkt.shop.pinUp": "Subir {name}",
  "mkt.shop.pinDown": "Bajar {name}",
  "mkt.shop.pinRemove": "Quitar {name}",
  "mkt.shop.pinsHidden": "{count} destacadas no se ven ahora (pausadas o sin stock): vuelven solas cuando estén activas.",
  "mkt.shop.pinsHidden_one": "1 destacada no se ve ahora (pausada o sin stock): vuelve sola cuando esté activa.",
  "mkt.shop.pinsDropHidden": "Quitarlas",
  "mkt.shop.pinSearch": "Buscá entre tus publicaciones",
  "mkt.shop.pinAdd": "Fijar arriba: {name}",
  "mkt.shop.pinAddShort": "Fijar arriba",
  "mkt.shop.pinNone": "No hay más publicaciones activas con esa búsqueda.",
  "mkt.shop.pinsFull": "Ya tenés {max} fijadas. Quitá una para sumar otra.",
  "mkt.shop.preview": "Vista previa",
  "mkt.shop.previewWidth": "Ancho de la vista previa",
  "mkt.shop.previewPhone": "Celular",
  "mkt.shop.previewDesktop": "Computadora",
  "mkt.shop.previewClose": "Cerrar",
  "mkt.shop.previewNote": "Así la ve un comprador, con los cambios sin guardar. Guardá para publicarlos.",
  "mkt.shop.previewOff": "Vista previa",
  "mkt.shop.viewAsBuyer": "Ver como comprador",
  "mkt.plan.current": "Plan {plan}.",
  "mkt.plan.noLimit": "Sin límite",
  "mkt.plan.listingsNoLimit": "Publicaciones activas: {live} (sin límite).",
  "mkt.plan.rowListings": "Publicaciones activas",
  "mkt.plan.rowPrice": "Precio máximo por publicación",
  "mkt.plan.rowBadge": "Insignia en tu tienda",
  "mkt.plan.rowSupport": "Soporte prioritario por WhatsApp y verificación con prioridad (respuesta en el día hábil; la verificación es gratis en todos los planes)",
  "mkt.verify.title": "Verificación",
  "mkt.verify.done": "Tu tienda está verificada: los compradores ven 🪪 Verificado.",
  "mkt.verify.what": "Con la verificación los compradores ven 🪪 Verificado en tu tienda, y dejás de tener los límites de vendedor nuevo. Es gratis.",
  "mkt.verify.ask": "Pedir verificación",
  "mkt.verify.requested": "Pediste la verificación el {date}: la revisamos y te avisamos.",
  "mkt.verify.requestedPriority": "Pediste la verificación el {date}. Tenés prioridad: te respondemos en el día hábil.",
  "mkt.verify.priority": "Con tu plan tenés prioridad: te respondemos en el día hábil.",
  "mkt.support.title": "Soporte prioritario",
  "mkt.support.text": "Escribinos por WhatsApp y te atendemos primero.",
  "mkt.support.button": "Escribir por WhatsApp",
  "mkt.support.message": "Hola, soy @{handle} (plan {plan}) del mercado de pokefans.fun.",
  "mkt.plan.rowDemand": "Aviso al instante cuando buscan tus cartas, resumen diario de Se busca y tablero de demanda",
  "mkt.demand.title": "Lo que buscan",
  "mkt.demand.teaser": "Te avisamos al instante cuando alguien busca una carta que vendés, y ves qué cartas busca la gente. Disponible en {plan}.",
  "mkt.demand.intro": "Cartas que la gente agregó a «La busco» en los últimos 30 días. Nunca mostramos quién ni a qué precio.",
  "mkt.demand.empty": "Nadie agregó cartas a «La busco» en los últimos 30 días.",
  "mkt.demand.wanting": "La buscan {count} personas",
  "mkt.demand.wanting_one": "La busca 1 persona",
  "mkt.demand.market": "{count} publicaciones desde {price}",
  "mkt.demand.market_one": "1 publicación a {price}",
  "mkt.demand.nobody": "nadie la vende",
  "mkt.demand.mine": "la tenés publicada",
  "mkt.plan.rowFeatured": "Publicaciones destacadas por mes (7 días cada una)",
  "mkt.feature.label": "Destacado",
  "mkt.feature.stripTitle": "Destacados",
  "mkt.feature.button": "Destacar 7 días (te quedan {count})",
  "mkt.feature.until": "Destacada hasta el {date}",
  "mkt.feature.done": "¡Listo! Queda destacada 7 días.",
  "mkt.feature.newSeller": "Podés destacar publicaciones cuando dejes de ser vendedor nuevo (30 días y 5 ventas) o te verifiquemos.",
  "mkt.feature.noneLeft": "Ya usaste los destacados de este mes.",
  "mkt.plan.rowUsd": "Precios en dólares",
  "mkt.plan.rowCustomShop": "Tienda personalizada (banner, texto y redes)",
  "mkt.plan.founder": "Gratis por ser fundador: 6 meses desde que lancemos los planes pagos.",
  "mkt.plan.until": "Hasta el {date}.",
  "mkt.plan.listings": "Publicaciones activas: {live} de {max}.",
  "mkt.plan.over": "Tenés {live} publicaciones activas y tu plan permite {max}: no se baja ninguna, pero no podés activar nuevas hasta bajar de {max}.",
  "mkt.plan.ask": "Quiero {plan}",
  "mkt.plan.renew": "Quiero seguir con {plan}",
  "mkt.plan.requested": "Pediste el plan {plan}: te escribimos con el precio y cómo pagar.",
  "bulk.open": "Editar precios",
  "bulk.title": "Editar precios de varias publicaciones",
  "bulk.search": "Buscar",
  "bulk.searchHint": "Nombre, set o número",
  "bulk.status": "Mostrar",
  "bulk.statusAll": "Todas",
  "bulk.statusActive": "Activas",
  "bulk.statusPaused": "En pausa",
  "lf.title": "Filtrar publicaciones",
  "lf.search": "Buscar en mis publicaciones",
  "lf.sort": "Ordenar",
  "lf.sort.recent": "Más nuevas",
  "lf.sort.price_asc": "Precio: menor a mayor",
  "lf.sort.price_desc": "Precio: mayor a menor",
  "lf.sort.name": "Nombre",
  "lf.more": "Más filtros",
  "lf.less": "Menos filtros",
  "lf.set": "Set",
  "lf.allSets": "Todos los sets",
  "lf.kind": "Tipo",
  "lf.kind.all": "Todo",
  "lf.kind.singles": "Cartas sueltas",
  "lf.kind.graded": "Gradeadas",
  "lf.kind.sealed": "Sellados",
  "lf.show.all": "Todas",
  "lf.show.live": "A la venta",
  "lf.show.soldout": "Agotadas",
  "lf.show.paused": "En pausa",
  "lf.show.reserved": "Con reserva",
  "lf.min": "Precio desde",
  "lf.max": "Precio hasta",
  "lf.count": "{shown} de {total}",
  "lf.clear": "Limpiar filtros",
  "lf.none": "Ninguna publicación coincide con los filtros.",
  "bulk.op": "Cambio",
  "bulk.op.pct_down": "Bajar un %",
  "bulk.op.pct_up": "Subir un %",
  "bulk.op.sub": "Restar pesos",
  "bulk.op.add": "Sumar pesos",
  "bulk.op.set": "Poner un precio",
  "usd.toggle": "Precio en dólares (los pesos siguen al dólar blue cada día)",
  "usd.price": "Precio (US$)",
  "usd.today": "Hoy son {ars}. Se actualiza solo cada noche con el dólar blue.",
  "usd.hint": "Escribí el precio en dólares, por ejemplo 12,50.",
  "usd.noRate": "Ahora no tenemos el dólar del día; probá más tarde.",
  "usd.planEnded": "Tu plan ya no incluye precios en dólares: quedó fijo en pesos. Guardá un precio en pesos o volvé a un plan que lo tenga.",
  "usd.offHint": "Guardar un precio en pesos deja de seguir al dólar.",
  "usd.heldCap": "Hoy no siguió al dólar: quedó en el precio más alto de tu plan.",
  "bulk.op.dollar": "Ajustar al dólar",
  "bulk.usdListing": "Tiene precio en dólares: ya sigue al dólar sola. Se cambia desde la publicación.",
  "bulk.dollarToday": "Dólar blue de hoy: {rate} (actualizado el {date}).",
  "bulk.dollarTodayNoDate": "Dólar blue de hoy: {rate}.",
  "bulk.dollarNothing": "El dólar no se movió desde que pusiste estos precios: no hay nada que ajustar.",
  "bulk.dollarNoRate": "Ahora no tenemos el dólar del día; probá más tarde.",
  "bulk.dollarLoading": "Buscando el dólar de hoy…",
  "bulk.dollarHow": "Cada precio sube o baja lo mismo que el dólar desde que lo pusiste. Nada cambia hasta que guardes.",
  "bulk.dollarThen": "dólar al ponerlo {rate}",
  "bulk.dollarUnknown": "No sabemos el dólar de cuando lo pusiste: queda igual.",
  "bulk.overCap": "Pasaría el tope de tu plan ({max}): no se cambia.",
  "bulk.openDollar": "Ajustar al dólar",
  "bulk.valuePct": "Porcentaje",
  "bulk.valueArs": "Pesos",
  "bulk.round": "Redondear",
  "bulk.roundNone": "Sin redondear",
  "bulk.roundTo": "A {amount}",
  "bulk.none": "No hay publicaciones con ese filtro.",
  "bulk.selectAll": "Seleccionar todas las que se ven",
  "bulk.select": "Seleccionar {name}",
  "bulk.price": "Precio",
  "bulk.paused": "en pausa",
  "bulk.invalid": "Ese cambio no se puede aplicar a este precio: no se cambia.",
  "bulk.selected": "{count} seleccionadas",
  "bulk.selected_one": "1 seleccionada",
  "bulk.save": "Guardar {count} precios",
  "bulk.save_one": "Guardar 1 precio",
  "bulk.close": "Cerrar",
  "bulk.updated": "{count} precios actualizados",
  "bulk.updated_one": "1 precio actualizado",
  "bulk.skippedPrice": "{count} sin cambiar (pasan el precio máximo de tu plan)",
  "bulk.skippedGone": "{count} ya no existen",
  "bulk.skippedGone_one": "1 ya no existe",
  "imp.open": "Cargar muchas con una planilla",
  "imp.title": "Cargar con una planilla",
  "imp.intro": "Copiá las filas de tu Excel o Google Sheets (con la fila de títulos) y pegalas acá, o subí un CSV. Hasta {max} filas por vez.",
  "imp.help1": "Columnas: Carta, Set, Número, Estado, Idioma, Terminación, Gradeo, Precio, Cantidad y Notas. Alcanza con Carta (o Set y Número) y Precio.",
  "imp.helpGame": "¿Vendés más de un juego? Sumá una columna Juego ({games}); sin ella buscamos la carta en todos.",
  "imp.help2": "Estado: NM, LP, MP, HP, DMG o Sellado; los productos sellados no lo necesitan. Idioma en blanco = español.",
  "imp.help3": "Se publican al toque, con la imagen del catálogo; si querés, después les sumás tus fotos.",
  "imp.template": "Descargar planilla modelo",
  "imp.file": "Subir archivo CSV",
  "imp.paste": "Pegá acá tus filas",
  "imp.placeholder": "Carta\tSet\tNúmero\tEstado\tPrecio\nPikachu\tMEW\t025\tNM\t2500",
  "imp.read": "Revisar",
  "imp.reading": "Buscando en el catálogo…",
  "imp.sheet.empty": "No encontramos filas para cargar.",
  "imp.sheet.no_header": "Falta la fila de títulos: necesitamos al menos las columnas Carta (o Set y Número) y Precio.",
  "imp.sheet.too_many": "Son más de {max} filas: dividila en partes.",
  "imp.counts": "{ok} listas · {pick} para elegir · {bad} con problemas",
  "imp.include": "Incluir",
  "imp.line": "Fila",
  "imp.product": "Producto",
  "imp.details": "Detalle",
  "imp.includeLine": "Incluir la fila {line}",
  "imp.whichOne": "¿Cuál es?",
  "imp.whichOneLine": "Producto de la fila {line}",
  "imp.choose": "Elegí…",
  "imp.err.card": "Falta la carta (o el set y el número).",
  "imp.err.game": "No conocemos ese juego, o todavía no está abierto en pokefans.",
  "imp.err.condition": "No entendimos el estado (NM, LP, MP, HP, DMG o Sellado).",
  "imp.err.language": "No entendimos el idioma.",
  "imp.err.finish": "No entendimos la terminación (normal, holo, reverse o 1ra edición).",
  "imp.err.finish_game": "Las cartas de este juego no tienen esa terminación: dejala vacía o poné normal.",
  "imp.err.grade": "No entendimos el gradeo (por ejemplo: PSA 10).",
  "imp.err.price": "El precio va en pesos enteros (por ejemplo: 1.500).",
  "imp.err.quantity": "La cantidad va de 1 a 999.",
  "imp.err.condition_missing": "Falta el estado de la carta.",
  "imp.err.single_sealed": "Es una carta suelta: poné su estado (NM, LP…), no \"sellado\".",
  "imp.err.sealed_graded": "Un producto sellado no lleva gradeo.",
  "imp.err.not_found": "No la encontramos en el catálogo: revisá el set y el número.",
  "imp.duplicate": "Ya la tenés publicada así: quedó sin marcar.",
  "imp.repeated": "Repetida más arriba en la planilla: quedó sin marcar.",
  "imp.commit": "Cargar {count} publicaciones",
  "imp.commit_one": "Cargar 1 publicación",
  "imp.back": "Volver a la planilla",
  "imp.rowFailed": "No pudimos cargar la fila {line}: revisala y probá de nuevo. No se cargó nada.",
  "imp.doneTitle": "Listo: cargaste {count} publicaciones",
  "imp.doneTitle_one": "Listo: cargaste 1 publicación",
  "imp.donePublished": "{count} ya están a la venta.",
  "imp.donePublished_one": "1 ya está a la venta.",
  "imp.doneOverLimit": "{count} quedaron en pausa: llegaste al máximo de {max} publicaciones activas.",
  "imp.doneOverPrice": "{count} quedaron en pausa: pasan el precio máximo de tu plan.",
  "imp.doneOverLimit_one": "1 quedó en pausa: llegaste al máximo de {max} publicaciones activas.",
  "imp.done": "Ver mis publicaciones",
  "mkt.pendingPrepare": "Mientras tanto ya podés cargar tus publicaciones, una por una o con una planilla. Quedan guardadas y las que estén listas se publican solas cuando te aprobemos.",
  "mkt.publishOnApproval": "Se publica cuando te aprobemos",
  "mkt.pendingLimit": "Mientras revisamos tu solicitud podés preparar hasta {max} publicaciones (las borradas también cuentan).",
  "imp.help3Pending": "Nada se publica hasta que te aprobemos; ahí salen solas, con la imagen del catálogo.",
  "imp.doneAwaiting": "{count} quedan listas: se publican solas cuando te aprobemos.",
  "imp.doneAwaiting_one": "1 queda lista: se publica sola cuando te aprobemos.",
  "mkt.openOffers": "{count} ofertas",
  "mkt.openOffers_one": "1 oferta",
  "mkt.makeCover": "Primera",
  "mkt.deletePhoto": "Borrar",
  "mkt.addPhoto": "Foto",
  "mkt.photosHint": "Opcional: fotos tuyas de la carta real, con buena luz, para mostrar su estado. Se ven después de la imagen del catálogo, que siempre va primero.",
  "mkt.pause": "Pausar",
  "mkt.publish": "Publicar",
  "mkt.published": "¡Publicada!",
  "mkt.view": "Ver",
  "mkt.delete": "Eliminar",
  "mkt.confirmDelete": "¿Eliminar esta publicación?",
  "mkt.noSales": "Todavía no tenés ventas.",
  "mkt.unread": "mensaje nuevo",
  "mkt.noOffersReceived": "No recibiste ofertas.",
  "mkt.noOffersMade": "No hiciste ofertas.",
  "mkt.offerLine": "{qty} × {price} (publicada a {list})",
  "mkt.counterLine": "contraoferta {price}",
  "mkt.until": "vence {date}",
  "mkt.accept": "Aceptar",
  "mkt.reject": "Rechazar",
  "mkt.counter": "Contraofertar",
  "mkt.counterAmount": "Tu precio",
  "mkt.acceptCounter": "Aceptar contraoferta",
  "mkt.buyAtOffer": "Comprar a este precio",
  "mkt.withdraw": "Retirar",
  "mkt.set.profile": "Tu tienda",
  "mkt.vacation": "De vacaciones hasta",
  "mkt.vacationHint": "Mientras tanto se ve tu tienda pero no te pueden comprar.",
  "mkt.set.payments": "Cómo cobrás",
  "mkt.set.paymentsIntro": "La plata va directo a vos. Configurá uno o más medios.",
  "mkt.mpSoon": "Muy pronto vas a poder conectar tu cuenta.",
  "mkt.mpConnectedShort": "Cuenta conectada",
  "mkt.mpNotConnected": "Sin conectar (lo conecta el vendedor desde su tienda).",
  "mkt.mpDisconnect": "Desconectar",
  "mkt.mpIntro": "Conectá tu cuenta: los compradores pagan en Mercado Pago y la plata entra a tu cuenta. Mercado Pago te descuenta su comisión habitual; nosotros no cobramos nada.",
  "mkt.mpConnect": "Conectar Mercado Pago",
  "mkt.set.transfer": "Transferencia",
  "mkt.set.crypto": "Cripto (USDT)",
  "mkt.network": "Red",
  "mkt.walletAddress": "Dirección de tu billetera",
  "mkt.walletInvalid": "Esa dirección no es válida para esta red. Copiala completa desde tu billetera.",
  "mkt.set.delivery": "Cómo entregás",
  "mkt.set.hand": "Entrego en mano",
  "mkt.set.handZones": "Zonas",
  "mkt.set.handAreas": "Lugares o barrios",
  "mkt.set.handAreasHint": "Ej.: estaciones de la línea D, Palermo",
  "mkt.set.cost": "Costo ($)",
  "mkt.set.ship": "Envío yo",
  "mkt.set.carriers": "Con qué correo",
  "mkt.set.pickup": "Punto de retiro",
  "mkt.set.pickupAddress": "Dirección",
  "mkt.set.pickupHours": "Horarios",
  "mkt.set.pickupHint": "La dirección se muestra al comprador recién cuando paga. Usá un lugar público (un local, una tienda amiga).",
  "mkt.set.arrange": "Donde arreglemos (en los días y horarios de abajo)",
  "mkt.set.sales": "Ventas",
  "mkt.set.acceptsOffers": "Acepto ofertas",
  "mkt.settingsError": "No se pudo guardar. Revisá los datos.",
  "mkt.saveSettings": "Guardar ajustes",
  "mkt.noPurchases": "Todavía no compraste en el mercado.",
  "mkt.goToMarket": "Ir al mercado",
  "mkt.noFavorites": "Guardá publicaciones con ♡ y te avisamos si bajan de precio.",
  "mkt.wantsIntro": "Cargá las cartas que buscás: te mandamos un email cuando alguien las publique (al precio máximo que pongas, si ponés uno).",
  "mkt.wantsPrivacy": "Tu lista es privada. Lo que marques «Visible en Se busca» aparece en el tablero público con tu alias, nunca con tu email. Las tiendas ven cuántas personas buscan cartas que tienen publicadas (las VMAX, cuántas buscan cada una), nunca quién.",
  "mkt.wantMax": "Precio máximo ($, opcional)",
  "mkt.wantAdd": "Agregar una carta que busco",
  "mkt.noWants": "Tu lista \"Busco\" está vacía.",
  "mkt.upTo": "hasta {price}",
  "mkt.wantFound": "{count} a la venta desde {price}",
  "mkt.wantFound_one": "1 a la venta: {price}",
  "mkt.wantWaiting": "Te avisamos",
  "mkt.noFollowing": "No seguís a ningún vendedor.",
  "sell.metaTitle": "Vendé tus cartas Pokémon sin comisión",
  "sell.kicker": "Para vendedores",
  "sell.title": "Vendé tus cartas en pokefans.fun, sin comisión",
  "sell.lead": "Publicás tus cartas sueltas y productos sellados, el comprador te paga directo a vos y coordinan la entrega. Nosotros ponemos la vidriera: tus ofertas aparecen en la ficha de cada producto y en el buscador de la tienda.",
  "sell.cta": "Quiero vender",
  "sell.haveAccount": "Ya tengo cuenta",
  "sell.foundersTitle": "Programa Vendedores Fundadores",
  "plans.nav": "Planes para vendedores",
  "plans.navHint": "Gratis, EX y VMAX: qué incluye cada uno.",
  "plans.title": "Planes para vendedores",
  "plans.intro": "Vender en pokefans.fun es gratis y sin comisión. Los planes suman herramientas para vender más: más publicaciones, destacadas, cupones, estadísticas y más.",
  "plans.free": "Gratis",
  "plans.perMonth": "{price} por mes",
  "plans.priceSoon": "Precio a confirmar",
  "plans.tagline.basic": "Para empezar: publicá y vendé sin pagar nada.",
  "plans.tagline.ex": "Para el que vende seguido y quiere ver qué funciona.",
  "plans.tagline.vmax": "Todo, sin límites: para tiendas y vendedores grandes.",
  "plans.hlListings": "Hasta {count} publicaciones activas",
  "plans.hlListingsNoLimit": "Publicaciones sin límite",
  "plans.hlPrice": "Hasta {price} por carta",
  "plans.hlPriceNoLimit": "Sin tope de precio",
  "plans.hlNoFees": "Sin comisión: el comprador te paga directo",
  "plans.hlVerified": "Verificación gratis",
  "plans.hlFeatured": "{count} destacadas por mes",
  "plans.hlInsights": "Estadísticas por publicación y precio contra el mercado",
  "plans.hlCoupon": "1 cupón de descuento para tu tienda",
  "plans.hlCoupons": "{count} cupones (por cartas, set, grupo o cliente)",
  "plans.hlCustomers": "Tus clientes: grupos y qué más compran",
  "plans.hlEmails": "{count} emails por mes a tus clientes",
  "plans.hlDemand": "Aviso al instante cuando buscan tus cartas",
  "plans.hlUsd": "Precios en dólares que siguen al dólar blue solos",
  "plans.hlReservations": "Reservar cartas para un cliente con link de pago ({count} a la vez)",
  "plans.hlCustomShop": "Tienda personalizada (banner, logo, color, anuncio, secciones, redes y cartas fijadas arriba)",
  "plans.hlApi": "API para conectar tu planilla o tu sistema",
  "plans.hlSupport": "Soporte prioritario por WhatsApp",
  "plans.openShop": "Abrí tu tienda gratis",
  "plans.openShopFirst": "Primero abrí tu tienda (gratis)",
  "plans.signIn": "Ingresá para suscribirte",
  "plans.underReview": "Tu tienda está en revisión: cuando la aprobemos vas a poder elegir un plan.",
  "plans.founderFree": "Lo tenés gratis por ser vendedor fundador.",
  "plans.founderHasVmax": "Ya tenés VMAX gratis por ser fundador.",
  "plans.yours": "Es tu plan",
  "plans.manage": "Gestionarlo en Mi tienda",
  "plans.subscribe": "Suscribirme",
  "plans.switchTo": "Cambiar a {plan}",
  "plans.switchNote": "Cuando se confirme el nuevo plan, dejamos de cobrarte {plan}. Lo que ya pagaste no se descuenta.",
  "plans.payerEmail": "Email de tu cuenta de Mercado Pago",
  "plans.payerEmailHint": "Pagás con esa cuenta, todos los meses. Podés cancelar cuando quieras desde Mi tienda.",
  "plans.goToMp": "Ir a Mercado Pago",
  "plans.err.founder_free": "Ya tenés este plan gratis por ser fundador.",
  "plans.err.already_subscribed": "Ya estás suscripto a este plan.",
  "plans.err.subscriptions_off": "Todavía no se puede suscribir: escribinos y te lo activamos.",
  "plans.err.validation_error": "Revisá el email de Mercado Pago.",
  "plans.err.generic": "No pudimos conectar con Mercado Pago. Probá de nuevo en un rato.",
  "plans.compare": "Qué incluye cada plan",
  "plans.faq": "Preguntas",
  "plans.q1": "¿Cómo se paga?",
  "plans.a1": "Con Mercado Pago, todos los meses, con la tarjeta o el saldo que elijas ahí. El plan se activa cuando Mercado Pago confirma el primer pago.",
  "plans.q2": "¿Puedo cancelar?",
  "plans.a2": "Sí, cuando quieras, desde Mi tienda › Ajustes. No te cobramos más y el plan sigue hasta que termina el mes que ya pagaste.",
  "plans.q3": "¿Y si cambio de plan?",
  "plans.a3": "Te suscribís al nuevo y, cuando se confirma, dejamos de cobrarte el anterior. No se prorratea lo ya pagado.",
  "plans.q4": "¿Pokefans cobra comisión por venta?",
  "plans.a4": "No, en ningún plan. El comprador te paga directo a vos.",
  "plans.see": "Ver planes",
  "plans.fromSell": "Vender es gratis. Si querés más publicaciones y herramientas, mirá los planes EX y VMAX.",
  "plans.cancel": "Cancelar suscripción",
  "plans.cancelConfirm": "¿Cancelar la suscripción? No te cobramos más y tu plan sigue hasta el {date}.",
  "plans.cancelError": "Mercado Pago no confirmó la cancelación. Probá de nuevo en un rato.",
  "plans.confirming": "Estamos confirmando tu pago con Mercado Pago… Puede tardar un minuto.",
  "plans.subActive": "Suscripción a {plan} con Mercado Pago: {price} por mes.",
  "plans.nextCharge": "Próximo cobro: {date}.",
  "plans.subPending": "Te falta terminar la suscripción a {plan} en Mercado Pago.",
  "plans.finish": "Terminar en Mercado Pago",
  "plans.subPaused": "Mercado Pago no pudo cobrar tu plan {plan}: revisá tu medio de pago en Mercado Pago.",
  "plans.subEnded": "Cancelaste la suscripción: tu plan {plan} sigue hasta el {date}.",
  "sell.foundersText": "Los primeros vendedores aprobados llevan para siempre la insignia de Vendedor fundador y tienen gratis el plan VMAX, el más completo (más visibilidad, herramientas y estadísticas), por 3 meses desde que los aprobamos.",
  "sell.foundersLeft": "Quedan {count} lugares.",
  "sell.foundersLeft_one": "Queda 1 lugar.",
  "sell.benefitsTitle": "Por qué vender acá",
  "sell.b1Title": "0% de comisión",
  "sell.b1Text": "No cobramos por publicar ni por vender. Lo que cobrás es tuyo.",
  "sell.b2Title": "Cobrás directo",
  "sell.b2Text": "Por transferencia a tu cuenta, en cripto o en efectivo contra entrega. La plata nunca pasa por nosotros.",
  "sell.b2TextMp": "Con Mercado Pago (la plata entra directo a tu cuenta), por transferencia, en cripto o en efectivo contra entrega. La plata nunca pasa por nosotros.",
  "sell.b3Title": "Te encuentran",
  "sell.b3Text": "Cada oferta aparece en la ficha del producto, debajo de la nuestra, y en el buscador de la tienda: la misma vidriera que usan nuestros clientes.",
  "sell.b4Title": "Tu tienda propia",
  "sell.b4Text": "Una página con tus publicaciones, tus ventas y las reseñas de tus compradores.",
  "sell.b5Title": "Cartas y sellados",
  "sell.b5Text": "Cartas sueltas, sobres, ETB, cajas y colecciones. Podés publicar con la imagen del catálogo y sumar tus fotos cuando quieras.",
  "sell.b6Title": "Vos ponés las reglas",
  "sell.b6Text": "Elegís cómo entregar (en mano, por envío o en un punto de retiro), los días y horarios, y si aceptás ofertas.",
  "sell.stepsTitle": "Cómo empezar",
  "sell.s1Title": "Anotate",
  "sell.s1Text": "Creá tu cuenta y completá la solicitud: contacto, ciudad, fecha de nacimiento (hay que ser mayor de 18), un link de una red social y una foto de verificación. La revisamos a mano.",
  "sell.s2Title": "Publicá",
  "sell.s2Text": "Buscá la carta o el producto en nuestro catálogo, elegí estado, idioma y precio, y subí tus fotos. Te mostramos el precio de referencia de la tienda.",
  "sell.s3Title": "Vendé y cobrá",
  "sell.s3Text": "Te avisamos cada compra por email. Coordinás la entrega por el chat del pedido y el comprador te paga directo.",
  "sell.faqTitle": "Preguntas frecuentes",
  "sell.q1": "¿Cuánto cobran de comisión?",
  "sell.a1": "Nada. Publicar y vender es gratis. Más adelante vamos a sumar planes opcionales con más visibilidad y herramientas; vender va a seguir siendo sin comisión.",
  "sell.a1Mp": "Nada. Publicar y vender es gratis. Si cobrás con Mercado Pago, MP te descuenta su comisión habitual, como en cualquier cobro; nosotros no sumamos nada. Más adelante vamos a sumar planes opcionales con más visibilidad y herramientas; vender va a seguir siendo sin comisión.",
  "sell.q2": "¿Cómo me pagan?",
  "sell.a2": "El comprador te paga directo a vos, con los medios que elijas: transferencia a tu cuenta, cripto o efectivo contra entrega. pokefans.fun no toca la plata.",
  "sell.a2Mp": "El comprador te paga directo a vos, con los medios que elijas: Mercado Pago (conectás tu cuenta y la plata entra ahí), transferencia, cripto o efectivo contra entrega. pokefans.fun no toca la plata.",
  "sell.q3": "¿Quién hace el envío?",
  "sell.a3": "Vos. Elegís si entregás en mano, si enviás por correo o si usás un punto de retiro, con el costo que quieras.",
  "sell.q4": "¿Qué puedo vender?",
  "sell.a4": "Cartas sueltas y productos sellados originales (sobres, ETB, cajas, mazos y colecciones). No accesorios, falsificaciones ni productos resellados.",
  "sell.q5": "¿Qué necesito para empezar?",
  "sell.a5": "Ser mayor de 18 años, estar en Argentina, tener una cuenta en pokefans.fun y compartirnos un link de una red social donde se vea que vendés o coleccionás, y una foto de tu carta más valiosa junto a un papel con tu @usuario y la fecha. Revisamos cada solicitud a mano antes de aprobarla.",
  "sell.q6": "¿Y si hay un problema con una venta?",
  "sell.a6": "Cada pedido tiene su chat y su historial. Compradores y vendedores se califican, y cualquiera puede denunciar una publicación o un vendedor: lo revisamos y podemos pausar o dar de baja una tienda.",
  "sell.termsNote": "Antes de anotarte, leé los",
  "sell.terms": "términos del mercado",
  "sell.homeTitle": "¿Tenés cartas para vender?",
  "sell.homeText": "Publicalas en pokefans.fun sin comisión: el comprador te paga directo y tus ofertas aparecen en la tienda.",
  "sell.homeCta": "Empezá a vender",
  "sell.nav": "Vendé",
  "offers.title": "Ofertas de vendedores",
  "offers.count": "{count} desde {price}",
  "offers.none": "Ningún vendedor lo publicó todavía.",
  "offers.sellYours": "¿Lo tenés? Vendelo acá, sin comisión",
  "offers.filters": "Filtrar ofertas",
  "offers.minCondition": "Estado mínimo",
  "offers.language": "Idioma",
  "offers.any": "Cualquiera",
  "offers.caba": "Entrega en CABA",
  "offers.cash": "Acepta efectivo",
  "offers.clear": "Limpiar filtros",
  "offers.noMatch": "Ninguna oferta con esos filtros.",
  "offers.seller": "Vendedor",
  "offers.item": "Producto",
  "offers.delivery": "Entrega y pago",
  "offers.price": "Precio",
  "offers.action": "Comprar",
  "offers.buy": "Comprar",
  "offers.more": "Más opciones",
  "offers.notesMore": "Ver más",
  "offers.goneMine": "Esa publicación es tuya y no está a la venta ahora (pausada o sin stock).",
  "offers.notesLess": "Ver menos",
  "offers.yours": "Es tuya",
  "offers.gone": "La publicación de ese link ya no está a la venta. Estas son las otras ofertas de la carta.",
  "offers.seeAll": "Ver las {count} ofertas",
  "offers.shipQuote": "envío a cotizar",
  "offers.free": "gratis",
  "offers.pickup": "punto de retiro",
  "offers.ownPhotos": "Con fotos del vendedor",
  "offers.jump": "Disponible en {count} vendedores desde {price}",
  "offers.tag": "Vendedores",
  "offers.or": "o",
  "offers.tile": "desde {price} en {count} vendedores",
  "offers.tile_one": "{price} en 1 vendedor",
  "offers.seeOffers": "Ver {count} ofertas",
  "offers.seeOffers_one": "Ver la oferta",
  "mkt.wantThis": "La busco: avisame si alguien la publica",
  "mkt.wantSaved": "Te avisamos cuando alguien la publique.",
} as const;

export const marketEn: Record<keyof typeof marketEs, string> = {
  "nav.market": "Market",
  "mkt.set.err.hand": "Pick at least one area where you hand cards over.",
  "mkt.set.err.pickup": "Type the pickup point's address.",
  "mkt.set.err.arrange": "For \"wherever we agree\" tick at least one day with its hours.",
  "mkt.set.err.schedule": "Check the hours: \"to\" must be after \"from\".",
  "mkt.set.err.window": "Check the hours",
  "mkt.set.fromDay": "{day} from",
  "mkt.set.toDay": "{day} to",
  "mkt.set.dayOff": "Off",
  "mkt.set.copyHours": "Use {day}'s hours on every ticked day",
  "mkt.status.confirmed": "Confirmed",
  "mkt.payHint.cash": "Pay in cash when you get the cards (in person only).",
  "mkt.set.schedule": "Days and hours to meet",
  "mkt.set.scheduleHint": "Tick the days you can meet and each day's hours. Buyers pick one of those days when buying (by hand, pickup or wherever you agree). Required for \"wherever we agree\".",
  "mkt.set.scheduleDays": "Available days",
  "mkt.set.from": "From",
  "mkt.set.to": "To",
  "mkt.set.cash": "I take cash on delivery",
  "mkt.set.cashHint": "In-person deliveries only (by hand, pickup or agreed). The order is confirmed with no payment upfront.",
  "mkt.set.minOrder": "Minimum purchase (optional, in pesos)",
  "mkt.set.minOrderNone": "No minimum",
  "mkt.set.minOrderHint": "Each order's cards must add up to at least this amount (delivery not included). Offers you accept don't need it. Empty: no minimum.",
  "mkt.set.minOrderInvalid": "Enter an amount in whole pesos, or leave it empty.",
  "mkt.minOrder": "Minimum purchase",
  "mkt.belowMinOrder": "This shop sells from {min} in cards: you need {missing} more.",
  "mkt.schedule": "Days and hours",
  "mkt.meetingDay": "Which day do you meet?",
  "mkt.meetingWindow": "Between {from} and {to}. Agree on the exact place in the chat.",
  "mkt.meetingLine": "{day}, between {from} and {to}",
  "mkt.cashInPerson": "Cash is only for in-person deliveries.",
  "mkt.newSellerSafePay": "This is a new seller: orders over {max} can only be paid with Mercado Pago (it has buyer protection) or in cash when you get the cards in hand.",
  "mkt.newSeller": "New seller",
  "mkt.limitedSeller": "Cash in person only",
  "mkt.set.ownerPays": "The shop's owner sets how they get paid (Mercado Pago, bank account, crypto wallet).",
  "sp.acting": "You're editing @{handle} as an admin. Changes are logged.",
  "sp.actingExit": "Exit",
  "sp.actingLost": "You can't edit this shop from the admin right now (you released it, or your session needs the code again).",
  "mkt.activate.title": "Your shop is ready",
  "mkt.activate.body": "pokefans.fun set up your shop with your listings. Nobody sees it yet: look it over and, when you're ready, accept the rules to publish it.",
  "mkt.activate.keep": "We can keep helping you load things. If you'd rather we didn't, write to us and we'll stop.",
  "mkt.activate.go": "Publish my shop",
  "mkt.activate.error": "It couldn't be published. Check the details and try again.",
  "mkt.set.limited": "While your shop has limits, buyers only see cash and the in-person handover. Anything else you set up is kept for when they lift.",
  "mkt.limitedBuyer": "This shop only sells for cash, handed over in person. Meet somewhere public and busy (a mall, a station, a café), check the cards before paying and don't pay anything in advance.",
  "mkt.limitedYou": "Your shop started with limits: buyers can only pay you in cash and get the cards in person. They lift on their own after your first {sales} sales with no disputes and {days} days as a seller.",
  "mkt.limitedSetup": "Your shop started with limits: it only sells for cash, handed over in person. Turn both on in Settings so your listings show.",
  "mkt.newSellerYou": "You're a new seller: on sales over {max}, buyers can only pay you with Mercado Pago or cash in hand. This lasts your first {days} days and until your first {sales} sales.",
  "mkt.newSellerConnectMp": "Connect Mercado Pago so you don't miss big sales.",
  "mkt.cashNote": "You pay in cash when you get the cards. Check them before paying.",
  "mkt.cashToPay": "To pay in cash on delivery: {total}",
  "mkt.errMeeting": "Pick one of the seller's available days.",
  "mkt.markHanded": "Handed over and paid",
  "mkt.markReceivedCash": "I got the cards and paid",
  "mkt.st.confirmedBuyer": "Order confirmed. We emailed you the seller's details: arrange the meeting and pay on delivery.",
  "mkt.st.confirmedSeller": "Order confirmed: paid in cash on delivery. We emailed you the buyer's details.",
  "mkt.title": "Community market",
  "mkt.titleSeller": "Cards from @{seller}",
  "mkt.intro": "Cards from other fans. You pay the seller directly and arrange delivery in the order chat. pokefans.fun takes no fees.",
  "mkt.results": "{count} listings",
  "mkt.resultsCards": "{count} cards",
  "mkt.f.category": "Category",
  "mkt.resultsCards_one": "1 card",
  "mkt.fromPrice": "From {price}",
  "mkt.soldByMany": "Sold by {count} sellers",
  "mkt.allCards": "← All cards",
  "mkt.results_one": "1 listing",
  "mkt.filters": "Filters",
  "mkt.sort": "Sort",
  "mkt.view.label": "View",
  "mkt.view.cards": "Cards",
  "mkt.view.list": "List",
  "mkt.view.listLabel": "Listings",
  "mkt.sort.newest": "Newest",
  "mkt.sort.price_asc": "Lowest price",
  "mkt.sort.price_desc": "Highest price",
  "mkt.sort.rating": "Best seller",
  "mkt.sellCta": "I want to sell",
  "mkt.empty": "No listings match those filters.",
  "mkt.emptyWant": "Tell me when it shows up",
  "mkt.f.search": "Search",
  "mkt.f.searchHint": "Card, set, number or seller",
  "mkt.f.seller": "Seller",
  "mkt.f.condition": "Condition",
  "mkt.f.language": "Language",
  "mkt.f.finish": "Finish",
  "mkt.f.graded": "Graded",
  "mkt.f.gradedYes": "Graded only",
  "mkt.f.gradedNo": "Ungraded",
  "mkt.f.any": "Any",
  "mkt.f.min": "From $",
  "mkt.f.max": "To $",
  "mkt.f.zone": "Hand delivery in",
  "mkt.f.payment": "Payment method",
  "mkt.f.rating": "Seller rating",
  "mkt.f.ratingAtLeast": "{value}★ or more",
  "mkt.f.sales": "Seller sales",
  "mkt.f.salesAtLeast": "{count}+ sales",
  "mkt.f.salesAtLeast_one": "At least 1 sale",
  "mkt.noReviews": "No reviews",
  "mkt.starsLabel": "{value} out of 5 stars, {count} reviews",
  "mkt.starsShort": "{count} stars",
  "mkt.starsShort_one": "1 star",
  "mkt.salesCount": "{count} sales",
  "mkt.salesCount_one": "1 sale",
  "mkt.available": "{count} available",
  "mkt.available_one": "1 available",
  "mkt.report": "Report",
  "mkt.reportTitle": "Report",
  "mkt.reportReason": "What's wrong?",
  "mkt.reportDetails": "Tell us more (optional)",
  "mkt.reportSend": "Send report",
  "mkt.reportSent": "Thanks. We'll look into it.",
  "mkt.reportOrder": "Report this order",
  "mkt.copy": "Copy",
  "mkt.copied": "Copied!",
  "mkt.status.pending_payment": "Awaiting payment",
  "mkt.status.paid": "Paid",
  "mkt.status.shipped": "Sent",
  "mkt.status.completed": "Completed",
  "mkt.status.cancelled": "Cancelled",
  "mkt.status.disputed": "Under review",
  "mkt.status.live": "Live",
  "mkt.status.soldout": "Out of stock",
  "mkt.status.draft": "Paused",
  "mkt.status.offer_pending": "Awaiting reply",
  "mkt.status.offer_countered": "Counter-offer",
  "mkt.status.offer_accepted": "Accepted",
  "mkt.status.offer_rejected": "Rejected",
  "mkt.status.offer_cancelled": "Withdrawn",
  "mkt.status.offer_expired": "Expired",
  "mkt.status.offer_used": "Bought",
  "mkt.breadcrumbs": "Breadcrumbs",
  "mkt.listingNotFound": "This listing is no longer available.",
  "mkt.photoN": "photo {n}",
  "mkt.catalogImageNote": "Catalog image. The seller hasn't added photos of this card.",
  "mkt.catalogImageMore": "Catalog image. The seller added {count} photos of this card: see its condition in the thumbnails.",
  "mkt.catalogImageMore_one": "Catalog image. The seller added 1 photo of this card: see its condition in the thumbnail.",
  "mkt.catalogImage": "catalog image",
  "mkt.sellerPhoto": "seller's photo {n}",
  "mkt.sellerPhotoNote": "Seller's photo: this is the card you'll get.",
  "mkt.photos.open": "See the seller's {count} photos",
  "mkt.photos.open_one": "See the seller's photo",
  "mkt.photos.title": "Seller's photos: {name}",
  "mkt.photos.listing": "See the listing",
  "mkt.presaleNote": "Pre-sale: out {date}. Agree with the seller on when you get it.",
  "mkt.presaleNoteNoDate": "Pre-sale: not out yet. Agree with the seller on when you get it.",
  "mkt.reference": "Reference price",
  "mkt.refStore": "In the store (bank transfer)",
  "mkt.refStoreOut": "The store doesn't have it in stock now.",
  "mkt.refStoreLink": "See in the store",
  "mkt.refNoStore": "The store doesn't sell it.",
  "mkt.refMarket": "{count} more listings from {price}",
  "mkt.refMarket_one": "1 more listing from {price}",
  "mkt.refMarketNone": "No other listings of this card.",
  "mkt.refMarketNoneSealed": "No other listings of this product.",
  "mkt.refCheaperStore": "💡 It's cheaper in the store (NM price, in whatever condition we have).",
  "mkt.editInShop": "Edit in my shop",
  "mkt.onVacation": "This shop is on vacation until {date}.",
  "mkt.notAvailable": "Not available right now.",
  "mkt.quantity": "Quantity",
  "mkt.quantityOf": "Quantity of {name}",
  "mkt.buyNow": "Buy",
  "mkt.addToOrder": "Add to order with {seller}",
  "mkt.addedToOrder": "✓ Added to the order",
  "mcart.title": "Your cart",
  "mcart.perSeller": "You have cards from {count} sellers: that's {count} separate orders, and you pay each seller directly, only their amount.",
  "mcart.orderOf": "Order {n} of {count}",
  "mcart.cardsOf": "Cards from @{handle}",
  "mcart.exactLater": "Each order gives you the exact amount to pay (delivery included) and who to pay.",
  "mcart.buyFrom": "Buy from @{handle}",
  "mcart.empty": "You haven't added any cards yet.",
  "mcart.browse": "Go to the market",
  "mkt.makeOffer": "Make an offer",
  "mkt.save": "Save",
  "mkt.saved": "Saved",
  "mkt.specsLocked": "It has open offers or a reservation: these details can't change until they close.",
  "mkt.soldBy": "Sold by",
  "mkt.seeShop": "See shop",
  "mkt.payments": "Takes",
  "mkt.delivery": "Delivery",
  "mkt.noProtection": "This seller doesn't take Mercado Pago: transfers and crypto have no buyer protection. Check their reputation first.",
  "mkt.sellerNotes": "Seller's notes",
  "mkt.offerTitle": "Make an offer",
  "mkt.offerIntro": "Listed at {price}. The seller can accept, reject or counter. If accepted, you have 48 hours to buy at that price.",
  "mkt.offerPrice": "Your offer per card ($)",
  "mkt.offerSend": "Send offer",
  "mkt.offerSent": "Offer sent! We'll email you when they reply. Follow it in My market › Offers.",
  "mkt.offerOpen": "You already have an open offer on this listing.",
  "mkt.sellerNotFound": "We couldn't find that shop.",
  "mkt.memberSince": "on pokefans.fun since {date}",
  "mkt.avatarLevel": "level {level}",
  "mkt.followers": "{count} followers",
  "mkt.followers_one": "1 follower",
  "mkt.follow": "Follow",
  "mkt.following": "Following",
  "mkt.share": "Share",
  "mkt.reputation": "Reputation",
  "mkt.metricResponse": "Replies in",
  "mkt.metricCancel": "Orders they cancelled",
  "mkt.metricOnTime": "Sent on time",
  "mkt.metricsNote": "Last 90 days. On time = within 3 days of payment.",
  "mkt.minutes": "~{count} minutes",
  "mkt.minutes_one": "~1 minute",
  "mkt.hours": "~{count} hours",
  "mkt.hours_one": "~1 hour",
  "mkt.days": "~{count} days",
  "mkt.days_one": "~1 day",
  "mkt.howSells": "How they sell",
  "mkt.free": "free",
  "mkt.quoted": "quoted",
  "mkt.pickupAfterPay": "Address after paying",
  "mkt.arrangeChat": "Wherever you agree, on their days and hours",
  "mkt.offers": "Offers",
  "mkt.offersYes": "Takes offers",
  "mkt.offersNo": "No offers",
  "mkt.sellerCards": "Their listings",
  "mkt.sellerNoCards": "Nothing listed right now.",
  "mkt.reviews": "Reviews ({count})",
  "mkt.noReviewsYet": "No reviews yet.",
  "mkt.sellerReply": "Seller's reply:",
  "mkt.moreReviews": "More reviews",
  "mkt.cartEmpty": "There are no cards from this seller in your order.",
  "mkt.backToShop": "Back to their shop",
  "mkt.checkoutTitle": "Your order from @{handle}",
  "mkt.totalTo": "Total to pay @{handle}",
  "mkt.otherCarts": "This order is only @{handle}'s. Your cards from other sellers stay in the cart: each one is another order, paid separately.",
  "mkt.otherCart": "@{handle}: {count} cards for {total}",
  "mkt.otherCart_one": "@{handle}: 1 card for {total}",
  "mkt.cards": "Cards",
  "mkt.offerPriceTag": "offer price",
  "mkt.remove": "Remove",
  "mkt.addMoreFromSeller": "＋ Add more cards from this seller",
  "mkt.yourZone": "Where are you?",
  "mkt.choose": "Choose…",
  "mkt.payment": "Payment",
  "mkt.payHint.mercadopago": "🛡️ Protected purchase: you pay through Mercado Pago, with its buyer protection.",
  "mkt.payHint.transfer": "Transfer to the seller, who confirms it arrived. No protection: only pay with the order's details.",
  "mkt.payHint.crypto": "USDT to the seller's wallet, at today's rate. No protection: only pay with the order's details.",
  "mkt.verified": "Verified",
  "mkt.manualWarning": "Transfers and crypto go straight to the seller with no intermediary: if something goes wrong there's nobody to claim the money from. Only pay with this order's details.",
  "mkt.yourDetails": "Your details",
  "mkt.name": "Full name",
  "mkt.phone": "Phone",
  "mkt.phoneHint": "The seller only sees it once the order is paid.",
  "mkt.address": "Delivery address",
  "mkt.city": "City",
  "mkt.notes": "Anything for the seller (optional)",
  "mkt.subtotal": "Cards",
  "mkt.deliveryLine": "Delivery",
  "mkt.toAgree": "to be agreed",
  "mkt.total": "Total",
  "mkt.acceptTermsBuyer": "I have read and accept the",
  "mkt.marketTerms": "market terms",
  "mkt.payWithMp": "Pay with Mercado Pago",
  "mkt.placeOrder": "Place order",
  "mkt.noMoneyNote": "pokefans.fun doesn't take or hold the money: you pay the seller directly.",
  "mkt.errStock": "Some card is no longer available in that quantity. Check the order.",
  "mkt.errPriceChanged": "The price of {names} changed since you added it. You now see today's price: check the total and confirm again.",
  "mkt.errPriceChangedCoupon": "The coupon came off: apply it again to see its discount on the new price.",
  "mkt.errVacation": "The seller is on vacation.",
  "mkt.errOffer": "The offer expired or was already used.",
  "mkt.orderNotFound": "We couldn't find that order.",
  "mkt.orderTitle": "Order {number}",
  "mkt.youSell": "You sell",
  "mkt.youBuy": "You buy",
  "mkt.howToPay": "How to pay",
  "mkt.payDirect": "Pay exactly {total} to @{handle} ({name}) for order {number}:",
  "mkt.exactAmount": "Exact amount",
  "mkt.payPlusShipping": "Pay {total} for the cards, plus the shipping they quote in the chat, to @{handle} ({name}) for order {number}:",
  "mkt.amountNoShipping": "Cards (shipping not included)",
  "mkt.payOnlyThis": "This payment is only for @{handle}. You still have cards from {others} in your cart: each order has its own amount and its own payment details.",
  "mkt.seeCart": "See cart",
  "mkt.holder": "Account holder",
  "mkt.checkHolder": "Before you confirm, check that the holder your bank shows is {holder}. If it doesn't match, don't transfer and tell us with “Report this order”.",
  "mkt.bank": "Bank",
  "mkt.reservedUntil": "The cards are reserved until {date}. Tell us as soon as you pay.",
  "mkt.markPaid": "I've paid",
  "mkt.txLabel": "Transaction hash (TXID)",
  "mkt.txHint": "Your wallet shows it after you send. With the hash, the seller finds your payment on the blockchain.",
  "mkt.txSave": "Save hash",
  "mkt.txReplace": "Change hash",
  "mkt.txShown": "Transaction:",
  "mkt.txExplorer": "View on the explorer",
  "mkt.txCheckSeller": "Before you confirm, open the transaction and check it went to your wallet, the amount, that the token is the official USDT and that it's confirmed.",
  "mkt.txMissingSeller": "The buyer says they paid but didn't add the transaction hash: ask for it in the chat.",
  "mkt.txUsed": "That hash already paid another order.",
  "mkt.txInvalid": "That hash isn't valid for this network. Copy the whole hash from your wallet.",
  "mkt.usdtExact": "This exact amount has to arrive, with every decimal: the last ones are your order's and show the seller the transfer is yours. If your exchange takes a fee, add it.",
  "mkt.usdtExactAuto": "This exact amount has to arrive, with every decimal: the last ones are your order's. If your exchange takes a fee, add it. With the hash, once the network confirms the transfer, the order confirms itself.",
  "mkt.txCheckSellerAmount": "Before you confirm, open the transaction and check it went to your wallet, that it's exactly {usdt} USDT (the official USDT) and that it's confirmed.",
  "mkt.txCheck.ok": "Verified on the network.",
  "mkt.txCheck.pending": "Waiting for the network to confirm the transaction. The order confirms itself once it does.",
  "mkt.txCheck.not_found": "It doesn't show up confirmed on the TRON network: the seller has to check it.",
  "mkt.txCheck.wrong_token": "This transaction isn't official USDT: the seller has to check it.",
  "mkt.txCheck.wrong_to": "This transaction didn't go to this order's wallet: the seller has to check it.",
  "mkt.txCheck.wrong_amount": "The amount isn't this order's exact amount: the seller has to check it and confirm.",
  "mkt.txCheck.too_old": "This transaction is from before the order: the seller has to check it.",
  "mkt.txCheck.used": "This transaction already paid another order.",
  "mkt.confirmPayment": "Payment received",
  "mkt.confirmPaymentMarked": "Confirm the payment arrived",
  "mkt.markShipped": "Mark as sent / handed over",
  "mkt.markReceived": "I got everything",
  "mkt.askHelp": "Ask pokefans.fun for help",
  "mkt.cancelOrder": "Cancel order",
  "mkt.reasonRequired": "Tell us what happened.",
  "mkt.discount": "Discount",
  "mkt.buyer": "Buyer",
  "mkt.seller": "Seller",
  "mkt.contactAfterPay": "Contact details show (and are emailed) once the order is paid or confirmed.",
  "mkt.tracking": "Tracking: {code}",
  "mkt.st.unpaidBuyer": "Pay the seller with the details below and tap \"I've paid\".",
  "mkt.st.unpaidMp": "Payment on Mercado Pago pending.",
  "mkt.st.unpaidSeller": "Waiting for the buyer to pay.",
  "mkt.st.markedBuyer": "You said you paid. The seller has to confirm it arrived.",
  "mkt.st.markedSeller": "The buyer says they paid: check your account and confirm.",
  "mkt.st.paidBuyer": "Payment confirmed. Arrange delivery in the chat.",
  "mkt.st.paidSeller": "Order paid. Arrange delivery and mark it as sent / handed over.",
  "mkt.st.shippedBuyer": "The seller sent / handed it over. Confirm when you have it; otherwise it completes on {date}.",
  "mkt.st.shippedSeller": "Sent. It completes when the buyer confirms, or on {date}.",
  "mkt.st.completed": "Order completed! Leave your review.",
  "mkt.st.disputed": "pokefans.fun is reviewing this order. Keep talking in the chat.",
  "mkt.st.cancelled": "Order cancelled. {reason}",
  "mkt.chat": "Order chat",
  "mkt.chatSafety": "For your safety, talk and pay only here. Never share passwords or codes.",
  "mkt.chatLabel": "Message",
  "mkt.chatPlaceholder": "Write a message…",
  "mkt.send": "Send",
  "mkt.reviewTitle": "Review",
  "mkt.theSeller": "the seller",
  "mkt.theBuyer": "the buyer",
  "mkt.rate": "Rate {who}",
  "mkt.reviewText": "Comment",
  "mkt.reviewPlaceholder": "How did it go? (optional)",
  "mkt.reviewSend": "Send review",
  "mkt.yourReview": "Your review:",
  "mkt.theirReview": "They rated you:",
  "mkt.replyLabel": "Reply",
  "mkt.replyPlaceholder": "Reply to this review (once)",
  "mkt.replySend": "Reply",
  "mkt.cancelTitle": "Cancel order",
  "mkt.cancelReason": "Reason",
  "mkt.cancelIntro": "The cards become available again. If it was paid, the seller must refund in full.",
  "mkt.disputeTitle": "Ask for help",
  "mkt.disputeReason": "What happened?",
  "mkt.disputeIntro": "Use it if you couldn't sort it out in the chat. pokefans.fun reviews the order and chat and mediates with the seller.",
  "mkt.shipTitle": "Sent / handed over",
  "mkt.trackingLabel": "Tracking number (optional)",
  "mkt.shipIntro": "Mark it when you ship it or hand it over.",
  "mkt.myShop": "My shop",
  "mkt.myShopHint": "Sell your cards in the market",
  "mkt.myMarket": "My market",
  "mkt.myMarketHint": "Purchases, offers, saved and wanted cards",
  "mkt.pendingTitle": "Your request is under review",
  "mkt.pendingText": "We'll email you as soon as we review it.",
  "mkt.pausedTitle": "Your shop is paused",
  "mkt.bannedTitle": "Your shop was closed",
  "mkt.reason": "Reason: {reason}",
  "mkt.mpConnected": "Done! Your Mercado Pago account is connected.",
  "mkt.mpError": "Couldn't connect Mercado Pago. Try again.",
  "mkt.setupPayments": "Set up at least one payment method in Settings so people can buy from you.",
  "mkt.cantSellYet": "This seller hasn't set up {what} yet. Once they do, you'll be able to buy.",
  "mkt.cantSellDelivery": "how they deliver",
  "mkt.cantSellPayment": "how they get paid",
  "mkt.and": " or ",
  "mkt.andBoth": " and ",
  "mkt.setupToSell": "Your listings aren't shown in the market until you set up {what}.",
  "mkt.setupWhatPayment": "how you get paid",
  "mkt.setupWhatDelivery": "how you deliver",
  "mkt.goToSettings": "Go to Settings",
  "mkt.tab.publicaciones": "Listings",
  "mkt.tab.ventas": "Sales",
  "mkt.tab.ofertas": "Offers",
  "mkt.tab.ajustes": "Settings",
  "mkt.tab.integraciones": "Integrations",
  "push.title": "Notifications on this device",
  "push.intro": "We let you know right away about purchases, sales, chat messages and offers, even when the site isn't open.",
  "push.enable": "Turn on notifications",
  "push.on": "On for this device.",
  "push.disable": "Turn off",
  "push.denied": "Notifications are blocked for pokefans.fun in this browser. Allow them from the site settings (the lock next to the address).",
  "push.iosInstall": "On iPhone they work in the installed app: tap Share › \"Add to Home Screen\", open pokefans.fun from the icon and turn them on here.",
  "inbox.label": "{count} waiting in the market",
  "inbox.label_one": "1 waiting in the market",
  "search.sellers": "Sellers",
  "search.sellerListings": "{count} listings",
  "search.sellerListings_one": "1 listing",
  "mkt.tab.estadisticas": "Stats",
  "mkt.tab.est_cartas": "Cards",
  "mkt.tab.est_precios": "Prices",
  "mkt.tab.demanda": "What people want",
  "mkt.tab.cupones": "Coupons",
  "mkt.tab.clientes": "Customers",
  "mkt.tab.emails": "Emails",
  "eml.teaser": "Emails to your customers and followers, with your cards and a coupon, sent by pokefans on your behalf: available on {plan}.",
  "eml.intro": "Write to a group of your customers or followers: pokefans picks the people (only those who accepted news and didn't turn you off) and sends the email on your behalf. You see how many got it, opened a card and bought.",
  "eml.paused": "pokefans isn't sending shops' emails yet: yours waits in the queue and goes out as soon as they're on.",
  "eml.blocked": "Your emails to customers are off: {reason}. Write to us if you think it's a mistake.",
  "eml.left": "{left} of {max} emails left this month.",
  "eml.rules": "Each person gets at most one email from you a week and four from all shops. No links to other sites or contact details: the rest goes through the order chat.",
  "eml.new": "New email",
  "eml.segment": "To",
  "eml.subject": "Subject",
  "eml.body": "Text",
  "eml.bodyHint": "Plain text. It starts with “Hola, <name>:” and ends with your cards and your coupon.",
  "eml.listings": "Cards to show (up to 6)",
  "eml.coupon": "Coupon (optional)",
  "eml.noCoupon": "No coupon",
  "eml.send": "Send",
  "eml.firstNote": "pokefans reviews your first one before it goes out; the next ones go out on their own.",
  "eml.empty": "You haven't sent any emails yet.",
  "eml.status.queued": "Queued",
  "eml.status.sending": "Going out",
  "eml.status.sent": "Sent",
  "eml.status.rejected": "Not sent",
  "eml.awaiting": "waiting for pokefans' review",
  "eml.results": "{sent} sent · {clicks} opened a card · {orders} orders",
  "eml.rejected": "Reason: {reason}",
  "eml.resultsFew": "Sent to fewer than 5 people: we don't show the numbers for this group.",
  "auto.title": "Automatic",
  "auto.intro": "Emails that go out on their own, with pokefans' text, to your customers (and followers, for news). They count for the same per-person limits and don't use your 4 a month.",
  "auto.thanks": "Thanks + coupon",
  "auto.thanksHint": "7 days after each completed purchase, once per buyer, with a personal coupon for the next one.",
  "auto.winback": "Come back",
  "auto.winbackHint": "To whoever hasn't bought in 60 days (once every 180), with your latest cards and, if you like, a coupon.",
  "auto.news": "News",
  "auto.newsHint": "Once a week, if you listed 5 cards or more, with up to 6 of them.",
  "auto.on": "On",
  "auto.save": "Save",
  "auto.saved": "Saved.",
  "auto.days": "Ends after (days)",
  "auto.results": "{sent} sent · {clicks} opened a card · {orders} orders",
  "eml.err.links": "Remove links to other sites and emails or contact details from the text.",
  "eml.err.emails_quota": "You've used this month's emails.",
  "eml.err.emails_blocked": "Your emails to customers are off.",
  "eml.err.validation": "Check the subject (3 to 80 characters) and the text (up to 2000).",
  "mkt.plan.rowEmails": "Emails to your customers and followers (per month)",
  "shopmail.title": "Shop emails",
  "shopmail.optoutText": "You won't get more emails from this shop through pokefans. Your other notices stay the same.",
  "shopmail.optoutButton": "No more from this shop",
  "shopmail.optoutDone": "Done: you won't get more emails from this shop.",
  "shopmail.spamText": "Did this shop's email feel like spam? Tell us: you stop getting that shop's emails and pokefans reviews its sending.",
  "shopmail.spamButton": "Report as spam",
  "shopmail.spamDone": "Thanks: you won't get more emails from that shop and we'll look into it.",
  "cus.teaser": "Your customers, groups (repeat, VIP, inactive), what else they buy and who's after what you have, with coupons for each group: available on {plan}.",
  "cus.customers": "Customers",
  "cus.repeat": "Repeat",
  "cus.repeatNote": "{pct}% of your customers",
  "cus.avgTicket": "Average order",
  "cus.repeatRevenue": "Of your money",
  "cus.repeatRevenueNote": "comes from people who had bought from you before",
  "cus.followers": "Followers",
  "cus.segment": "Group",
  "cus.sort": "Sort",
  "cus.sort.last": "Last purchase",
  "cus.sort.spent": "Most spent",
  "cus.sort.orders": "Most orders",
  "cus.seg.all": "All your customers",
  "cus.seg.new": "Bought once",
  "cus.seg.repeat": "Repeat (2 purchases or more)",
  "cus.seg.vip": "VIP (biggest spenders)",
  "cus.seg.recent": "Bought in the last 30 days",
  "cus.seg.inactive": "No purchase in over 60 days",
  "cus.seg.followers": "Follow you",
  "cus.seg.wants_my_stock": "Look for or saved cards you have",
  "cus.seg.boughtSet": "Bought from {set}",
  "cus.chip.new": "new",
  "cus.chip.repeat": "repeat",
  "cus.chip.vip": "VIP",
  "cus.chip.recent": "recent",
  "cus.chip.inactive": "inactive",
  "cus.colName": "Customer",
  "cus.colOrders": "Orders",
  "cus.colSpent": "Spent",
  "cus.colFirst": "First",
  "cus.colLast": "Last",
  "cus.lastOrder": "Last order",
  "cus.giveCoupon": "Give a coupon",
  "cus.couponFor": "Coupon for {name}",
  "cus.couponDays": "Ends in (days)",
  "cus.couponMade": "Done: {name} sees it in My coupons and when buying from you. Code {code}.",
  "cus.empty": "Nobody in this group has bought from you yet.",
  "cus.privacy": "You only see what they bought from you. For groups and emails, pokefans picks the people and you see how many.",
  "cus.interests": "Your customers also buy",
  "cus.interestsHint": "What your customers bought at other shops and at pokefans in the last 180 days. Only counts of people, and only when they are 5 or more.",
  "cus.interestsEmpty": "Not enough data yet (each row needs 5 different buyers).",
  "cus.sets": "Sets",
  "cus.categories": "Categories",
  "cus.pokemon": "Pokémon",
  "cus.buyers": "{count} customers",
  "cus.opportunities": "Opportunities",
  "cus.opportunitiesHint": "{count} of your customers or followers look for or saved cards you have listed. We don't show who: give them a coupon with the group “Look for or saved cards you have”.",
  "cus.opportunitiesEmpty": "None of your customers or followers is after what you have listed right now.",
  "cus.people": "{count} people",
  "cus.groupSize": "{count} people in this group now",
  "cus.groupSizeFew": "Fewer than 5 people in this group now",
  "cus.peopleFew": "fewer than 5 people",
  "cus.opportunitiesHintFew": "Fewer than 5 of your customers or followers look for or saved cards you have listed. We don't show who: give them a coupon with the group “Look for or saved cards you have”.",
  "mkt.plan.rowCustomers": "Customers: groups, what else they buy, opportunities and coupons per group or customer",
  "mkt.plan.rowApi": "API and integrations: your sheet or your system sync stock, prices and orders",
  "mkt.tab.cuponesBuyer": "My coupons",
  "myc.intro": "Coupons shops gave you: use them at that shop's checkout.",
  "myc.empty": "You have no coupons right now.",
  "myc.personal": "just for you",
  "myc.until": "until {date}",
  "myc.atCheckout": "You have a coupon from this shop: {code} ({off}).",
  "cpn.intro": "A coupon is a discount on your own prices: it applies at your shop's checkout, never on delivery or together with an accepted offer. The buyer still pays you directly.",
  "cpn.limit": "Your plan allows {count} active coupons at a time.",
  "cpn.limit_one": "Your plan allows 1 active coupon at a time, for the whole shop.",
  "cpn.new": "New coupon",
  "cpn.code": "Code",
  "cpn.codeHint": "4 to 16 letters or digits, no spaces (e.g. WELCOME).",
  "cpn.kind": "Type",
  "cpn.percent": "Percentage",
  "cpn.amount": "Fixed amount",
  "cpn.value": "Discount",
  "cpn.minSubtotal": "Minimum purchase (optional)",
  "cpn.maxDiscount": "Discount cap (optional)",
  "cpn.scope": "For",
  "cpn.scope.shop": "The whole shop",
  "cpn.scope.products": "Some cards",
  "cpn.scope.set": "A set",
  "cpn.scope.segment": "A group of customers",
  "cpn.scope.user": "One customer",
  "cpn.products": "Cards",
  "cpn.set": "Set",
  "cpn.usesMax": "Total uses (optional)",
  "cpn.perUser": "Uses per buyer",
  "cpn.endsAt": "Ends (optional)",
  "cpn.create": "Create coupon",
  "cpn.empty": "You haven't made any coupons yet.",
  "cpn.uses": "{count} uses",
  "cpn.uses_one": "1 use",
  "cpn.usesOf": "{count} of {max} uses",
  "cpn.discounted": "{amount} off in all",
  "cpn.status.active": "Active",
  "cpn.status.paused": "Paused",
  "cpn.status.ended": "Ended",
  "cpn.pausedPlan": "paused: your plan no longer includes it",
  "cpn.pausedAdmin": "paused by pokefans.fun",
  "cpn.until": "until {date}",
  "cpn.from": "from {date}",
  "cpn.min": "minimum {amount}",
  "cpn.cap": "cap {amount}",
  "cpn.pause": "Pause",
  "cpn.resume": "Resume",
  "cpn.end": "End",
  "cpn.endConfirm": "End coupon {code}? It can't be used again.",
  "cpn.err.coupon_limit": "Your plan allows no more active coupons: pause or end another one first.",
  "cpn.err.coupon_code_taken": "You already have a coupon with that code.",
  "cpn.err.plan_required": "Your plan doesn't include that kind of coupon.",
  "cpn.err.validation": "Check the coupon's details.",
  "cpn.public": "🏷️ Coupon {code}: {off}",
  "cpn.off.percent": "{value}% off",
  "cpn.off.amount": "{value} off",
  "cpn.publicMin": " on orders from {amount}",
  "mkt.coupon": "Coupon",
  "mkt.couponHave": "Got a coupon?",
  "mkt.couponApply": "Apply",
  "mkt.couponRemove": "Remove coupon",
  "mkt.couponUse": "Use it",
  "mkt.couponLine": "Coupon {code}",
  "mkt.couponWithOffer": "Coupons don't add to an accepted offer.",
  "mkt.couponErr.coupon_not_found": "That coupon doesn't exist at this shop.",
  "mkt.couponErr.coupon_other_shop": "That coupon is another shop's.",
  "mkt.couponErr.coupon_inactive": "That coupon isn't active.",
  "mkt.couponErr.coupon_not_started": "That coupon hasn't started yet.",
  "mkt.couponErr.coupon_expired": "That coupon has expired.",
  "mkt.couponErr.coupon_used_up": "That coupon has been used as many times as it allowed.",
  "mkt.couponErr.coupon_already_used": "You already used that coupon.",
  "mkt.couponErr.coupon_min": "That coupon is for orders from {min}.",
  "mkt.couponErr.coupon_no_lines": "That coupon doesn't cover these cards.",
  "mkt.couponErr.coupon_with_offer": "Coupons don't add to an accepted offer.",
  "mkt.couponErr.coupon_not_for_you": "That coupon is someone else's.",
  "mkt.couponErr.other": "We couldn't check the coupon. Try again.",
  "mkt.bulkPart": "Bulk discount",
  "perf.sources": "Where your visits come from",
  "perf.sourcesHint": "Counted since we started recording it. Your short link and QR count as “Your QR or short link”.",
  "perf.sourcesEmpty": "No visits with a recorded source in this period yet.",
  "perf.src.search": "Market search",
  "perf.src.product": "The card's page",
  "perf.src.shop": "Your shop",
  "perf.src.featured": "Featured",
  "perf.src.email": "Your emails",
  "perf.src.qr": "Your QR or short link",
  "perf.src.external": "Other sites (Instagram, WhatsApp…)",
  "perf.src.other": "Other pages",
  "perf.rotationText": "Your cards take {days} days to sell (median of {count} sales).",
  "perf.rotationNone": "No completed sales yet to work it out.",
  "perf.noViews": "No visits in 30 days",
  "perf.noViewsHint": "Listed a month ago or more and nobody looked at them in the last 30 days: lower the price or pause them.",
  "perf.savedNotSold": "Saved but not sold",
  "perf.savedNotSoldHint": "People save them as favorites but don't buy: try featuring them or lowering the price a bit.",
  "perf.favorites": "{count} favorites",
  "perf.lowerPrice": "Lower price",
  "perf.pause": "Pause",
  "perf.paused": "Paused",
  "perf.feature": "Feature",
  "perf.featured": "Featured",
  "perf.none": "None.",
  "rep.title": "Emails for you",
  "rep.teaser": "A summary of your week every Monday, alerts about your prices against the market and a monthly summary for your accountant: available on {plan}.",
  "rep.weekly": "Summary of my week (Mondays)",
  "rep.prices": "Price alerts (Mondays, if a listing got pricey)",
  "rep.saved": "Saved.",
  "rep.accounting": "Summary for the accountant",
  "rep.accountingHint": "Completed orders of the last 12 months, by month and payment method (without shipping quoted in the chat). It's only what you charged: pokefans.fun issues no invoices.",
  "rep.accountingDownload": "Download for Excel",
  "serverPage.open": "Open the page",
  "wh.title": "Webhooks",
  "wh.count": "{count} of {max} webhooks",
  "wh.hint": "Get a signed notification (HTTP POST) on your server whenever something happens in your shop: orders, payments, messages or listing changes.",
  "wh.url": "URL (https)",
  "wh.description": "Description (optional)",
  "wh.events": "Events",
  "wh.all": "All events",
  "wh.pick": "Pick events",
  "wh.listingHint": "Not to miss a listing's changes, pick all the listing events: a simultaneous price and stock change arrives as “Stock change”, with the whole listing.",
  "wh.create": "Create webhook",
  "wh.created": "Copy the signing secret and keep it somewhere safe: you need it to verify each notification and it won't be shown again.",
  "wh.rotated": "Copy the new secret now. For 24 hours each notification carries both signatures, the previous and the new one.",
  "wh.active": "Active",
  "wh.failing": "Failing since {date}",
  "wh.off": "Off",
  "wh.offFailing": "Switched off after 3 days of failures. Fix the endpoint and turn it back on: pending notifications go out.",
  "wh.allEvents": "All",
  "wh.someEvents": "{count} events",
  "wh.test": "Test",
  "wh.testOk": "Answered {code} in {ms} ms",
  "wh.testFail": "Didn't answer well: {error}",
  "wh.rotate": "Rotate secret",
  "wh.deliveries": "Deliveries",
  "wh.noDeliveries": "No deliveries yet.",
  "wh.retry": "Retry",
  "wh.retried": "Queued",
  "wh.turnOff": "Turn off",
  "wh.turnOn": "Turn on",
  "wh.delete": "Delete",
  "wh.deleteConfirm": "Delete the webhook to {url}? It stops getting notifications.",
  "wh.limit": "You've reached your plan's {max} webhooks.",
  "wh.badUrl": "It must be a public https URL (not an internal address).",
  "wh.status.ok": "delivered",
  "wh.status.pending": "retrying",
  "wh.status.dead": "failed",
  "wh.status.skipped": "skipped",
  "wh.ev.order.created": "New order",
  "wh.ev.order.payment_claimed": "The buyer says they paid",
  "wh.ev.order.confirmed": "Cash order confirmed",
  "wh.ev.order.paid": "Order paid",
  "wh.ev.order.shipped": "Order shipped",
  "wh.ev.order.handed": "Handed over in person",
  "wh.ev.order.completed": "Order completed",
  "wh.ev.order.cancelled": "Order cancelled",
  "wh.ev.order.disputed": "Order disputed",
  "wh.ev.order.updated": "Other order changes",
  "wh.ev.order.message.created": "Message on an order",
  "wh.ev.offer.created": "New offer",
  "wh.ev.offer.accepted": "Offer accepted",
  "wh.ev.offer.expired": "Offer expired",
  "wh.ev.listing.created": "New listing",
  "wh.ev.listing.updated": "Listing changed",
  "wh.ev.listing.stock_changed": "Stock change",
  "wh.ev.listing.sold_out": "Listing sold out",
  "wh.ev.listing.removed": "Listing deleted",
  "wh.ev.review.created": "New review",
  "wh.ev.want.matched": "Someone looks for a card you listed",
  "api.log": "Activity log",
  "api.logEmpty": "No requests with your keys yet.",
  "api.logHint": "Last 30 days: every write and error, and a sample of successful reads.",
  "api.title": "Integrations (API)",
  "wh.testLabel": "Test",
  "wh.failingPill": "Failing",
  "wh.rotatedTitle": "Secret rotated",
  "wh.createdTitle": "Webhook created",
  "wh.colResponse": "Response",
  "wh.colResult": "Result",
  "wh.colEvent": "Event",
  "wh.colStatus": "Status",
  "wh.colUrl": "Endpoint",
  "wh.empty": "No webhooks set up.",
  "wh.new": "New webhook",
  "api.lapsed": "Integrations are included in the {plan} plan.",
  "api.teaserShort": "Connect your system or spreadsheet and keep the stock and prices of your listings up to date automatically. Included in {plan}.",
  "api.teaser": "Connect your system or spreadsheet and keep the stock and prices of your {count} listings up to date automatically. Included in {plan}.",
  "api.logHide": "Hide",
  "api.logShow": "View log",
  "api.scopeShort.webhooks:manage": "Webhooks",
  "api.scopeShort.orders:write": "Orders: write",
  "api.scopeShort.orders:read": "Orders: read",
  "api.scopeShort.listings:write": "Listings: write",
  "api.scopeShort.listings:read": "Listings: read",
  "api.createdTitle": "Key created",
  "api.colKeyName": "Key",
  "api.colMs": "Duration",
  "api.colStatus": "Status",
  "api.colRequest": "Request",
  "api.colDate": "Date",
  "api.colActions": "Actions",
  "api.colLastUsed": "Last used",
  "api.colScopes": "Permissions",
  "api.colKey": "Key",
  "api.colName": "Name",
  "api.empty": "You haven't created any keys yet.",
  "api.cancel": "Cancel",
  "api.new": "New key",
  "api.keysHint": "We recommend one key per system, so you can revoke one without affecting the others.",
  "api.keysTitle": "API keys",
  "api.baseUrl": "Base URL",
  "api.count": "{count} of {max} keys",
  "api.hint": "Connect your management system, spreadsheet or your own scripts to the shop through the REST API: listings, stock, prices and orders.",
  "api.docs": "API documentation",
  "api.teaserCta": "See {plan}",
  "api.name": "Name (to tell it apart)",
  "api.namePlaceholder": "Sheet, Tiendanube, my script…",
  "api.scopes": "What it can do",
  "api.scope.listings:read": "See listings",
  "api.scope.listings:write": "Create and change listings, stock and prices",
  "api.scope.orders:read": "See orders",
  "api.scope.orders:write": "Act on orders (confirm payment, shipped, handed over, cancel)",
  "api.scope.webhooks:manage": "Set up automatic notices (webhooks)",
  "api.create": "Create key",
  "api.created": "Copy it and keep it somewhere safe: this is the only time you'll see it. If you lose it, revoke it and create another.",
  "api.copy": "Copy",
  "api.copied": "Copied",
  "api.neverUsed": "Never",
  "api.revoke": "Revoke",
  "api.revokeConfirm": "Revoke the key “{name}”? Whatever uses it stops working right away.",
  "api.limit": "You've reached your plan's {max} keys: revoke one to create another.",
  "qr.title": "Quick replies",
  "qr.hint": "Texts you use often in order chats (how to pay, when you ship, how you pack cards). In the chat, one tap puts it in the message: then you check it and send it.",
  "qr.count": "{count} of {max}",
  "qr.teaser": "Quick replies for order chats: available on {plan}.",
  "qr.titleLabel": "Name",
  "qr.bodyLabel": "Text",
  "qr.add": "Save reply",
  "qr.remove": "Delete",
  "qr.limit": "Your plan allows no more quick replies: delete one first.",
  "qr.inChat": "Quick replies:",
  "link.title": "Your short link and QR",
  "link.hint": "Your link for your Instagram or WhatsApp bio. The QR, for your table at an event or your parcels: Performance shows the visits that come from the QR.",
  "link.copy": "Copy link",
  "link.download": "Download QR",
  "ins.funnel": "Funnel per listing",
  "ins.funnelHint": "From visit to sale, in the period. Conversion: orders per 100 visits, counted only since visits are recorded.",
  "ins.funnelEmpty": "You have no listings yet.",
  "ins.colOffers": "Offers",
  "ins.colOrders": "Orders",
  "ins.colUnits": "Units",
  "ins.colConversion": "Conversion",
  "ins.prices": "Your price against the market",
  "ins.pricesEmpty": "You have no live ungraded listings.",
  "ins.alone": "You're the only one selling it",
  "ins.cheapest": "You're the cheapest",
  "ins.above": "{pct}% above the median",
  "ins.below": "{pct}% below the median",
  "ins.atMedian": "At the median",
  "ins.priceRow": "You: {mine} · median {median} · lowest {min} · {count} other offers",
  "ins.priceRow_one": "You: {mine} · the other offer: {min}",
  "ins.response": "You answer in the chat in",
  "ins.dispatch": "You ship an order in",
  "ins.samples": "median of {count} orders",
  "ins.samples_one": "1 order",
  "ins.timesNote": "Only you see these times.",
  "todo.title": "To do today",
  "todo.none": "Nothing pending: you're up to date.",
  "todo.confirmPayment": "Confirm the payment arrived",
  "todo.unpaid": "Unpaid for over a day",
  "todo.deliver": "To ship or hand over",
  "todo.unanswered": "Messages to answer",
  "todo.reviews": "Reviews to reply to",
  "todo.more": "and {count} more in Sales",
  "show.demand.title": "What people want",
  "show.demand.number": "{count} people saved cards you have in «Busco».",
  "show.demand.number_one": "1 person saved a card you have in «Busco».",
  "show.demand.hint": "They didn't post it on Se busca, so you only hear of it with {plan}: we tell you the moment someone adds it.",
  "show.demand.verb": "See which",
  "show.customers.title": "You've sold. The hard part is done.",
  "show.customers.number": "{count} customers bought from you more than once.",
  "show.customers.number_one": "1 customer bought from you more than once.",
  "show.customers.hint": "With {plan} you see who they are, group them and send them a coupon to come back.",
  "show.customers.verb": "See who bought",
  "show.emails.title": "Emails to your customers",
  "show.emails.number": "{count} customers and followers would get your news.",
  "show.emails.number_one": "1 customer or follower would get your news.",
  "show.emails.hint": "With {plan} you write to them {emails} times a month from pokefans.",
  "show.emails.verb": "Write to them",
  "show.price.title": "Your price against the market",
  "show.price.number": "{count} of your listings are above the market median.",
  "show.price.number_one": "1 of your listings is above the market median.",
  "show.price.hint": "With {plan} you see which and by how much, and how long you take to answer and ship.",
  "show.price.verb": "See which",
  "show.feature.title": "Featured",
  "show.feature.number": "A listing of yours has {count} favorites and no sale.",
  "show.feature.number_one": "A listing of yours has 1 favorite and no sale.",
  "show.feature.hint": "With {plan} you feature it 7 days over the market's results.",
  "show.feature.verb": "Feature it",
  "show.first_sale.title": "You've sold. Want them to buy again?",
  "show.first_sale.number": "{count} people already bought from you.",
  "show.first_sale.number_one": "Someone already bought from you: the hard part is done.",
  "show.first_sale.hint": "Someone who bought once comes back more easily. With {plan} you see who they are and send them a coupon and your news.",
  "show.first_sale.verb": "See who bought",
  "show.coupons.title": "Coupons for your shop",
  "show.coupons.number": "A welcome coupon brings back whoever looked and didn't buy.",
  "show.coupons.sample": "10% off in your shop",
  "show.coupons.hint": "With {plan} you create your coupon and share it: whoever uses it pays less in your shop.",
  "show.coupons.verb": "Create my coupon",
  "show.shop.tagline": "Your line, your color and your logo",
  "show.shop.number": "This is how your shop would look with your own banner, logo and color.",
  "show.shop.links": "Your {count} social links go at the top.",
  "show.shop.links_one": "Your social link goes at the top.",
  "show.shop.verb": "Customize my shop",
  "offer.featureFirst": "{count} people have it in favorites: feature it before lowering the price.",
  "offer.featured": "Done! It's featured for 7 days.",
  "limit.listingTitle": "This card doesn't fit",
  "limit.listingText": "You have {live} live listings, the most the {plan} plan allows.",
  "limit.listingNext": "With {plan} you list this one and {more} more.",
  "limit.listingNextNoLimit": "With {plan} you list with no limit.",
  "limit.featured": "And you feature {count} a month.",
  "limit.priceTitle": "This card is worth more than your plan allows",
  "limit.priceText": "The {plan} plan allows listings up to {max}.",
  "limit.priceNext": "With {plan} you list up to {max}.",
  "limit.priceNextNoLimit": "With {plan} you list at any price.",
  "limit.saved": "It was saved, paused: nothing is lost.",
  "limit.upgrade": "Move to {plan}",
  "limit.pauseOther": "Pause another listing",
  "limit.lowerPrice": "Lower the price",
  "nl.quota": "{live} of {max} live listings",
  "nl.quotaLow": "You have {count} listings left. Cards you don't list don't sell.",
  "nl.quotaLow_one": "You have 1 listing left. Cards you don't list don't sell.",
  "todo.offers": "Offers to answer",
  "mkt.tab.inicio": "Home",
  "mkt.tab.mas": "More",
  "mkt.tab.pedidos": "Orders",
  "mkt.tab.plan": "Plan",
  "mkt.tab.tienda": "Shop design",
  "sp.toSite": "Back to pokefans.fun",
  "sig.views": "{count} visits in 30 days",
  "sig.views_one": "1 visit in 30 days",
  "sig.above": "{pct}% over the market",
  "sig.noViews": "No visits in 30 days",
  "sig.wanting": "{count} want it",
  "sig.wanting_one": "1 wants it",
  "sig.seeWanted": "See who wants it",
  "lst.more": "More actions",
  "sp.search": "Search my shop",
  "sp.searchHint": "Order, buyer or card ( / )",
  "sp.searchNone": "Nothing like that in your shop.",
  "sp.bell": "Alerts",
  "sp.bellCount": "{count} things to do",
  "sp.bellCount_one": "1 thing to do",
  "sp.bellAll": "See everything on Home",
  "home.week": "Last 7 days",
  "home.orders": "{count} sales",
  "home.orders_one": "1 sale",
  "home.views": "{count} visits",
  "home.views_one": "1 visit",
  "home.shop": "Your shop",
  "home.liveOf": "{live} of {max} live listings",
  "home.live": "{count} live listings",
  "home.live_one": "1 live listing",
  "home.noViews": "{count} without visits in 30 days",
  "home.noViews_one": "1 without visits in 30 days",
  "home.publish": "List a card",
  "home.import": "Import a sheet",
  "home.seeShop": "See my shop",
  "home.plan": "{plan} plan",
  "home.planListings": "{live}/{max} listings",
  "home.planFeatured": "{count} featured left",
  "home.planFeatured_one": "1 featured left",
  "home.seePlans": "See plans",
  "home.planEnding": "Your {plan} plan ends on {date}.",
  "home.start": "Towards your first sale",
  "home.startMp": "Connect Mercado Pago",
  "home.startListings": "List {max} cards ({live} of {max})",
  "home.startVerify": "Ask to be verified",
  "home.startShare": "Share your shop's link",
  "home.pendingReview": "We're reviewing your request to sell.",
  "home.pendingPrepare": "Prepare your listings",
  "home.pendingSettings": "Set up payment and delivery",
  "acct.shopNone": "Got cards to sell?",
  "acct.shopOpen": "Open your shop",
  "acct.shopPending": "under review",
  "acct.shopTodo": "{count} things to do today",
  "acct.shopTodo_one": "1 thing to do today",
  "acct.shopAllDone": "all caught up",
  "acct.shopGo": "Go to my shop",
  "todo.meeting": "Handovers agreed for today or tomorrow",
  "todo.connectMp": "Connect Mercado Pago to take cards",
  "todo.soldout": "Listings out of stock",
  "todo.couponEnding": "Coupons ending within 48 hours",
  "todo.verify": "Ask for the Verified badge",
  "todo.allDone": "All caught up ✓",
  "todo.all": "See all ({count})",
  "todo.fewer": "See less",
  "todo.dismiss": "Hide: {task}",
  "todo.dismissHint": "Hide this task (it comes back when something new arrives)",
  "todo.dismissFailed": "That didn't work. Try again.",
  "todo.hidden": "{count} hidden tasks.",
  "todo.hidden_one": "1 hidden task.",
  "todo.restore": "Show them again",
  "todo.seeSales": "See in Sales",
  "qa.title": "Quick actions",
  "qa.reserve": "Hold for a customer",
  "qa.coupon": "Create a coupon",
  "qa.copy": "Copy the shop's link",
  "qa.copied": "Link copied!",
  "qa.locked": "{action}: available on {plan}",
  "home.followers": "{count} new followers",
  "home.followers_one": "1 new follower",
  "home.weeksChart": "Sales over the last 8 weeks",
  "home.soldOut": "{count} out of stock",
  "home.soldOut_one": "1 out of stock",
  "home.opportunities": "Opportunities",
  "home.recentOrders": "Latest sales",
  "home.recentMessages": "Latest messages",
  "home.next.confirm": "Confirm payment",
  "home.next.deliver": "Hand over",
  "home.next.view": "View",
  "home.next.reply": "Reply",
  "home.reviewTitle": "So we can approve you",
  "home.reviewPhoto": "Send the verification photo",
  "home.reviewPayment": "Choose how you get paid",
  "home.reviewDelivery": "Choose how you deliver",
  "home.reviewListings": "Prepare your first listings",
  "home.reviewListingsCap": "Prepare your first listings (up to {n} go live with your plan once approved)",
  "guide.progress": "{done} of {total}",
  "guide.progressLabel": "Getting started progress",
  "guide.optional": "optional",
  "guide.recommended": "recommended",
  "guide.ownerDoes": "The shop's owner does this.",
  "guide.toSettings": "Go to Settings",
  "guide.publish": "List a card",
  "guide.photoWhy": "A photo of one of your cards with your @handle and the date handwritten: that's how we know the shop is yours. Only the pokefans team sees it.",
  "guide.photoCta": "Upload the photo",
  "guide.paymentWhy": "Without a way to get paid nobody can buy from you: bank transfer, Mercado Pago, crypto or cash in hand.",
  "guide.deliveryWhy": "Buyers choose from what you offer: shipping, in hand, pickup or to be agreed.",
  "guide.firstListingWhy": "Load them now and they go on sale as soon as we approve the shop.",
  "guide.bio": "Tell buyers who you are",
  "guide.bioWhy": "A few lines about you or your shop ({n} characters or more) build trust with first-time buyers.",
  "guide.bioCta": "Write the intro",
  "guide.listingsWhy": "Shops with few cards hardly get any visits.",
  "guide.mpWhy": "With Mercado Pago your buyers pay with Protected purchase: it gives them the confidence to buy from a new shop.",
  "guide.mpCta": "Connect Mercado Pago",
  "guide.verifyWhy": "The 🪪 Verified badge shows buyers we checked your shop.",
  "guide.verifyCta": "Ask to be verified",
  "guide.dismiss": "Close the guide",
  "guide.dismissFailed": "We couldn't close the guide. Try again.",
  "csv.title": "Export orders",
  "csv.hint": "A file for Excel with your orders on those dates (up to a year), with the buyer, payment method and amounts.",
  "csv.from": "From",
  "csv.to": "To",
  "csv.download": "Download for Excel",
  "csv.teaser": "Export your orders to Excel: available on {plan}.",
  "mkt.plan.rowInsights": "Funnel per listing, price against the market and order export",
  "mkt.plan.rowCoupons": "Active discount coupons (EX: for the whole shop; VMAX: also per card, set, customer group or customer)",
  "st.period": "Period",
  "st.period30": "30 days",
  "st.period90": "90 days",
  "st.periodAll": "All time",
  "st.sales": "Completed sales",
  "st.revenue": "{amount} in cards",
  "st.avgTicket": "Average order",
  "st.views": "Visits to your listings",
  "st.viewsSince": "since {date}",
  "st.viewsNone": "none yet",
  "st.offers": "Offers received",
  "st.offersAccepted": "{count} accepted",
  "st.offersAccepted_one": "1 accepted",
  "st.salesNote": "Sales count on the day they complete and amounts are what you sold in cards, without shipping. Visits are to each listing's page (yours don't count).",
  "st.tabSummary": "Summary",
  "st.pricesToday": "Today's prices, against other shops' live listings of the same card, condition, language and finish (ungraded).",
  "st.cancelledNote": "{count} cancelled",
  "st.cancelledNote_one": "1 cancelled",
  "st.avgTicketNote": "per completed sale",
  "st.nowLabel": "Now:",
  "st.nowOrders": "{count} orders in progress",
  "st.nowOrders_one": "1 order in progress",
  "st.nowFavorites": "{count} saved as favorites",
  "st.nowFavorites_one": "1 saved as favorite",
  "st.nowFollowers": "{count} followers",
  "st.nowFollowers_one": "1 follower",
  "st.repTimes": "Your reputation and your times",
  "st.repHint": "What buyers see, from the last 90 days.",
  "ins.recent": "Your times in the last 30 days",
  "st.howWeCount": "How do we count?",
  "perf.needsPush": "Need a push",
  "st.lockedFunnel": "With {plan} you see how many visits end in a sale, for each listing.",
  "st.lockedFunnelVerb": "See my funnel",
  "st.lockedPush": "With {plan} you see which ones nobody looks at and which get saved but not bought, with the button to pause or feature them.",
  "st.lockedPushVerb": "See which",
  "st.lockedPrices": "With {plan} you see each listing against the market's median.",
  "st.lockedPricesVerb": "See my prices",
  "st.chartWeeks": "Sales per week",
  "st.chartMonths": "Sales per month",
  "st.chartEmpty": "No completed sales in this period yet.",
  "st.bar": "{when}: {count} sales, {amount}",
  "st.bar_one": "{when}: 1 sale, {amount}",
  "st.response": "You reply in",
  "st.cancelPct": "Your cancellations",
  "st.onTimePct": "Sent on time",
  "st.top": "Your most viewed listings",
  "st.topNone": "You have no listings yet.",
  "st.colViews": "Visits",
  "st.colFavorites": "Saved",
  "st.colSold": "Sold",
  "st.pricing": "Improve your price",
  "st.pricingNone": "None: nobody has the same card cheaper than you.",
  "st.pricingRow": " · You: {mine} · {count} cheaper, from {min}.",
  "st.pricingRow_one": " · You: {mine} · 1 cheaper, at {min}.",
  "st.pricingStore": "The store has it at {store}.",
  "st.demand": "Who wants your cards",
  "st.demandHint": "People who marked \"I want it\" on cards you list. We don't show who.",
  "st.demandNone": "Nobody marked \"I want it\" on your cards yet.",
  "st.demandRow": " · {count} looking for it · you: {price}.",
  "st.demandRow_one": " · 1 person looking for it · you: {price}.",
  "st.demandBelow": "{count} would pay less than your price (the highest, {max}).",
  "st.demandBelow_one": "1 would pay less than your price ({max}).",
  "mkt.tab.compras": "Purchases",
  "mkt.tab.favoritos": "Saved",
  "mkt.tab.busco": "Wanted",
  "mkt.tab.seguidos": "Following",
  "mkt.applyTitle": "Sell your cards",
  "mkt.applyIntro": "Open your shop in the community market. We review every request by hand.",
  "mkt.applyPoint1": "You get paid directly: your Mercado Pago, bank transfer or crypto. No fees.",
  "mkt.applyPoint2": "You choose how to deliver: by hand in Buenos Aires, shipping, a pickup point or arranged.",
  "mkt.applyPoint3": "Your own original single cards and sealed products (packs, ETBs, boxes, decks and collections). No proxies, fakes or resealed products.",
  "mkt.rejected": "We didn't approve your previous request. {reason}",
  "mkt.handle": "Shop username",
  "mkt.handleHint": "3 to 20 lowercase letters, numbers or _. It goes in pokefans.fun/vendedores/…",
  "mkt.handleError": "Use 3 to 20 lowercase letters, numbers or _.",
  "mkt.handleTaken": "That name is taken.",
  "mkt.shopName": "Display name",
  "mkt.contactPhone": "Contact phone",
  "mkt.contactPhoneHint": "Not public: buyers see it once they pay.",
  "mkt.socialUrl": "Link to a social network or shop (optional)",
  "mkt.socialUrlHint": "Share a social network link that lets us check you're a seller or collector (Instagram, Facebook, TikTok, Mercado Libre, Cardmarket…). If you don't have one, we can still approve you, with limits: cash and in-person handover only until your first sales.",
  "mkt.socialUrlError": "Enter a valid link, e.g. instagram.com/your_user.",
  "mkt.kind": "Who is selling?",
  "mkt.kindPerson": "A person",
  "mkt.kindPersonHint": "You sell under your own name (also as a sole trader). We ask for a verification photo and your birth date.",
  "mkt.kindCompany": "A company",
  "mkt.kindCompanyHint": "A business with a legal name and CUIT (starting with 30, 33 or 34). Buyers see both on your shop.",
  "mkt.legalName": "Legal name",
  "mkt.legalNameError": "Enter the legal name, as registered with ARCA.",
  "mkt.cuit": "Company CUIT",
  "mkt.cuitError": "Check the CUIT: it must be a company's (30, 33 or 34) and have 11 digits.",
  "mkt.companyReview": "We check your company's legal name and CUIT: no verification photo needed.",
  "mkt.companyLine": "Company: {name} · CUIT {cuit}",
  "mkt.birthDate": "Date of birth",
  "mkt.birthDateHint": "You must be 18 or older to sell. It isn't public: only the pokefans.fun team sees it.",
  "mkt.birthDateError": "Enter a valid date of birth.",
  "mkt.birthDateMinor": "You must be 18 or older to sell on the market.",
  "mkt.province": "Province",
  "mkt.bio": "About you (public)",
  "mkt.applyNote": "Anything for us?",
  "mkt.applyNoteHint": "What you'll sell, whether you already sell elsewhere (Instagram, groups, events)…",
  "mkt.acceptSellerTerms": "I accept the",
  "mkt.applyError": "Check the highlighted fields.",
  "mkt.verifyTitle": "Verification",
  "mkt.verifyPhoto": "Verification photo",
  "mkt.verifyPhotoHint": "Take a photo of your most valuable card next to a handwritten note with your shop's @username and today's date. Only we see it, to approve you.",
  "mkt.verifyPhotoError": "We couldn't upload the photo: try another JPG, PNG or WebP.",
  "mkt.verifyPhotoMissingShort": "The verification photo is missing.",
  "mkt.verifyPhotoSent": "✅ We got your verification photo.",
  "mkt.verifyPhotoMissing": "Your verification photo is missing: we can't approve you without it.",
  "mkt.verifyPhotoUpload": "Upload verification photo",
  "mkt.verifyPhotoChange": "Change the verification photo",
  "mkt.verifySocialMissing": "If you have a social network where we can see you sell or collect, add the link (without one, we can approve you with limits):",
  "mkt.verifySave": "Save link",
  "mkt.blockedApply": "We can't accept this request. If you think it's a mistake, write to us.",
  "mkt.blockedBank": "We can't accept that bank account. If you think it's a mistake, write to us.",
  "mkt.applySend": "Send request",
  "mkt.newListing": "List a card or a sealed product",
  "mkt.noListings": "You haven't listed anything yet.",
  "mkt.findCard": "Find the card in the catalog",
  "mkt.findCardHint": "Name, set or number (e.g. charizard 151, pikachu 25)",
  "mkt.noCardFound": "Not found. Try another name or the number.",
  "mkt.searchCards": "Search",
  "mkt.pickKind": "Type",
  "mkt.pickKindAll": "Everything (cards and sealed)",
  "mkt.pickSet": "Set",
  "mkt.pickSetAll": "All sets",
  "mkt.seeAllCards": "See every card for \"{q}\"",
  "mkt.cardResults": "{count} results for \"{q}\". Tap the right one.",
  "mkt.cardResults_one": "1 result for \"{q}\". Tap the right one.",
  "mkt.cardResultsFuzzy": "We didn't find \"{q}\" as typed; here are {count} similar ones.",
  "mkt.cardResultsFuzzy_one": "We didn't find \"{q}\" as typed; here's 1 similar one.",
  "mkt.closeResults": "Close results",
  "mkt.moreCards": "See more",
  "mkt.changeCard": "Change card",
  "mkt.grader": "Grading",
  "mkt.notGraded": "Ungraded",
  "mkt.grade": "Grade",
  "mkt.priceArs": "Price per unit ($)",
  "mkt.listingNotes": "Details (optional)",
  "mkt.sealedNote": "Sealed product: it must be original and factory-sealed (no resealed or weighed packs).",
  "nl.progress": "Steps to list",
  "nl.id.button": "Identify with a photo",
  "nl.id.reading": "Reading the card…",
  "nl.id.pick": "Is it one of these?",
  "nl.id.none": "We didn't find that card in the catalog: search it by name or number.",
  "nl.id.ocr_failed": "We couldn't read the card. Try better light, closer and without glare.",
  "nl.id.unsupported_language": "For now we only recognize cards in Spanish or English.",
  "nl.id.unsupported_image": "The photo couldn't be opened. Try another one.",
  "nl.id.image_too_large": "The photo is too large.",
  "nl.id.rate_limited": "Too many photos in a row: try again in a minute.",
  "nl.id.error": "The photo couldn't be read. Try again or search it by name.",
  "nl.step1": "Which card?",
  "nl.step2": "What condition?",
  "nl.step3": "How much?",
  "nl.graded": "It's graded",
  "nl.more": "More options (finish, details)",
  "nl.next": "Next",
  "nl.back": "Back",
  "nl.less": "One less",
  "nl.more1": "One more",
  "nl.repeat": "Same as the last one: {what}",
  "nl.sealedShort": "Sealed",
  "nl.repeatHint": "Same price and quantity as the last one: check it suits this card.",
  "nl.publish": "List it",
  "nl.save": "Save (it goes live when we approve you)",
  "nl.publishing": "Listing…",
  "nl.openSaved": "It was saved, paused: open it",
  "nl.savedPaused": "It was saved, paused, but couldn't be finished. Try again.",
  "nl.doneLive": "Listed",
  "nl.donePending": "Saved: it goes live when we approve you",
  "nl.another": "List another",
  "nl.addPhotos": "Add photos",
  "nl.see": "See listing",
  "nl.close": "Close",
  "nl.refNone": "Nobody sells it on pokefans yet.",
  "nl.refSale": "Last sale on pokefans: {price}",
  "nl.refMedian": "Median on pokefans {price}",
  "nl.refMin": "lowest {price}",
  "nl.refSellers": "{count} sellers",
  "nl.refSellers_one": "1 seller",
  "nl.photosOptional": "Your photos of the card's condition (optional)",
  "nl.errPrice": "Enter the price.",
  "nl.errGrade": "Enter the grade.",
  "mkt.listingError": "Couldn't create it. Check the details.",
  "mkt.listingLimit": "You reached your plan's live listing limit ({max}). Pause one or move to a plan with more.",
  "mkt.priceLimit": "Your plan allows listings up to {max}. To list higher, move to a higher plan.",
  "mkt.plan.title": "Your plan",
  "mkt.shop.title": "Customized shop",
  "mkt.shop.teaser": "Your own banner, logo, line and color, a long “About the shop” text, links to your social networks and up to {pins} cards pinned at the top of your page. Available on {plan}.",
  "mkt.shop.banner": "Banner",
  "mkt.shop.bannerUpload": "Upload banner",
  "mkt.shop.bannerChange": "Change banner",
  "mkt.shop.bannerRemove": "Remove",
  "mkt.shop.bannerHint": "Cropped to 1600 × 400 (JPG, PNG or WebP).",
  "mkt.shop.bannerLink": "The banner leads to",
  "mkt.shop.bannerLinkNone": "Nowhere (just the image)",
  "mkt.shop.bannerLinkSection": "Your section “{name}”",
  "mkt.shop.bannerLinkListing": "One of your listings…",
  "mkt.shop.bannerLinkTo": "Leads to: {name}.",
  "mkt.shop.bannerLinkHidden": "It isn't on sale now: the banner leads nowhere until it's back.",
  "mkt.shop.bannerLinkChange": "Change",
  "mkt.shop.bannerLinkPick": "Pick for the banner: {name}",
  "mkt.shop.bannerLinkPickShort": "Pick",
  "mkt.shop.bannerLinkHint": "Saved with “Save shop”. If the section ends up empty or the listing stops being on sale, the banner stays, without a link.",
  "mkt.shop.bannerGo": "See {name}",
  "mkt.shop.bannerLinkError": "Check where the banner leads: that section or listing is gone.",
  "mkt.shop.about": "About the shop",
  "mkt.shop.aboutHint": "Plain text, up to {max} characters. Shown on your public page.",
  "mkt.shop.aboutTitle": "About the shop",
  "mkt.shop.links": "Your social networks",
  "mkt.shop.linkN": "Link {n}",
  "mkt.shop.linksHint": "Instagram, TikTok, YouTube, Facebook, X, Twitch, Kick or Threads. WhatsApp and payment links aren't accepted.",
  "mkt.shop.linksError": "Check the links: only Instagram, TikTok, YouTube, Facebook, X, Twitch, Kick or Threads profiles.",
  "mkt.shop.save": "Save shop",
  "mkt.shop.saved": "Saved.",
  "mkt.shop.logo": "Logo",
  "mkt.shop.logoUpload": "Upload logo",
  "mkt.shop.logoChange": "Change logo",
  "mkt.shop.logoHint": "Square, cropped to 512 × 512. It replaces your photo on the shop's page.",
  "mkt.shop.tagline": "Line under the name",
  "mkt.shop.taglinePlaceholder": "Scarlet & Violet sealed and singles",
  "mkt.shop.taglineHint": "One line, up to {max} characters.",
  "mkt.shop.accent": "Your shop's color",
  "mkt.shop.accentNone": "No color",
  "mkt.shop.accentHint": "Used on the “Follow” button and your page's headings. Only in your shop.",
  "mkt.shop.accent.rojo": "Red",
  "mkt.shop.accent.naranja": "Orange",
  "mkt.shop.accent.dorado": "Gold",
  "mkt.shop.accent.verde": "Green",
  "mkt.shop.accent.turquesa": "Teal",
  "mkt.shop.accent.celeste": "Cyan",
  "mkt.shop.accent.azul": "Blue",
  "mkt.shop.accent.indigo": "Indigo",
  "mkt.shop.accent.violeta": "Violet",
  "mkt.shop.accent.rosa": "Pink",
  "mkt.shop.accent.marron": "Brown",
  "mkt.shop.accent.grafito": "Graphite",
  "mkt.shop.pinsVacation": "You're on vacation until {date}: your shop shows nothing until then. Your pinned listings are fine and come back on their own.",
  "mkt.shop.announcementLabel": "Shop announcement",
  "mkt.shop.announcementSet": "on {set} cards",
  "mkt.shop.announcementProducts": "on selected cards",
  "mkt.shop.announcementCopy": "Copy code",
  "mkt.shop.announcementUntil": "Until {date}",
  "mkt.shop.announcement": "Announcement over your shop",
  "mkt.shop.announcementText": "Announcement text",
  "mkt.shop.announcementPlaceholder": "10% off all weekend · Delta Reign is here",
  "mkt.shop.announcementHint": "One line, up to {max} characters. Empty: no announcement.",
  "mkt.shop.announcementCoupon": "Coupon (optional)",
  "mkt.shop.announcementNoCoupon": "No coupon",
  "mkt.shop.announcementNoCoupons": "To announce a coupon, create one for the whole shop, some cards or a set in Customers › Coupons.",
  "mkt.shop.announcementLast": "Last day (optional)",
  "mkt.shop.announcementCouponOff": "With this coupon the announcement doesn't show now (paused, expired, used up or not started yet).",
  "mkt.shop.announcementRule": "It hides on its own after the last day or when the coupon stops working (paused, expired or used up).",
  "mkt.shop.announcementError": "Check the announcement: 3 to 120 characters, a public coupon of yours and a date from today on.",
  "mkt.shop.sectionMore": "See all {count}",
  "mkt.shop.search": "Search {name}",
  "mkt.shop.allCards": "All their cards",
  "mkt.shop.closeFilters": "Close filters",
  "sec.title": "Your shop's sections",
  "sec.hint": "Up to {max}. They go under the pinned ones. Choose what each shows; a section with no cards now isn't shown.",
  "sec.n": "Section {n}",
  "sec.up": "Move section {n} up",
  "sec.down": "Move section {n} down",
  "sec.remove": "Remove section {n}",
  "sec.type": "What it shows",
  "sec.type.sealed": "Sealed",
  "sec.type.newest": "New arrivals",
  "sec.type.under": "Up to a price",
  "sec.type.graded": "Graded",
  "sec.type.set": "One set",
  "sec.type.coupon": "On a coupon",
  "sec.type.manual": "Picked by hand",
  "sec.title.under": "Up to {price}",
  "sec.what.sealed": "Your packs, boxes and other sealed products.",
  "sec.what.newest": "What you listed in the last {days} days, newest first.",
  "sec.what.under": "Your listings up to that price, priciest first.",
  "sec.what.graded": "Your graded cards (PSA, Beckett, CGC, SGC…).",
  "sec.what.set": "Your cards from that set.",
  "sec.what.coupon": "The cards a live coupon of yours for some cards or a set covers.",
  "sec.what.manual": "Up to {max} listings you pick, in that order.",
  "sec.name": "Title",
  "sec.maxPrice": "Highest price ($)",
  "sec.set": "Set",
  "sec.add": "Add {name} to the section",
  "sec.addShort": "Add",
  "sec.notLive": "{name} (paused or sold out: not shown now)",
  "sec.count": "{count} listings now.",
  "sec.count_one": "1 listing now.",
  "sec.empty": "None now: this section won't show until it has cards.",
  "sec.addSection": "Add a section",
  "sec.error": "Check the sections: a 2-40 letter title, a price, a set or at least one picked listing.",
  "rsv.button": "Reserve for a client",
  "rsv.title": "Reserve for a client",
  "rsv.what": "You set “{name}” aside at a price for one person: you get a link to send by Instagram or WhatsApp, and the card leaves the market for {hours} hours. Whoever opens the link first pays with the usual protected purchase.",
  "rsv.quantity": "Quantity",
  "rsv.price": "Price per unit ($)",
  "rsv.priceHint": "Up to the listed price ({price}).",
  "rsv.note": "Note for the buyer (optional)",
  "rsv.notePlaceholder": "The one we talked about on Instagram 🙌",
  "rsv.create": "Reserve and create the link",
  "rsv.cancelForm": "Cancel",
  "rsv.done": "Done: the card is set aside for {hours} hours. Send this link to your client:",
  "rsv.doneHint": "If nobody pays in time, it goes back to your stock on its own. You can cancel it from Listings.",
  "rsv.close": "Done",
  "rsv.copy": "Copy link",
  "rsv.waText": "I reserved the card for you on pokefans.fun, pay for it here: {url}",
  "rsv.errPrice": "A reservation goes at the listed price ({price}) or less.",
  "rsv.errStock": "Only {count} left to reserve.",
  "rsv.errLimit": "Your plan allows {max} active reservations at a time. Cancel one or wait for one to end.",
  "rsv.listTitle": "Reservations for clients",
  "rsv.st.open": "Waiting for someone to take it · ends {date}",
  "rsv.st.claimed": "{name} took it, payment pending · ends {date}",
  "rsv.st.used": "{name} bought it (order {order})",
  "rsv.st.expired": "Expired: back in your stock",
  "rsv.st.cancelled": "Cancelled: back in your stock",
  "rsv.cancel": "Cancel reservation",
  "rsv.confirmCancel": "Cancel the reservation? The card goes back to your stock and the link stops working.",
  "rsv.viewOrder": "View order",
  "rsv.stockHint": "Plus {count} set aside for a client: don't add them here, they come back on their own if unpaid.",
  "rsv.stockHint_one": "Plus 1 set aside for a client: don't add it here, it comes back on its own if unpaid.",
  "rsv.rowPill": "{count} reserved",
  "rsv.rowPill_one": "1 reserved",
  "rsv.pillSeller": "Your reservation",
  "rsv.pillBuyer": "Reserved for you",
  "rsv.pageTitle": "A card reserved for you",
  "rsv.pageWhat": "{seller} set this card aside for you. The reservation ends {date}.",
  "rsv.pagePrice": "{count} × {price}",
  "rsv.pageListed": "(listed at {price})",
  "rsv.buy": "Buy it",
  "rsv.signInToBuy": "Sign in to buy it",
  "rsv.pageHint": "You pay with the market's protected purchase, like any other.",
  "rsv.unavailable": "This reservation isn't available: someone else took it, it expired or it was cancelled.",
  "rsv.toMarket": "Go to the market",
  "mkt.shop.pins": "Pinned in your shop",
  "mkt.shop.pinsHint": "Pin up to {max} listings at the top of your page, in this order. Included in your plan: it doesn't use your monthly “Feature for 7 days” or change the market's order.",
  "mkt.shop.pinsTitle": "Pinned",
  "mkt.shop.pinUp": "Move {name} up",
  "mkt.shop.pinDown": "Move {name} down",
  "mkt.shop.pinRemove": "Remove {name}",
  "mkt.shop.pinsHidden": "{count} pinned listings aren't shown now (paused or sold out): they come back when they're live.",
  "mkt.shop.pinsHidden_one": "1 pinned listing isn't shown now (paused or sold out): it comes back when it's live.",
  "mkt.shop.pinsDropHidden": "Unpin them",
  "mkt.shop.pinSearch": "Search your listings",
  "mkt.shop.pinAdd": "Pin on top: {name}",
  "mkt.shop.pinAddShort": "Pin on top",
  "mkt.shop.pinNone": "No more live listings for that search.",
  "mkt.shop.pinsFull": "You have {max} pinned. Unpin one to add another.",
  "mkt.shop.preview": "Preview",
  "mkt.shop.previewWidth": "Preview width",
  "mkt.shop.previewPhone": "Phone",
  "mkt.shop.previewDesktop": "Computer",
  "mkt.shop.previewClose": "Close",
  "mkt.shop.previewNote": "This is how a buyer sees it, with your unsaved changes. Save to publish them.",
  "mkt.shop.previewOff": "Preview",
  "mkt.shop.viewAsBuyer": "View as a buyer",
  "mkt.plan.current": "{plan} plan.",
  "mkt.plan.noLimit": "No limit",
  "mkt.plan.listingsNoLimit": "Live listings: {live} (no limit).",
  "mkt.plan.rowListings": "Live listings",
  "mkt.plan.rowPrice": "Highest price per listing",
  "mkt.plan.rowBadge": "Badge on your shop",
  "mkt.plan.rowSupport": "Priority support on WhatsApp and verification with priority (answer within the business day; verification is free on every plan)",
  "mkt.verify.title": "Verification",
  "mkt.verify.done": "Your shop is verified: buyers see 🪪 Verified.",
  "mkt.verify.what": "With verification buyers see 🪪 Verified on your shop, and the new-seller limits go away. It's free.",
  "mkt.verify.ask": "Ask for verification",
  "mkt.verify.requested": "You asked for verification on {date}: we'll review it and let you know.",
  "mkt.verify.requestedPriority": "You asked for verification on {date}. You have priority: we'll answer within the business day.",
  "mkt.verify.priority": "Your plan has priority: we'll answer within the business day.",
  "mkt.support.title": "Priority support",
  "mkt.support.text": "Write to us on WhatsApp and we'll get to you first.",
  "mkt.support.button": "Write on WhatsApp",
  "mkt.support.message": "Hi, I'm @{handle} ({plan} plan) from the pokefans.fun market.",
  "mkt.plan.rowDemand": "Instant alert when someone looks for your cards, a daily Se busca summary and a demand board",
  "mkt.demand.title": "What people look for",
  "mkt.demand.teaser": "We tell you at once when someone looks for a card you sell, and you see which cards people want. Available on {plan}.",
  "mkt.demand.intro": "Cards people added to “Busco” in the last 30 days. We never show who, nor their price.",
  "mkt.demand.empty": "Nobody added cards to “Busco” in the last 30 days.",
  "mkt.demand.wanting": "{count} people want it",
  "mkt.demand.wanting_one": "1 person wants it",
  "mkt.demand.market": "{count} listings from {price}",
  "mkt.demand.market_one": "1 listing at {price}",
  "mkt.demand.nobody": "nobody sells it",
  "mkt.demand.mine": "you have it listed",
  "mkt.plan.rowFeatured": "Featured listings per month (7 days each)",
  "mkt.feature.label": "Featured",
  "mkt.feature.stripTitle": "Featured",
  "mkt.feature.button": "Feature for 7 days ({count} left)",
  "mkt.feature.until": "Featured until {date}",
  "mkt.feature.done": "Done! It's featured for 7 days.",
  "mkt.feature.newSeller": "You can feature listings once you're no longer a new seller (30 days and 5 sales) or we verify you.",
  "mkt.feature.noneLeft": "You've used this month's featured listings.",
  "mkt.plan.rowUsd": "Prices in dollars",
  "mkt.plan.rowCustomShop": "Customized shop (banner, text and social links)",
  "mkt.plan.founder": "Free as a founder: 6 months from when we launch paid plans.",
  "mkt.plan.until": "Until {date}.",
  "mkt.plan.listings": "Live listings: {live} of {max}.",
  "mkt.plan.over": "You have {live} live listings and your plan allows {max}: none are taken down, but you can't put new ones live until you're under {max}.",
  "mkt.plan.ask": "I want {plan}",
  "mkt.plan.renew": "I want to keep {plan}",
  "mkt.plan.requested": "You asked for the {plan} plan: we'll write to you with the price and how to pay.",
  "bulk.open": "Edit prices",
  "bulk.title": "Edit the prices of several listings",
  "bulk.search": "Search",
  "bulk.searchHint": "Name, set or number",
  "bulk.status": "Show",
  "bulk.statusAll": "All",
  "bulk.statusActive": "Live",
  "bulk.statusPaused": "Paused",
  "lf.title": "Filter listings",
  "lf.search": "Search my listings",
  "lf.sort": "Sort",
  "lf.sort.recent": "Newest",
  "lf.sort.price_asc": "Price: low to high",
  "lf.sort.price_desc": "Price: high to low",
  "lf.sort.name": "Name",
  "lf.more": "More filters",
  "lf.less": "Fewer filters",
  "lf.set": "Set",
  "lf.allSets": "All sets",
  "lf.kind": "Type",
  "lf.kind.all": "All",
  "lf.kind.singles": "Single cards",
  "lf.kind.graded": "Graded",
  "lf.kind.sealed": "Sealed",
  "lf.show.all": "All",
  "lf.show.live": "For sale",
  "lf.show.soldout": "Sold out",
  "lf.show.paused": "Paused",
  "lf.show.reserved": "With a reservation",
  "lf.min": "Price from",
  "lf.max": "Price up to",
  "lf.count": "{shown} of {total}",
  "lf.clear": "Clear filters",
  "lf.none": "No listing matches the filters.",
  "bulk.op": "Change",
  "bulk.op.pct_down": "Lower by %",
  "bulk.op.pct_up": "Raise by %",
  "bulk.op.sub": "Subtract pesos",
  "bulk.op.add": "Add pesos",
  "bulk.op.set": "Set a price",
  "usd.toggle": "Price in dollars (the pesos follow the dólar blue every day)",
  "usd.price": "Price (US$)",
  "usd.today": "Today that's {ars}. It updates itself every night with the dólar blue.",
  "usd.hint": "Type the price in dollars, for example 12.50.",
  "usd.noRate": "We don't have today's dólar right now; try later.",
  "usd.planEnded": "Your plan no longer has dollar prices: it stays fixed in pesos. Save a peso price or go back to a plan that has them.",
  "usd.offHint": "Saving a peso price stops following the dollar.",
  "usd.heldCap": "It didn't follow the dollar today: it stayed at your plan's top price.",
  "bulk.op.dollar": "Follow the dollar",
  "bulk.usdListing": "Priced in dollars: it already follows the dollar. Change it from the listing.",
  "bulk.dollarToday": "Today's dólar blue: {rate} (updated {date}).",
  "bulk.dollarTodayNoDate": "Today's dólar blue: {rate}.",
  "bulk.dollarNothing": "The dólar hasn't moved since you set these prices: nothing to adjust.",
  "bulk.dollarNoRate": "We don't have today's dólar right now; try later.",
  "bulk.dollarLoading": "Getting today's dólar…",
  "bulk.dollarHow": "Each price goes up or down as much as the dólar did since you set it. Nothing changes until you save.",
  "bulk.dollarThen": "dólar when set {rate}",
  "bulk.dollarUnknown": "We don't know the dólar from when you set it: left as is.",
  "bulk.overCap": "It would go over your plan's top price ({max}): left as is.",
  "bulk.openDollar": "Follow the dollar",
  "bulk.valuePct": "Percent",
  "bulk.valueArs": "Pesos",
  "bulk.round": "Round",
  "bulk.roundNone": "Don't round",
  "bulk.roundTo": "To {amount}",
  "bulk.none": "No listings match that filter.",
  "bulk.selectAll": "Select all shown",
  "bulk.select": "Select {name}",
  "bulk.price": "Price",
  "bulk.paused": "paused",
  "bulk.invalid": "That change can't apply to this price: left as is.",
  "bulk.selected": "{count} selected",
  "bulk.selected_one": "1 selected",
  "bulk.save": "Save {count} prices",
  "bulk.save_one": "Save 1 price",
  "bulk.close": "Close",
  "bulk.updated": "{count} prices updated",
  "bulk.updated_one": "1 price updated",
  "bulk.skippedPrice": "{count} left as they were (above your plan's highest price)",
  "bulk.skippedGone": "{count} no longer exist",
  "bulk.skippedGone_one": "1 no longer exists",
  "imp.open": "Load many with a spreadsheet",
  "imp.title": "Load from a spreadsheet",
  "imp.intro": "Copy the rows from Excel or Google Sheets (with the header row) and paste them here, or upload a CSV. Up to {max} rows at a time.",
  "imp.help1": "Columns: Card, Set, Number, Condition, Language, Finish, Grade, Price, Quantity and Notes. Card (or Set and Number) and Price are enough.",
  "imp.helpGame": "Selling more than one game? Add a Game column ({games}); without it we look the card up in all of them.",
  "imp.help2": "Condition: NM, LP, MP, HP, DMG or Sealed; sealed products don't need it. Blank language = Spanish.",
  "imp.help3": "They go live right away with the catalog image; add your own photos later if you like.",
  "imp.template": "Download the template",
  "imp.file": "Upload a CSV file",
  "imp.paste": "Paste your rows here",
  "imp.placeholder": "Card\tSet\tNumber\tCondition\tPrice\nPikachu\tMEW\t025\tNM\t2500",
  "imp.read": "Review",
  "imp.reading": "Searching the catalog…",
  "imp.sheet.empty": "We found no rows to load.",
  "imp.sheet.no_header": "The header row is missing: we need at least the Card (or Set and Number) and Price columns.",
  "imp.sheet.too_many": "That's more than {max} rows: split it in parts.",
  "imp.counts": "{ok} ready · {pick} to choose · {bad} with problems",
  "imp.include": "Include",
  "imp.line": "Row",
  "imp.product": "Product",
  "imp.details": "Details",
  "imp.includeLine": "Include row {line}",
  "imp.whichOne": "Which one?",
  "imp.whichOneLine": "Product of row {line}",
  "imp.choose": "Choose…",
  "imp.err.card": "The card (or the set and number) is missing.",
  "imp.err.game": "We don't know that game, or it isn't open on pokefans yet.",
  "imp.err.condition": "We couldn't read the condition (NM, LP, MP, HP, DMG or Sealed).",
  "imp.err.language": "We couldn't read the language.",
  "imp.err.finish": "We couldn't read the finish (normal, holo, reverse or 1st edition).",
  "imp.err.finish_game": "This game's cards don't come in that finish: leave it blank or put normal.",
  "imp.err.grade": "We couldn't read the grade (for example: PSA 10).",
  "imp.err.price": "The price goes in whole pesos (for example: 1500).",
  "imp.err.quantity": "The quantity goes from 1 to 999.",
  "imp.err.condition_missing": "The card's condition is missing.",
  "imp.err.single_sealed": "It's a single card: give its condition (NM, LP…), not \"sealed\".",
  "imp.err.sealed_graded": "A sealed product isn't graded.",
  "imp.err.not_found": "Not found in the catalog: check the set and number.",
  "imp.duplicate": "You already list it like this: left unchecked.",
  "imp.repeated": "Repeated above in the sheet: left unchecked.",
  "imp.commit": "Load {count} listings",
  "imp.commit_one": "Load 1 listing",
  "imp.back": "Back to the sheet",
  "imp.rowFailed": "We couldn't load row {line}: check it and try again. Nothing was loaded.",
  "imp.doneTitle": "Done: you loaded {count} listings",
  "imp.doneTitle_one": "Done: you loaded 1 listing",
  "imp.donePublished": "{count} are already for sale.",
  "imp.donePublished_one": "1 is already for sale.",
  "imp.doneOverLimit": "{count} stayed paused: you reached the maximum of {max} live listings.",
  "imp.doneOverPrice": "{count} stayed paused: they're above your plan's highest price.",
  "imp.doneOverLimit_one": "1 stayed paused: you reached the maximum of {max} live listings.",
  "imp.done": "See my listings",
  "mkt.pendingPrepare": "Meanwhile you can already load your listings, one by one or with a spreadsheet. They're saved, and the ready ones go live on their own when you're approved.",
  "mkt.publishOnApproval": "Goes live when you're approved",
  "mkt.pendingLimit": "While we review your request you can prepare up to {max} listings (deleted ones count too).",
  "imp.help3Pending": "Nothing goes live until you're approved; then they go live on their own, with the catalog image.",
  "imp.doneAwaiting": "{count} are ready: they go live on their own when you're approved.",
  "imp.doneAwaiting_one": "1 is ready: it goes live on its own when you're approved.",
  "mkt.openOffers": "{count} offers",
  "mkt.openOffers_one": "1 offer",
  "mkt.makeCover": "First",
  "mkt.deletePhoto": "Delete",
  "mkt.addPhoto": "Photo",
  "mkt.photosHint": "Optional: your own photos of the real card, in good light, to show its condition. They come after the catalog image, which always goes first.",
  "mkt.pause": "Pause",
  "mkt.publish": "Publish",
  "mkt.published": "Published!",
  "mkt.view": "View",
  "mkt.delete": "Delete",
  "mkt.confirmDelete": "Delete this listing?",
  "mkt.noSales": "No sales yet.",
  "mkt.unread": "new message",
  "mkt.noOffersReceived": "No offers received.",
  "mkt.noOffersMade": "You haven't made offers.",
  "mkt.offerLine": "{qty} × {price} (listed at {list})",
  "mkt.counterLine": "counter-offer {price}",
  "mkt.until": "expires {date}",
  "mkt.accept": "Accept",
  "mkt.reject": "Reject",
  "mkt.counter": "Counter",
  "mkt.counterAmount": "Your price",
  "mkt.acceptCounter": "Accept counter-offer",
  "mkt.buyAtOffer": "Buy at this price",
  "mkt.withdraw": "Withdraw",
  "mkt.set.profile": "Your shop",
  "mkt.vacation": "On vacation until",
  "mkt.vacationHint": "Your shop stays visible but nobody can buy meanwhile.",
  "mkt.set.payments": "How you get paid",
  "mkt.set.paymentsIntro": "The money goes straight to you. Set up one or more methods.",
  "mkt.mpSoon": "You'll be able to connect your account very soon.",
  "mkt.mpConnectedShort": "Account connected",
  "mkt.mpNotConnected": "Not connected (the seller connects it from their shop).",
  "mkt.mpDisconnect": "Disconnect",
  "mkt.mpIntro": "Connect your account: buyers pay on Mercado Pago and the money goes into your account. Mercado Pago takes its usual fee; we take nothing.",
  "mkt.mpConnect": "Connect Mercado Pago",
  "mkt.set.transfer": "Bank transfer",
  "mkt.set.crypto": "Crypto (USDT)",
  "mkt.network": "Network",
  "mkt.walletAddress": "Your wallet address",
  "mkt.walletInvalid": "That address isn't valid for this network. Copy the whole address from your wallet.",
  "mkt.set.delivery": "How you deliver",
  "mkt.set.hand": "I hand them over",
  "mkt.set.handZones": "Areas",
  "mkt.set.handAreas": "Places or neighbourhoods",
  "mkt.set.handAreasHint": "E.g. subway line D stations, Palermo",
  "mkt.set.cost": "Cost ($)",
  "mkt.set.ship": "I ship",
  "mkt.set.carriers": "Carrier",
  "mkt.set.pickup": "Pickup point",
  "mkt.set.pickupAddress": "Address",
  "mkt.set.pickupHours": "Hours",
  "mkt.set.pickupHint": "Buyers see the address only after paying. Use a public place (a shop, a friendly store).",
  "mkt.set.arrange": "Wherever we agree (on the days and hours below)",
  "mkt.set.sales": "Sales",
  "mkt.set.acceptsOffers": "I take offers",
  "mkt.settingsError": "Couldn't save. Check the details.",
  "mkt.saveSettings": "Save settings",
  "mkt.noPurchases": "You haven't bought in the market yet.",
  "mkt.goToMarket": "Go to the market",
  "mkt.noFavorites": "Save listings with ♡ and we'll tell you if the price drops.",
  "mkt.wantsIntro": "Add the cards you're after: we email you when someone lists one (at your max price, if you set one).",
  "mkt.wantsPrivacy": "Your list is private. What you mark \"Visible on Wanted\" shows on the public board with your alias, never your email. Shops see how many people want cards they have listed (VMAX ones, how many want each card), never who.",
  "mkt.wantMax": "Max price ($, optional)",
  "mkt.wantAdd": "Add a card I'm looking for",
  "mkt.noWants": "Your wanted list is empty.",
  "mkt.upTo": "up to {price}",
  "mkt.wantFound": "{count} for sale from {price}",
  "mkt.wantFound_one": "1 for sale: {price}",
  "mkt.wantWaiting": "We'll let you know",
  "mkt.noFollowing": "You don't follow any seller.",
  "sell.metaTitle": "Sell your Pokémon cards with no fees",
  "sell.kicker": "For sellers",
  "sell.title": "Sell your cards on pokefans.fun, no fees",
  "sell.lead": "List your single cards and sealed products, buyers pay you directly and you arrange delivery together. We provide the shop window: your offers show on each product's page and in the store search.",
  "sell.cta": "I want to sell",
  "sell.haveAccount": "I already have an account",
  "sell.foundersTitle": "Founding Sellers program",
  "plans.nav": "Plans for sellers",
  "plans.navHint": "Free, EX and VMAX: what each includes.",
  "plans.title": "Plans for sellers",
  "plans.intro": "Selling on pokefans.fun is free and has no fees. Plans add tools to sell more: more listings, featured listings, coupons, stats and more.",
  "plans.free": "Free",
  "plans.perMonth": "{price} a month",
  "plans.priceSoon": "Price to be announced",
  "plans.tagline.basic": "To start: list and sell without paying anything.",
  "plans.tagline.ex": "For regular sellers who want to see what works.",
  "plans.tagline.vmax": "Everything, no limits: for shops and big sellers.",
  "plans.hlListings": "Up to {count} live listings",
  "plans.hlListingsNoLimit": "Unlimited listings",
  "plans.hlPrice": "Up to {price} per card",
  "plans.hlPriceNoLimit": "No price cap",
  "plans.hlNoFees": "No fees: the buyer pays you directly",
  "plans.hlVerified": "Free verification",
  "plans.hlFeatured": "{count} featured listings a month",
  "plans.hlInsights": "Stats per listing and price against the market",
  "plans.hlCoupon": "1 discount coupon for your shop",
  "plans.hlCoupons": "{count} coupons (per card, set, group or customer)",
  "plans.hlCustomers": "Your customers: groups and what else they buy",
  "plans.hlEmails": "{count} emails a month to your customers",
  "plans.hlDemand": "Instant alert when someone looks for your cards",
  "plans.hlUsd": "Prices in dollars that follow the dólar blue by themselves",
  "plans.hlReservations": "Reserve cards for a client with a payment link ({count} at a time)",
  "plans.hlCustomShop": "Customized shop (banner, logo, color, announcement, sections, social links and pinned cards on top)",
  "plans.hlApi": "API to connect your sheet or your system",
  "plans.hlSupport": "Priority support on WhatsApp",
  "plans.openShop": "Open your shop for free",
  "plans.openShopFirst": "Open your shop first (free)",
  "plans.signIn": "Sign in to subscribe",
  "plans.underReview": "Your shop is under review: once approved you can pick a plan.",
  "plans.founderFree": "You have it free as a founding seller.",
  "plans.founderHasVmax": "You already have VMAX free as a founder.",
  "plans.yours": "Your plan",
  "plans.manage": "Manage it in My shop",
  "plans.subscribe": "Subscribe",
  "plans.switchTo": "Switch to {plan}",
  "plans.switchNote": "Once the new plan is confirmed, we stop charging {plan}. What you already paid isn't prorated.",
  "plans.payerEmail": "Your Mercado Pago account email",
  "plans.payerEmailHint": "You pay with that account every month. Cancel any time from My shop.",
  "plans.goToMp": "Go to Mercado Pago",
  "plans.err.founder_free": "You already have this plan free as a founder.",
  "plans.err.already_subscribed": "You're already subscribed to this plan.",
  "plans.err.subscriptions_off": "Subscriptions aren't open yet: write to us and we'll set it up.",
  "plans.err.validation_error": "Check the Mercado Pago email.",
  "plans.err.generic": "We couldn't reach Mercado Pago. Try again in a while.",
  "plans.compare": "What each plan includes",
  "plans.faq": "Questions",
  "plans.q1": "How do I pay?",
  "plans.a1": "With Mercado Pago, every month, with the card or balance you choose there. The plan turns on when Mercado Pago confirms the first payment.",
  "plans.q2": "Can I cancel?",
  "plans.a2": "Yes, any time, from My shop › Settings. We stop charging and the plan lasts until the month you paid ends.",
  "plans.q3": "What if I switch plans?",
  "plans.a3": "Subscribe to the new one and, once it's confirmed, we stop charging the old one. What you paid isn't prorated.",
  "plans.q4": "Does pokefans take a fee per sale?",
  "plans.a4": "No, on no plan. The buyer pays you directly.",
  "plans.see": "See plans",
  "plans.fromSell": "Selling is free. For more listings and tools, see the EX and VMAX plans.",
  "plans.cancel": "Cancel subscription",
  "plans.cancelConfirm": "Cancel the subscription? We stop charging and your plan lasts until {date}.",
  "plans.cancelError": "Mercado Pago didn't confirm the cancellation. Try again in a while.",
  "plans.confirming": "Confirming your payment with Mercado Pago… It may take a minute.",
  "plans.subActive": "{plan} subscription with Mercado Pago: {price} a month.",
  "plans.nextCharge": "Next charge: {date}.",
  "plans.subPending": "You still have to finish the {plan} subscription in Mercado Pago.",
  "plans.finish": "Finish in Mercado Pago",
  "plans.subPaused": "Mercado Pago couldn't charge your {plan} plan: check your payment method in Mercado Pago.",
  "plans.subEnded": "You cancelled the subscription: your {plan} plan lasts until {date}.",
  "sell.foundersText": "The first approved sellers keep the Founding seller badge for good and get the VMAX plan, the most complete one (more visibility, tools and stats), free for 3 months from their approval.",
  "sell.foundersLeft": "{count} places left.",
  "sell.foundersLeft_one": "1 place left.",
  "sell.benefitsTitle": "Why sell here",
  "sell.b1Title": "0% fees",
  "sell.b1Text": "Listing and selling are free. What you earn is yours.",
  "sell.b2Title": "Paid directly",
  "sell.b2Text": "By bank transfer to your account, in crypto or cash on delivery. The money never goes through us.",
  "sell.b2TextMp": "With Mercado Pago (the money goes straight into your account), by bank transfer, in crypto or cash on delivery. The money never goes through us.",
  "sell.b3Title": "Buyers find you",
  "sell.b3Text": "Every offer shows on the product's page, under ours, and in the store search: the same window our customers use.",
  "sell.b4Title": "Your own shop",
  "sell.b4Text": "A page with your listings, your sales and your buyers' reviews.",
  "sell.b5Title": "Cards and sealed",
  "sell.b5Text": "Singles, packs, ETBs, boxes and collections. List with the catalog image and add your own photos whenever you like.",
  "sell.b6Title": "Your rules",
  "sell.b6Text": "Choose how to deliver (in person, by post or at a pickup point), your days and hours, and whether you take offers.",
  "sell.stepsTitle": "How to start",
  "sell.s1Title": "Sign up",
  "sell.s1Text": "Create your account and fill in the request: contact, city, date of birth (you must be 18+), a social network link and a verification photo. We review it by hand.",
  "sell.s2Title": "List",
  "sell.s2Text": "Find the card or product in our catalog, choose condition, language and price, and upload your photos. We show you the store's reference price.",
  "sell.s3Title": "Sell and get paid",
  "sell.s3Text": "We email you every sale. Arrange delivery in the order's chat and the buyer pays you directly.",
  "sell.faqTitle": "FAQ",
  "sell.q1": "What are the fees?",
  "sell.a1": "None. Listing and selling are free. Later we'll add optional plans with more visibility and tools; selling will stay fee-free.",
  "sell.a1Mp": "None. Listing and selling are free. If you get paid with Mercado Pago, MP takes its usual fee, as with any payment; we add nothing. Later we'll add optional plans with more visibility and tools; selling will stay fee-free.",
  "sell.q2": "How do I get paid?",
  "sell.a2": "Buyers pay you directly, with the methods you choose: bank transfer, crypto or cash on delivery. pokefans.fun never touches the money.",
  "sell.a2Mp": "Buyers pay you directly, with the methods you choose: Mercado Pago (connect your account and the money lands there), bank transfer, crypto or cash on delivery. pokefans.fun never touches the money.",
  "sell.q3": "Who ships?",
  "sell.a3": "You do. Deliver in person, ship by post or use a pickup point, at the cost you set.",
  "sell.q4": "What can I sell?",
  "sell.a4": "Original single cards and sealed products (packs, ETBs, boxes, decks and collections). No accessories, fakes or resealed products.",
  "sell.q5": "What do I need?",
  "sell.a5": "Be 18 or older, be in Argentina, have a pokefans.fun account and share a social network link that shows you sell or collect, plus a photo of your most valuable card next to a note with your @username and the date. We review every request by hand before approving it.",
  "sell.q6": "What if a sale goes wrong?",
  "sell.a6": "Every order has its chat and history. Buyers and sellers rate each other, and anyone can report a listing or a seller: we review it and can pause or close a shop.",
  "sell.termsNote": "Before signing up, read the",
  "sell.terms": "market terms",
  "sell.homeTitle": "Got cards to sell?",
  "sell.homeText": "List them on pokefans.fun with no fees: buyers pay you directly and your offers show in the store.",
  "sell.homeCta": "Start selling",
  "sell.nav": "Sell",
  "offers.title": "Offers from sellers",
  "offers.count": "{count} from {price}",
  "offers.none": "No seller has listed it yet.",
  "offers.sellYours": "Have one? Sell it here, no fees",
  "offers.filters": "Filter offers",
  "offers.minCondition": "Minimum condition",
  "offers.language": "Language",
  "offers.any": "Any",
  "offers.caba": "Delivery in CABA",
  "offers.cash": "Takes cash",
  "offers.clear": "Clear filters",
  "offers.noMatch": "No offers match those filters.",
  "offers.seller": "Seller",
  "offers.item": "Item",
  "offers.delivery": "Delivery and payment",
  "offers.price": "Price",
  "offers.action": "Buy",
  "offers.buy": "Buy",
  "offers.more": "More options",
  "offers.notesMore": "More",
  "offers.goneMine": "That listing is yours and isn't for sale right now (paused or sold out).",
  "offers.notesLess": "Less",
  "offers.yours": "Yours",
  "offers.gone": "The listing that link pointed to isn't for sale any more. These are the card's other offers.",
  "offers.seeAll": "See all {count} offers",
  "offers.shipQuote": "shipping quoted",
  "offers.free": "free",
  "offers.pickup": "pickup point",
  "offers.ownPhotos": "With the seller's photos",
  "offers.jump": "Available from {count} sellers from {price}",
  "offers.tag": "Sellers",
  "offers.or": "or",
  "offers.tile": "from {price} at {count} sellers",
  "offers.tile_one": "{price} at 1 seller",
  "offers.seeOffers": "See {count} offers",
  "offers.seeOffers_one": "See the offer",
  "mkt.wantThis": "I want it: tell me if someone lists it",
  "mkt.wantSaved": "We'll let you know when someone lists it.",
};
